import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { publish } from 'rxjs/operators';
import { Injectable, Component, Input, NgModule, Output, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { __awaiter } from 'tslib';
import { SubSink } from 'subsink';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatTooltipModule } from '@angular/material/tooltip';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/platform-browser';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@angular/material/form-field';
import * as ɵngcc6 from '@angular/material/input';
import * as ɵngcc7 from '@angular/forms';
import * as ɵngcc8 from '@angular/material/dialog';
import * as ɵngcc9 from '@angular/material/menu';
import * as ɵngcc10 from '@angular/material/progress-spinner';
import * as ɵngcc11 from '@angular/cdk/text-field';

function TimestampComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵpipe(1, "date");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind2(1, 2, ctx_r0.value, "short"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(3, 5, ctx_r0.value, "shortDate"), " ");
} }
function TimestampComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵpipe(1, "date");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind2(1, 2, ctx_r1.value, "short"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.relative, " ");
} }
function EmojiSelectorPanelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "a", 4);
    ɵngcc0.ɵɵlistener("click", function EmojiSelectorPanelComponent_div_0_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.hideSearch(); });
    ɵngcc0.ɵɵelementStart(2, "mat-icon");
    ɵngcc0.ɵɵtext(3, "arrow_back");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "mat-form-field", 5);
    ɵngcc0.ɵɵelementStart(5, "mat-label");
    ɵngcc0.ɵɵtext(6, "Search for emoji");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function EmojiSelectorPanelComponent_div_0_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.searchQuery = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.searchQuery);
} }
function EmojiSelectorPanelComponent_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_2_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const emoji_r7 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.select(emoji_r7.char); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const emoji_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("innerHtml", emoji_r7.html || "", ɵngcc0.ɵɵsanitizeHtml);
} }
function EmojiSelectorPanelComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtemplate(2, EmojiSelectorPanelComponent_ng_container_2_a_2_Template, 1, 1, "a", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.searchResults);
} }
function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const category_r13 = ctx.$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.activeCategory = category_r13.name; });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r13 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("active", ctx_r12.activeCategory === category_r13.name);
    ɵngcc0.ɵɵproperty("title", ctx_r12.humanize(category_r13.name));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(category_r13.icon);
} }
function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EmojiSelectorPanelComponent_ng_container_3_ng_container_2_a_1_Template, 3, 4, "a", 12);
    ɵngcc0.ɵɵelementStart(2, "a", 13);
    ɵngcc0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.showSearch(); });
    ɵngcc0.ɵɵelementStart(3, "mat-icon");
    ɵngcc0.ɵɵtext(4, "search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.categories);
} }
function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const emoji_r21 = ctx.$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(4); return ctx_r22.select(emoji_r21.char); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const emoji_r21 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("innerHtml", emoji_r21.html || "", ɵngcc0.ɵɵsanitizeHtml);
} }
function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_a_1_Template, 1, 1, "a", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", category_r18.emojis);
} }
function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_Template, 2, 1, "div", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const category_r18 = ctx.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.activeCategory && ctx_r11.activeCategory == category_r18.name);
} }
function EmojiSelectorPanelComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵtemplate(2, EmojiSelectorPanelComponent_ng_container_3_ng_container_2_Template, 5, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, EmojiSelectorPanelComponent_ng_container_3_ng_container_3_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.searchVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.categories);
} }
const _c0 = ["panel"];
const _c1 = ["button"];
function ChatMessageComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "mat-icon", 9);
    ɵngcc0.ɵɵtext(3, "star");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.message.upvotes, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("inline", true);
} }
function LiveChatMessageComponent_banta_chat_message_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-chat-message", 1);
    ɵngcc0.ɵɵlistener("upvoted", function LiveChatMessageComponent_banta_chat_message_0_Template_banta_chat_message_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.upvote(); })("reported", function LiveChatMessageComponent_banta_chat_message_0_Template_banta_chat_message_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.report(); })("selected", function LiveChatMessageComponent_banta_chat_message_0_Template_banta_chat_message_selected_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.select(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r0.message);
} }
const _c2 = ["messageContainer"];
function ChatViewComponent_banta_chat_message_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-chat-message", 3);
    ɵngcc0.ɵɵlistener("selected", function ChatViewComponent_banta_chat_message_3_Template_banta_chat_message_selected_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const message_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.selectMessage(message_r2); })("upvoted", function ChatViewComponent_banta_chat_message_3_Template_banta_chat_message_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const message_r2 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.upvoteMessage(message_r2); })("reported", function ChatViewComponent_banta_chat_message_3_Template_banta_chat_message_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const message_r2 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.reportMessage(message_r2); })("userSelected", function ChatViewComponent_banta_chat_message_3_Template_banta_chat_message_userSelected_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const message_r2 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.selectMessageUser(message_r2); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("highlight", ctx_r1.mentionsMe(message_r2))("flash", message_r2.id === ctx_r1.flashedMessageId);
    ɵngcc0.ɵɵproperty("message", message_r2);
    ɵngcc0.ɵɵattribute("data-id", message_r2.id);
} }
const _c3 = [[["", "data-before", ""]], [["", 3, "data-before", ""]]];
const _c4 = ["[data-before]", ":not([data-before])"];
const _c5 = ["chatView"];
function BantaChatComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 8);
    ɵngcc0.ɵɵlistener("click", function BantaChatComponent_ng_container_7_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.showSignIn(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.signInLabel);
} }
function BantaChatComponent_ng_container_8_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r5.newMessage.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.sendLabel);
} }
function BantaChatComponent_ng_container_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function BantaChatComponent_ng_container_8_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.sendPermissionError(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.permissionDeniedLabel);
} }
function BantaChatComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BantaChatComponent_ng_container_8_button_1_Template, 2, 2, "button", 9);
    ɵngcc0.ɵɵtemplate(2, BantaChatComponent_ng_container_8_button_2_Template, 2, 1, "button", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.canChat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.canChat);
} }
const _c6 = ["firehose"];
function BantaComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 20);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 21);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_ng_container_2_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.signOut(); });
    ɵngcc0.ɵɵtext(4, "Sign Out");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r1.currentUser.displayName, " (@", ctx_r1.currentUser.username, ")");
} }
function BantaComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 2);
    ɵngcc0.ɵɵtext(2, "Sign In");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BantaComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 12);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_ng_container_14_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.showNotifications(); });
    ɵngcc0.ɵɵelementStart(4, "mat-icon");
    ɵngcc0.ɵɵtext(5, "notification_important");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" @", ctx_r3.currentUser.username, " ");
} }
function BantaComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_button_15_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.showSignIn(); });
    ɵngcc0.ɵɵtext(1, " Sign In ");
    ɵngcc0.ɵɵelementEnd();
} }
function BantaComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 12);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_ng_container_22_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.showNotifications(); });
    ɵngcc0.ɵɵelementStart(4, "mat-icon");
    ɵngcc0.ɵɵtext(5, "notification_important");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" @", ctx_r5.currentUser.username, " ");
} }
function BantaComponent_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_button_23_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.showSignIn(); });
    ɵngcc0.ɵɵtext(1, " Sign In ");
    ɵngcc0.ɵɵelementEnd();
} }
function BantaComponent_ng_container_36_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "strong", 23);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "br");
    ɵngcc0.ɵɵelementStart(6, "strong");
    ɵngcc0.ɵɵtext(7, "Top Messages");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div");
    ɵngcc0.ɵɵelementStart(9, "em");
    ɵngcc0.ɵɵtext(10, "Not yet available");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "br");
    ɵngcc0.ɵɵelementStart(12, "strong");
    ɵngcc0.ɵɵtext(13, "Recent Messages");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div");
    ɵngcc0.ɵɵelementStart(15, "em");
    ɵngcc0.ɵɵtext(16, "Not yet available");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r24.profileUser.displayName, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" @", ctx_r24.profileUser.username, " ");
} }
function BantaComponent_ng_container_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BantaComponent_ng_container_36_ng_container_1_Template, 17, 2, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.profileUser);
} }
function BantaComponent_ng_container_37_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2, "Are you sure you want to report this message?");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "banta-live-message", 24);
    ɵngcc0.ɵɵelementStart(4, "div", 25);
    ɵngcc0.ɵɵelementStart(5, "button", 26);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_ng_container_37_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.sendReport(ctx_r25.reportedMessage); });
    ɵngcc0.ɵɵtext(6, "Yes, Report");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, " \u00A0 ");
    ɵngcc0.ɵɵelementStart(8, "button", 27);
    ɵngcc0.ɵɵlistener("click", function BantaComponent_ng_container_37_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.auxOpen = false; });
    ɵngcc0.ɵɵtext(9, "No, Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("message", ctx_r9.reportedMessage);
} }
function BantaComponent_ng_container_38_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "em");
    ɵngcc0.ɵɵtext(2, "You do not have any notifications yet");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function BantaComponent_ng_container_38_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "banta-live-message", 32);
    ɵngcc0.ɵɵlistener("upvoted", function BantaComponent_ng_container_38_div_3_ng_container_2_Template_banta_live_message_upvoted_2_listener() { ɵngcc0.ɵɵrestoreView(_r37); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ctx_r35.upvoteMessage(notif_r30.message); })("reported", function BantaComponent_ng_container_38_div_3_ng_container_2_Template_banta_live_message_reported_2_listener() { ɵngcc0.ɵɵrestoreView(_r37); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ctx_r38.reportMessage(notif_r30.message); })("selected", function BantaComponent_ng_container_38_div_3_ng_container_2_Template_banta_live_message_selected_2_listener() { ɵngcc0.ɵɵrestoreView(_r37); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.goToMessage(notif_r30.message); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" @", notif_r30.message == null ? null : notif_r30.message.user == null ? null : notif_r30.message.user.username, " upvoted your post ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("message", notif_r30.message);
} }
function BantaComponent_ng_container_38_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "a", 33);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", notif_r30.message, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", notif_r30.actionUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", notif_r30.actionLabel, " ");
} }
function BantaComponent_ng_container_38_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r46 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "banta-live-message", 32);
    ɵngcc0.ɵɵlistener("upvoted", function BantaComponent_ng_container_38_div_3_ng_container_4_Template_banta_live_message_upvoted_2_listener() { ɵngcc0.ɵɵrestoreView(_r46); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r44 = ɵngcc0.ɵɵnextContext(2); return ctx_r44.upvoteMessage(notif_r30.message); })("reported", function BantaComponent_ng_container_38_div_3_ng_container_4_Template_banta_live_message_reported_2_listener() { ɵngcc0.ɵɵrestoreView(_r46); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r47 = ɵngcc0.ɵɵnextContext(2); return ctx_r47.reportMessage(notif_r30.message); })("selected", function BantaComponent_ng_container_38_div_3_ng_container_4_Template_banta_live_message_selected_2_listener() { ɵngcc0.ɵɵrestoreView(_r46); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r49 = ɵngcc0.ɵɵnextContext(2); return ctx_r49.goToMessage(notif_r30.message); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" You were mentioned by @", notif_r30.message == null ? null : notif_r30.message.user == null ? null : notif_r30.message.user.username, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("message", notif_r30.message);
} }
function BantaComponent_ng_container_38_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r54 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "banta-live-message", 32);
    ɵngcc0.ɵɵlistener("upvoted", function BantaComponent_ng_container_38_div_3_ng_container_5_Template_banta_live_message_upvoted_2_listener() { ɵngcc0.ɵɵrestoreView(_r54); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r52 = ɵngcc0.ɵɵnextContext(2); return ctx_r52.upvoteMessage(notif_r30.replyMessage); })("reported", function BantaComponent_ng_container_38_div_3_ng_container_5_Template_banta_live_message_reported_2_listener() { ɵngcc0.ɵɵrestoreView(_r54); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r55 = ɵngcc0.ɵɵnextContext(2); return ctx_r55.reportMessage(notif_r30.replyMessage); })("selected", function BantaComponent_ng_container_38_div_3_ng_container_5_Template_banta_live_message_selected_2_listener() { ɵngcc0.ɵɵrestoreView(_r54); const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r57 = ɵngcc0.ɵɵnextContext(2); return ctx_r57.goToMessage(notif_r30.replyMessage); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notif_r30 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" @", notif_r30.replyMessage == null ? null : notif_r30.replyMessage.user == null ? null : notif_r30.replyMessage.user.username, " replied to your post ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("message", notif_r30.replyMessage);
} }
function BantaComponent_ng_container_38_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtemplate(2, BantaComponent_ng_container_38_div_3_ng_container_2_Template, 3, 2, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(3, BantaComponent_ng_container_38_div_3_ng_container_3_Template, 5, 3, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(4, BantaComponent_ng_container_38_div_3_ng_container_4_Template, 3, 2, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(5, BantaComponent_ng_container_38_div_3_ng_container_5_Template, 3, 2, "ng-container", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "banta-timestamp", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notif_r30 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", notif_r30.type === "upvote");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", notif_r30.type === "notice");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", notif_r30.type === "mention");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", notif_r30.type === "reply");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", notif_r30.sentAt);
} }
function BantaComponent_ng_container_38_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BantaComponent_ng_container_38_div_1_Template, 3, 0, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 28);
    ɵngcc0.ɵɵtemplate(3, BantaComponent_ng_container_38_div_3_Template, 7, 5, "div", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.notifications || ctx_r10.notifications.length === 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.notifications);
} }
function BantaComponent_ng_container_51_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 34);
    ɵngcc0.ɵɵelementStart(2, "div", 35);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 36);
    ɵngcc0.ɵɵelementStart(5, "mat-icon");
    ɵngcc0.ɵɵtext(6, "thumb_up");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11.pointOpen.upvotes, " ");
} }
function BantaComponent_div_52_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " Error: No subchat ");
    ɵngcc0.ɵɵelementEnd();
} }
function BantaComponent_banta_comment_view_53_banta_comment_1_Template(rf, ctx) { if (rf & 1) {
    const _r62 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-comment", 43);
    ɵngcc0.ɵɵlistener("upvoted", function BantaComponent_banta_comment_view_53_banta_comment_1_Template_banta_comment_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r62); const ctx_r61 = ɵngcc0.ɵɵnextContext(2); return ctx_r61.upvoteMessage(ctx_r61.pointOpen); })("userSelected", function BantaComponent_banta_comment_view_53_banta_comment_1_Template_banta_comment_userSelected_0_listener() { ɵngcc0.ɵɵrestoreView(_r62); const ctx_r63 = ɵngcc0.ɵɵnextContext(2); return ctx_r63.showProfile(ctx_r63.pointOpen.user); })("reported", function BantaComponent_banta_comment_view_53_banta_comment_1_Template_banta_comment_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r62); const ctx_r64 = ɵngcc0.ɵɵnextContext(2); return ctx_r64.reportMessage(ctx_r64.pointOpen); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("showReplyAction", false)("message", ctx_r60.pointOpen);
} }
function BantaComponent_banta_comment_view_53_Template(rf, ctx) { if (rf & 1) {
    const _r66 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-comment-view", 37);
    ɵngcc0.ɵɵlistener("upvoted", function BantaComponent_banta_comment_view_53_Template_banta_comment_view_upvoted_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r65 = ɵngcc0.ɵɵnextContext(); return ctx_r65.upvoteMessage($event); })("reported", function BantaComponent_banta_comment_view_53_Template_banta_comment_view_reported_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r67 = ɵngcc0.ɵɵnextContext(); return ctx_r67.reportMessage($event); })("userSelected", function BantaComponent_banta_comment_view_53_Template_banta_comment_view_userSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r68 = ɵngcc0.ɵɵnextContext(); return ctx_r68.showProfile($event.user); });
    ɵngcc0.ɵɵtemplate(1, BantaComponent_banta_comment_view_53_banta_comment_1_Template, 1, 2, "banta-comment", 38);
    ɵngcc0.ɵɵelementStart(2, "div", 39);
    ɵngcc0.ɵɵtext(3, " Reply: ");
    ɵngcc0.ɵɵelementStart(4, "form", 40);
    ɵngcc0.ɵɵlistener("submit", function BantaComponent_banta_comment_view_53_Template_form_submit_4_listener() { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r69 = ɵngcc0.ɵɵnextContext(); return ctx_r69.sendPointSubMessage(); });
    ɵngcc0.ɵɵelementStart(5, "textarea", 41);
    ɵngcc0.ɵɵlistener("keydown", function BantaComponent_banta_comment_view_53_Template_textarea_keydown_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r70 = ɵngcc0.ɵɵnextContext(); return ctx_r70.newPointSubMessageKeyDown($event); })("ngModelChange", function BantaComponent_banta_comment_view_53_Template_textarea_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r71 = ɵngcc0.ɵɵnextContext(); return ctx_r71.newPointSubMessage.message = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 16);
    ɵngcc0.ɵɵelementStart(7, "button", 42);
    ɵngcc0.ɵɵtext(8, "Send");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("newestLast", true)("allowReplies", false)("source", ctx_r13.pointSubChat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.pointOpen);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.newPointSubMessage.message);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r13.newPointSubMessage.message);
} }
function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-live-chat-message", 2);
    ɵngcc0.ɵɵlistener("upvoted", function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template_banta_live_chat_message_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.upvote(ctx_r3.message); })("reported", function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template_banta_live_chat_message_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.report(ctx_r5.message); })("selected", function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template_banta_live_chat_message_selected_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.select(ctx_r6.message); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("message", ctx_r1.message);
} }
function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-live-comment", 2);
    ɵngcc0.ɵɵlistener("upvoted", function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template_banta_live_comment_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.upvote(ctx_r7.message); })("reported", function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template_banta_live_comment_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.report(ctx_r9.message); })("selected", function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template_banta_live_comment_selected_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.select(ctx_r10.message); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("message", ctx_r2.message);
} }
function LiveMessageComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template, 1, 1, "banta-live-chat-message", 1);
    ɵngcc0.ɵɵtemplate(2, LiveMessageComponent_ng_container_0_banta_live_comment_2_Template, 1, 1, "banta-live-comment", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.viewType === "chat");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.viewType === "comment");
} }
function CommentComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 18);
    ɵngcc0.ɵɵlistener("click", function CommentComponent_div_18_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.select(); });
    ɵngcc0.ɵɵelementStart(4, "mat-icon", 16);
    ɵngcc0.ɵɵtext(5, "comment");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r1.message.submessages == null ? null : ctx_r1.message.submessages.length) || 0, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("inline", true);
} }
function CommentViewComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" (", ctx_r0.newMessages.length, ") ");
} }
function CommentViewComponent_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1, " Be the first to comment! ");
    ɵngcc0.ɵɵelementEnd();
} }
function CommentViewComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CommentViewComponent_ng_container_7_div_1_Template, 2, 0, "div", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showEmptyState);
} }
function CommentViewComponent_banta_comment_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-comment", 7);
    ɵngcc0.ɵɵlistener("click", function CommentViewComponent_banta_comment_8_Template_banta_comment_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.isViewingMore = true; })("userSelected", function CommentViewComponent_banta_comment_8_Template_banta_comment_userSelected_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const message_r5 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectMessageUser(message_r5); })("upvoted", function CommentViewComponent_banta_comment_8_Template_banta_comment_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const message_r5 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.upvoteMessage(message_r5); })("reported", function CommentViewComponent_banta_comment_8_Template_banta_comment_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const message_r5 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.reportMessage(message_r5); })("selected", function CommentViewComponent_banta_comment_8_Template_banta_comment_selected_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const message_r5 = ctx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.selectMessage(message_r5); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r5 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", message_r5)("showReplyAction", ctx_r2.allowReplies);
} }
function CommentViewComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "mat-spinner");
    ɵngcc0.ɵɵelementEnd();
} }
function BantaCommentsComponent_div_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelement(2, "mat-spinner");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BantaCommentsComponent_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "banta-comment-view", 10);
    ɵngcc0.ɵɵelementStart(2, "banta-comment-field", 11);
    ɵngcc0.ɵɵlistener("signInSelected", function BantaCommentsComponent_div_0_ng_container_9_Template_banta_comment_field_signInSelected_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.showSignIn(); })("editAvatarSelected", function BantaCommentsComponent_div_0_ng_container_9_Template_banta_comment_field_editAvatarSelected_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.showEditAvatar(); })("permissionDeniedError", function BantaCommentsComponent_div_0_ng_container_9_Template_banta_comment_field_permissionDeniedError_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.showPermissionDenied(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("source", ctx_r2.selectedMessageThread)("allowReplies", false)("fixedHeight", false)("showEmptyState", false)("newestLast", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("sendLabel", ctx_r2.replyLabel)("sendingLabel", ctx_r2.sendingLabel)("hashtags", ctx_r2.hashtags)("participants", ctx_r2.participants)("source", ctx_r2.selectedMessageThread)("canComment", ctx_r2.canComment)("signInLabel", ctx_r2.signInLabel)("permissionDeniedLabel", ctx_r2.permissionDeniedLabel)("user", ctx_r2.user)("label", ctx_r2.postReplyLabel);
} }
function BantaCommentsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "a", 5);
    ɵngcc0.ɵɵlistener("click", function BantaCommentsComponent_div_0_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.unselectMessage(); });
    ɵngcc0.ɵɵelementStart(3, "mat-icon");
    ɵngcc0.ɵɵtext(4, "arrow_back");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " Latest Comments ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "banta-comment", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵtemplate(8, BantaCommentsComponent_div_0_ng_container_8_Template, 3, 0, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(9, BantaCommentsComponent_div_0_ng_container_9_Template, 3, 15, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("visible", ctx_r0.selectedMessageVisible);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("message", ctx_r0.selectedMessage);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.selectedMessageThread);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedMessageThread);
} }
function LiveCommentComponent_banta_comment_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "banta-comment", 1);
    ɵngcc0.ɵɵlistener("upvoted", function LiveCommentComponent_banta_comment_0_Template_banta_comment_upvoted_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.upvote(); })("reported", function LiveCommentComponent_banta_comment_0_Template_banta_comment_reported_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.report(); })("selected", function LiveCommentComponent_banta_comment_0_Template_banta_comment_selected_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.select(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r0.message);
} }
const _c7 = ["autocomplete"];
const _c8 = ["autocompleteContainer"];
const _c9 = ["textarea"];
function CommentFieldComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function CommentFieldComponent_a_18_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const option_r8 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.activateAutoComplete(option_r8); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    const index_r9 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r3.autoCompleteSelected === index_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r8.label, " ");
} }
function CommentFieldComponent_mat_spinner_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 19);
} }
function CommentFieldComponent_div_20_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "error");
    ɵngcc0.ɵɵelementEnd();
} }
function CommentFieldComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, CommentFieldComponent_div_20_mat_icon_1_Template, 2, 0, "mat-icon", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("expanded", ctx_r5.expandError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.sendError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.sendError.message, " ");
} }
function CommentFieldComponent_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 21);
    ɵngcc0.ɵɵlistener("click", function CommentFieldComponent_ng_container_23_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.showSignIn(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.signInLabel);
} }
function CommentFieldComponent_ng_container_24_button_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "chevron_right");
    ɵngcc0.ɵɵelementEnd();
} }
function CommentFieldComponent_ng_container_24_button_1_mat_spinner_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 27);
} }
function CommentFieldComponent_ng_container_24_button_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r19.sendLabel, " ");
} }
function CommentFieldComponent_ng_container_24_button_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r20.sendingLabel, " ");
} }
function CommentFieldComponent_ng_container_24_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 24);
    ɵngcc0.ɵɵtemplate(1, CommentFieldComponent_ng_container_24_button_1_mat_icon_1_Template, 2, 0, "mat-icon", 17);
    ɵngcc0.ɵɵtemplate(2, CommentFieldComponent_ng_container_24_button_1_mat_spinner_2_Template, 1, 0, "mat-spinner", 25);
    ɵngcc0.ɵɵelementStart(3, "span", 26);
    ɵngcc0.ɵɵtemplate(4, CommentFieldComponent_ng_container_24_button_1_ng_container_4_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵtemplate(5, CommentFieldComponent_ng_container_24_button_1_ng_container_5_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r15.text || ctx_r15.sending);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r15.sending);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.sending);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r15.sending);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.sending);
} }
function CommentFieldComponent_ng_container_24_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function CommentFieldComponent_ng_container_24_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.showPermissionDenied(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r16.permissionDeniedLabel);
} }
function CommentFieldComponent_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CommentFieldComponent_ng_container_24_button_1_Template, 6, 5, "button", 22);
    ɵngcc0.ɵɵtemplate(2, CommentFieldComponent_ng_container_24_button_2_Template, 2, 1, "button", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.canComment);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.canComment);
} }
function lazyConnection(options) {
    let obs = new Observable(observer => {
        let subject = new Subject();
        let subscription = subject.subscribe(observer);
        options.start(subject);
        return () => {
            subscription.unsubscribe();
            options.stop();
        };
    });
    return obs.pipe(publish()).refCount();
}

class BantaService {
    constructor() {
        this._userChanged = new BehaviorSubject(null);
    }
    get userChanged() {
        return this._userChanged;
    }
    set user(user) {
        this._user = user;
        this._userChanged.next(user);
    }
    get user() {
        return this._user;
    }
}
BantaService.ɵfac = function BantaService_Factory(t) { return new (t || BantaService)(); };
BantaService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BantaService, factory: BantaService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class TimestampComponent {
    constructor() {
        this.relative = '';
        this.tooltip = '';
        this.updateInterval = null;
        this.showAbsolute = false;
    }
    ngOnDestroy() {
        if (this.updateInterval)
            clearInterval(this.updateInterval);
    }
    get value() {
        return this._value;
    }
    update() {
        let now = Date.now();
        let diff = now - this.value;
        let minute = 1000 * 60;
        let hour = minute * 60;
        let day = hour * 24;
        let week = day * 7;
        let month = day * 30;
        let year = day * 365;
        this.showAbsolute = false;
        let updateTime = 0;
        if (diff > year) {
            this.showAbsolute = true;
            this.relative = 'abs';
            return;
        }
        if (diff > month) {
            let months = Math.floor(diff / month);
            if (months === 1)
                this.relative = `${months} month ago`;
            else
                this.relative = `${months} months ago`;
        }
        else if (diff > week) {
            let weeks = Math.floor(diff / week);
            if (weeks === 1)
                this.relative = `${weeks} week ago`;
            else
                this.relative = `${weeks} weeks ago`;
        }
        else if (diff > day) {
            let days = Math.floor(diff / day);
            if (days === 1)
                this.relative = `${days} day ago`;
            else
                this.relative = `${days} days ago`;
        }
        else if (diff > hour) {
            let hours = Math.floor(diff / hour);
            if (hours === 1)
                this.relative = `${hours} hour ago`;
            else
                this.relative = `${hours} hours ago`;
            updateTime = 1000 * 60 * 30;
        }
        else if (diff > minute) {
            let minutes = Math.floor(diff / minute);
            if (minutes === 1)
                this.relative = `${minutes} minute ago`;
            else
                this.relative = `${minutes} minutes ago`;
            updateTime = 1000 * 45;
        }
        else if (diff > 30000) {
            this.relative = `about a minute ago`;
            updateTime = 1000 * 60;
        }
        else {
            this.relative = `just now`;
            updateTime = 1000 * 30;
        }
        if (typeof window !== 'undefined') {
            clearInterval(this.updateInterval);
            if (updateTime > 0) {
                this.updateInterval = setInterval(() => this.update());
            }
        }
    }
    set value(v) {
        this._value = v;
        this.update();
    }
}
TimestampComponent.ɵfac = function TimestampComponent_Factory(t) { return new (t || TimestampComponent)(); };
TimestampComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimestampComponent, selectors: [["banta-timestamp"]], inputs: { value: "value" }, decls: 2, vars: 2, consts: [[3, "title", 4, "ngIf"], [3, "title"]], template: function TimestampComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TimestampComponent_span_0_Template, 4, 8, "span", 0);
        ɵngcc0.ɵɵtemplate(1, TimestampComponent_span_1_Template, 3, 5, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAbsolute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showAbsolute);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc1.DatePipe], styles: [""] });
TimestampComponent.propDecorators = {
    value: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimestampComponent, [{
        type: Component,
        args: [{
                selector: 'banta-timestamp',
                template: `
        <span *ngIf="showAbsolute" [title]="value | date : 'short'">
            {{value | date : 'shortDate'}}
        </span>
        <span *ngIf="!showAbsolute" [title]="value | date : 'short'">
            {{relative}}
        </span>
    `,
                styles: [``]
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }] }); })();

class ChatBackendService {
}
ChatBackendService.ɵfac = function ChatBackendService_Factory(t) { return new (t || ChatBackendService)(); };
ChatBackendService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ChatBackendService, factory: ChatBackendService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatBackendService, [{
        type: Injectable
    }], null, null); })();

const COMPONENTS = [
    TimestampComponent
];
class BantaCommonModule {
}
BantaCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BantaCommonModule });
BantaCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BantaCommonModule_Factory(t) { return new (t || BantaCommonModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BantaCommonModule, { declarations: function () { return [TimestampComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TimestampComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaCommonModule, [{
        type: NgModule,
        args: [{
                declarations: COMPONENTS,
                imports: [
                    CommonModule
                ],
                exports: COMPONENTS
            }]
    }], null, null); })();

const EMOJIS = {
    "grinning": {
        "keywords": ["face", "smile", "happy", "joy", ":D", "grin"],
        "char": "😀",
        "category": "people"
    },
    "grimacing": {
        "keywords": ["face", "grimace", "teeth"],
        "char": "😬",
        "category": "people"
    },
    "grin": {
        "keywords": ["face", "happy", "smile", "joy", "kawaii"],
        "char": "😁",
        "category": "people"
    },
    "joy": {
        "keywords": ["face", "cry", "tears", "weep", "happy", "happytears", "haha"],
        "char": "😂",
        "category": "people"
    },
    "smiley": {
        "keywords": ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"],
        "char": "😃",
        "category": "people"
    },
    "smile": {
        "keywords": ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"],
        "char": "😄",
        "category": "people"
    },
    "sweat_smile": {
        "keywords": ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"],
        "char": "😅",
        "category": "people"
    },
    "laughing": {
        "keywords": ["happy", "joy", "lol", "satisfied", "haha", "face", "glad", "XD", "laugh"],
        "char": "😆",
        "category": "people"
    },
    "innocent": {
        "keywords": ["face", "angel", "heaven", "halo"],
        "char": "😇",
        "category": "people"
    },
    "wink": {
        "keywords": ["face", "happy", "mischievous", "secret", ";)", "smile"],
        "char": "😉",
        "category": "people"
    },
    "blush": {
        "keywords": ["face", "smile", "happy", "flushed", "crush", "embarrassed", "shy", "joy"],
        "char": "😊",
        "category": "people"
    },
    "slightly_smiling": {
        "keywords": ["face", "smile"],
        "char": "🙂",
        "category": "people"
    },
    "upside_down": {
        "keywords": ["face", "flipped", "silly", "smile"],
        "char": "🙃",
        "category": "people"
    },
    "relaxed": {
        "keywords": ["face", "blush", "massage", "happiness"],
        "char": "☺️",
        "category": "people"
    },
    "yum": {
        "keywords": ["happy", "joy", "tongue", "smile", "face", "silly", "yummy", "nom"],
        "char": "😋",
        "category": "people"
    },
    "relieved": {
        "keywords": ["face", "relaxed", "phew", "massage", "happiness"],
        "char": "😌",
        "category": "people"
    },
    "heart_eyes": {
        "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "heart"],
        "char": "😍",
        "category": "people"
    },
    "kissing_heart": {
        "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
        "char": "😘",
        "category": "people"
    },
    "kissing": {
        "keywords": ["love", "like", "face", "3", "valentines", "infatuation", "kiss"],
        "char": "😗",
        "category": "people"
    },
    "kissing_smiling_eyes": {
        "keywords": ["face", "affection", "valentines", "infatuation", "kiss"],
        "char": "😙",
        "category": "people"
    },
    "kissing_closed_eyes": {
        "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
        "char": "😚",
        "category": "people"
    },
    "stuck_out_tongue_winking_eye": {
        "keywords": ["face", "prank", "childish", "playful", "mischievous", "smile", "wink", "tongue"],
        "char": "😜",
        "category": "people"
    },
    "stuck_out_tongue_closed_eyes": {
        "keywords": ["face", "prank", "playful", "mischievous", "smile", "tongue"],
        "char": "😝",
        "category": "people"
    },
    "stuck_out_tongue": {
        "keywords": ["face", "prank", "childish", "playful", "mischievous", "smile", "tongue"],
        "char": "😛",
        "category": "people"
    },
    "money_mouth": {
        "keywords": ["face", "rich", "dollar", "money"],
        "char": "🤑",
        "category": "people"
    },
    "nerd": {
        "keywords": ["face", "nerdy", "geek", "dork"],
        "char": "🤓",
        "category": "people"
    },
    "sunglasses": {
        "keywords": ["face", "cool", "smile", "summer", "beach", "sunglass"],
        "char": "😎",
        "category": "people"
    },
    "hugging": {
        "keywords": ["face", "smile", "hug"],
        "char": "🤗",
        "category": "people"
    },
    "smirk": {
        "keywords": ["face", "smile", "mean", "prank", "smug", "sarcasm"],
        "char": "😏",
        "category": "people"
    },
    "no_mouth": {
        "keywords": ["face", "hellokitty"],
        "char": "😶",
        "category": "people"
    },
    "neutral_face": {
        "keywords": ["indifference", "meh", ":|", "neutral"],
        "char": "😐",
        "category": "people"
    },
    "expressionless": {
        "keywords": ["face", "indifferent", "-_-", "meh", "deadpan"],
        "char": "😑",
        "category": "people"
    },
    "unamused": {
        "keywords": ["indifference", "bored", "straight face", "serious", "sarcasm"],
        "char": "😒",
        "category": "people"
    },
    "rolling_eyes": {
        "keywords": ["face", "eyeroll", "frustrated"],
        "char": "🙄",
        "category": "people"
    },
    "thinking": {
        "keywords": ["face", "hmmm", "think", "consider"],
        "char": "🤔",
        "category": "people"
    },
    "flushed": {
        "keywords": ["face", "blush", "shy", "flattered"],
        "char": "😳",
        "category": "people"
    },
    "disappointed": {
        "keywords": ["face", "sad", "upset", "depressed", ":("],
        "char": "😞",
        "category": "people"
    },
    "worried": {
        "keywords": ["face", "concern", "nervous", ":("],
        "char": "😟",
        "category": "people"
    },
    "angry": {
        "keywords": ["mad", "face", "annoyed", "frustrated"],
        "char": "😠",
        "category": "people"
    },
    "rage": {
        "keywords": ["angry", "mad", "hate", "despise"],
        "char": "😡",
        "category": "people"
    },
    "pensive": {
        "keywords": ["face", "sad", "depressed", "okay", "upset"],
        "char": "😔",
        "category": "people"
    },
    "confused": {
        "keywords": ["face", "indifference", "huh", "weird", "hmmm", ":/"],
        "char": "😕",
        "category": "people"
    },
    "slightly_sad": {
        "keywords": ["face", "frowning", "disappointed", "sad", "upset"],
        "char": "🙁",
        "category": "people"
    },
    "white_frowning": {
        "keywords": ["face", "sad", "upset", "frown"],
        "char": "☹",
        "category": "people"
    },
    "persevere": {
        "keywords": ["face", "sick", "no", "upset", "oops"],
        "char": "😣",
        "category": "people"
    },
    "confounded": {
        "keywords": ["face", "confused", "sick", "unwell", "oops", ":S"],
        "char": "😖",
        "category": "people"
    },
    "tired_face": {
        "keywords": ["sick", "whine", "upset", "frustrated"],
        "char": "😫",
        "category": "people"
    },
    "weary": {
        "keywords": ["face", "tired", "sleepy", "sad", "frustrated", "upset"],
        "char": "😩",
        "category": "people"
    },
    "triumph": {
        "keywords": ["face", "gas", "phew", "proud", "pride"],
        "char": "😤",
        "category": "people"
    },
    "open_mouth": {
        "keywords": ["face", "surprise", "impressed", "wow", "whoa", ":O"],
        "char": "😮",
        "category": "people"
    },
    "scream": {
        "keywords": ["face", "munch", "scared", "omg"],
        "char": "😱",
        "category": "people"
    },
    "fearful": {
        "keywords": ["face", "scared", "terrified", "nervous", "oops", "huh"],
        "char": "😨",
        "category": "people"
    },
    "cold_sweat": {
        "keywords": ["face", "nervous", "sweat"],
        "char": "😰",
        "category": "people"
    },
    "hushed": {
        "keywords": ["face", "woo", "shh"],
        "char": "😯",
        "category": "people"
    },
    "frowning": {
        "keywords": ["face", "aw", "what"],
        "char": "😦",
        "category": "people"
    },
    "anguished": {
        "keywords": ["face", "stunned", "nervous"],
        "char": "😧",
        "category": "people"
    },
    "cry": {
        "keywords": ["face", "tears", "sad", "depressed", "upset", ":'("],
        "char": "😢",
        "category": "people"
    },
    "disappointed_relieved": {
        "keywords": ["face", "phew", "sweat", "nervous"],
        "char": "😥",
        "category": "people"
    },
    "sleepy": {
        "keywords": ["face", "tired", "rest", "nap"],
        "char": "😪",
        "category": "people"
    },
    "sweat": {
        "keywords": ["face", "hot", "sad", "tired", "exercise"],
        "char": "😓",
        "category": "people"
    },
    "sob": {
        "keywords": ["face", "cry", "tears", "sad", "upset", "depressed"],
        "char": "😭",
        "category": "people"
    },
    "dizzy_face": {
        "keywords": ["spent", "unconscious", "xox", "dizzy"],
        "char": "😵",
        "category": "people"
    },
    "astonished": {
        "keywords": ["face", "xox", "surprised", "poisoned"],
        "char": "😲",
        "category": "people"
    },
    "zipper_mouth": {
        "keywords": ["face", "sealed", "zipper", "secret"],
        "char": "🤐",
        "category": "people"
    },
    "mask": {
        "keywords": ["face", "sick", "ill", "disease"],
        "char": "😷",
        "category": "people"
    },
    "thermometer_face": {
        "keywords": ["sick", "temperature", "thermometer", "cold"],
        "char": "🤒",
        "category": "people"
    },
    "bandage_face": {
        "keywords": ["injured", "clumsy", "bandage", "hurt"],
        "char": "🤕",
        "category": "people"
    },
    "sleeping": {
        "keywords": ["face", "tired", "sleepy", "night", "zzz"],
        "char": "😴",
        "category": "people"
    },
    "zzz": {
        "keywords": ["sleepy", "tired"],
        "char": "💤",
        "category": "people"
    },
    "hankey": {
        "keywords": ["poop", "shitface", "fail", "turd", "shit"],
        "char": "💩",
        "category": "people"
    },
    "smiling_imp": {
        "keywords": ["devil", "horns"],
        "char": "😈",
        "category": "people"
    },
    "imp": {
        "keywords": ["devil", "angry", "horns"],
        "char": "👿",
        "category": "people"
    },
    "japanese_ogre": {
        "keywords": ["monster", "red", "mask", "halloween", "scary", "creepy", "devil", "demon", "japanese", "ogre"],
        "char": "👹",
        "category": "people"
    },
    "japanese_goblin": {
        "keywords": ["red", "evil", "mask", "monster", "scary", "creepy", "japanese", "goblin"],
        "char": "👺",
        "category": "people"
    },
    "skull": {
        "keywords": ["dead", "skeleton", "creepy"],
        "char": "💀",
        "category": "people"
    },
    "ghost": {
        "keywords": ["halloween", "spooky", "scary"],
        "char": "👻",
        "category": "people"
    },
    "alien": {
        "keywords": ["UFO", "paul", "weird", "outer_space"],
        "char": "👽",
        "category": "people"
    },
    "robot": {
        "keywords": ["computer", "machine"],
        "char": "🤖",
        "category": "people"
    },
    "smiley_cat": {
        "keywords": ["animal", "cats", "happy", "smile"],
        "char": "😺",
        "category": "people"
    },
    "smile_cat": {
        "keywords": ["animal", "cats", "smile"],
        "char": "😸",
        "category": "people"
    },
    "joy_cat": {
        "keywords": ["animal", "cats", "haha", "happy", "tears"],
        "char": "😹",
        "category": "people"
    },
    "heart_eyes_cat": {
        "keywords": ["animal", "love", "like", "affection", "cats", "valentines", "heart"],
        "char": "😻",
        "category": "people"
    },
    "smirk_cat": {
        "keywords": ["animal", "cats", "smirk"],
        "char": "😼",
        "category": "people"
    },
    "kissing_cat": {
        "keywords": ["animal", "cats", "kiss"],
        "char": "😽",
        "category": "people"
    },
    "scream_cat": {
        "keywords": ["animal", "cats", "munch", "scared", "scream"],
        "char": "🙀",
        "category": "people"
    },
    "crying_cat_face": {
        "keywords": ["animal", "tears", "weep", "sad", "cats", "upset", "cry"],
        "char": "😿",
        "category": "people"
    },
    "pouting_cat": {
        "keywords": ["animal", "cats"],
        "char": "😾",
        "category": "people"
    },
    "raised_hands": {
        "keywords": ["gesture", "hooray", "yea", "celebration", "hands"],
        "char": "🙌",
        "category": "people"
    },
    "clap": {
        "keywords": ["hands", "praise", "applause", "congrats", "yay"],
        "char": "👏",
        "category": "people"
    },
    "wave": {
        "keywords": ["hands", "gesture", "goodbye", "solong", "farewell", "hello", "palm"],
        "char": "👋",
        "category": "people"
    },
    "+1": {
        "keywords": ["thumbsup", "yes", "awesome", "good", "agree", "accept", "cool", "hand", "like"],
        "char": "👍",
        "category": "people"
    },
    "minus1": {
        "keywords": ["thumbsdown", "no", "dislike", "hand"],
        "char": "👎",
        "category": "people"
    },
    "facepunch": {
        "keywords": ["angry", "violence", "fist", "hit", "attack", "hand"],
        "char": "👊",
        "category": "people"
    },
    "fist": {
        "keywords": ["fingers", "hand", "grasp"],
        "char": "✊",
        "category": "people"
    },
    "v": {
        "keywords": ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
        "char": "✌️",
        "category": "people"
    },
    "ok_hand": {
        "keywords": ["fingers", "limbs", "perfect", "ok"],
        "char": "👌",
        "category": "people"
    },
    "hand": {
        "keywords": ["fingers", "stop", "highfive", "palm", "ban", "raised_hand"],
        "char": "✋",
        "category": "people"
    },
    "open_hands": {
        "keywords": ["fingers", "butterfly", "hands", "open"],
        "char": "👐",
        "category": "people"
    },
    "muscle": {
        "keywords": ["arm", "flex", "hand", "summer", "strong", "biceps"],
        "char": "💪",
        "category": "people"
    },
    "pray": {
        "keywords": ["please", "hope", "wish", "namaste", "highfive"],
        "char": "🙏",
        "category": "people"
    },
    "point_up": {
        "keywords": ["hand", "fingers", "direction", "up"],
        "char": "☝️",
        "category": "people"
    },
    "point_up_2": {
        "keywords": ["fingers", "hand", "direction", "up"],
        "char": "👆",
        "category": "people"
    },
    "point_down": {
        "keywords": ["fingers", "hand", "direction", "down"],
        "char": "👇",
        "category": "people"
    },
    "point_left": {
        "keywords": ["direction", "fingers", "hand", "left"],
        "char": "👈",
        "category": "people"
    },
    "point_right": {
        "keywords": ["fingers", "hand", "direction", "right"],
        "char": "👉",
        "category": "people"
    },
    "middle_finger": {
        "keywords": ["hand", "fingers", "rude"],
        "char": "🖕",
        "category": "people"
    },
    "splayed_fingers": {
        "keywords": ["hand", "fingers", "palm"],
        "char": "🖐",
        "category": "people"
    },
    "sign_of_horns": {
        "keywords": ["hand", "fingers", "evil_eye", "metal", "rock_on"],
        "char": "🤘",
        "category": "people"
    },
    "vulcan_salute": {
        "keywords": ["hand", "fingers", "spock", "star trek"],
        "char": "🖖",
        "category": "people"
    },
    "writing_hand": {
        "keywords": ["pen", "stationery", "write"],
        "char": "✍",
        "category": "people"
    },
    "nail_care": {
        "keywords": ["beauty", "manicure", "finger", "fashion", "nail"],
        "char": "💅",
        "category": "people"
    },
    "lips": {
        "keywords": ["mouth", "kiss"],
        "char": "👄",
        "category": "people"
    },
    "tongue": {
        "keywords": ["mouth", "playful"],
        "char": "👅",
        "category": "people"
    },
    "ear": {
        "keywords": ["face", "hear", "sound", "listen"],
        "char": "👂",
        "category": "people"
    },
    "nose": {
        "keywords": ["smell", "sniff"],
        "char": "👃",
        "category": "people"
    },
    "eye": {
        "keywords": ["face", "look", "see", "watch", "stare"],
        "char": "👁",
        "category": "people"
    },
    "eyes": {
        "keywords": ["look", "watch", "stalk", "peek", "see"],
        "char": "👀",
        "category": "people"
    },
    "bust_in_silhouette": {
        "keywords": ["user", "person", "human"],
        "char": "👤",
        "category": "people"
    },
    "busts_in_silhouette": {
        "keywords": ["user", "person", "human", "group", "team"],
        "char": "👥",
        "category": "people"
    },
    "speaking_head": {
        "keywords": ["user", "person", "human"],
        "char": "🗣",
        "category": "people"
    },
    "baby": {
        "keywords": ["child", "boy", "girl", "toddler"],
        "char": "👶",
        "category": "people"
    },
    "boy": {
        "keywords": ["man", "male", "guy", "teenager"],
        "char": "👦",
        "category": "people"
    },
    "girl": {
        "keywords": ["female", "woman", "teenager"],
        "char": "👧",
        "category": "people"
    },
    "man": {
        "keywords": ["mustache", "father", "dad", "guy", "classy", "sir", "moustache"],
        "char": "👨",
        "category": "people"
    },
    "woman": {
        "keywords": ["female", "girls", "lady"],
        "char": "👩",
        "category": "people"
    },
    "person_with_blond_hair": {
        "keywords": ["man", "male", "boy", "blonde", "guy", "person"],
        "char": "👱",
        "category": "people"
    },
    "older_man": {
        "keywords": ["human", "male", "men", "old", "elder", "senior"],
        "char": "👴",
        "category": "people"
    },
    "older_woman": {
        "keywords": ["human", "female", "women", "lady", "old", "elder", "senior"],
        "char": "👵",
        "category": "people"
    },
    "man_with_gua_pi_mao": {
        "keywords": ["male", "boy", "chinese"],
        "char": "👲",
        "category": "people"
    },
    "man_with_turban": {
        "keywords": ["male", "indian", "hinduism", "arabs"],
        "char": "👳",
        "category": "people"
    },
    "cop": {
        "keywords": ["man", "police", "law", "legal", "enforcement", "arrest", "911"],
        "char": "👮",
        "category": "people"
    },
    "construction_worker": {
        "keywords": ["male", "human", "wip", "guy", "build", "construction", "worker", "labor"],
        "char": "👷",
        "category": "people"
    },
    "guardsman": {
        "keywords": ["uk", "gb", "british", "male", "guy", "royal"],
        "char": "💂",
        "category": "people"
    },
    "sleuth": {
        "keywords": ["human", "spy", "detective"],
        "char": "🕵",
        "category": "people"
    },
    "santa": {
        "keywords": ["festival", "man", "male", "xmas", "father christmas"],
        "char": "🎅",
        "category": "people"
    },
    "angel": {
        "keywords": ["heaven", "wings", "halo"],
        "char": "👼",
        "category": "people"
    },
    "princess": {
        "keywords": ["girl", "woman", "female", "blond", "crown", "royal", "queen"],
        "char": "👸",
        "category": "people"
    },
    "bride_with_veil": {
        "keywords": ["couple", "marriage", "wedding", "woman", "bride"],
        "char": "👰",
        "category": "people"
    },
    "runner": {
        "keywords": ["man", "walking", "exercise", "race", "running"],
        "char": "🏃",
        "category": "people"
    },
    "walking": {
        "keywords": ["human", "feet", "steps"],
        "char": "🚶",
        "category": "people"
    },
    "dancer": {
        "keywords": ["female", "girl", "woman", "fun"],
        "char": "💃",
        "category": "people"
    },
    "dancers": {
        "keywords": ["female", "bunny", "women", "girls"],
        "char": "👯",
        "category": "people"
    },
    "couple": {
        "keywords": ["pair", "people", "human", "love", "date", "dating", "like", "affection", "valentines", "marriage"],
        "char": "👫",
        "category": "people"
    },
    "two_men_holding_hands": {
        "keywords": ["pair", "couple", "love", "like", "bromance", "friendship", "people", "human"],
        "char": "👬",
        "category": "people"
    },
    "two_women_holding_hands": {
        "keywords": ["pair", "friendship", "couple", "love", "like", "female", "people", "human"],
        "char": "👭",
        "category": "people"
    },
    "bow": {
        "keywords": ["man", "male", "boy"],
        "char": "🙇",
        "category": "people"
    },
    "information_desk_person": {
        "keywords": ["female", "girl", "woman", "human", "information"],
        "char": "💁",
        "category": "people"
    },
    "no_good": {
        "keywords": ["female", "girl", "woman", "nope"],
        "char": "🙅",
        "category": "people"
    },
    "ok_woman": {
        "keywords": ["women", "girl", "female", "pink", "human", "woman"],
        "char": "🙆",
        "category": "people"
    },
    "raising_hand": {
        "keywords": ["female", "girl", "woman"],
        "char": "🙋",
        "category": "people"
    },
    "person_with_pouting_face": {
        "keywords": ["female", "girl", "woman"],
        "char": "🙎",
        "category": "people"
    },
    "person_frowning": {
        "keywords": ["female", "girl", "woman", "sad", "depressed", "discouraged", "unhappy"],
        "char": "🙍",
        "category": "people"
    },
    "haircut": {
        "keywords": ["female", "girl", "woman"],
        "char": "💇",
        "category": "people"
    },
    "massage": {
        "keywords": ["female", "girl", "woman", "head"],
        "char": "💆",
        "category": "people"
    },
    "couple_with_heart": {
        "keywords": ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"],
        "char": "💑",
        "category": "people"
    },
    "female_couple_with_heart": {
        "keywords": ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"],
        "char": "👩‍❤️‍👩",
        "category": "people"
    },
    "male_couple_with_heart": {
        "keywords": ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"],
        "char": "👨‍❤️‍👨",
        "category": "people"
    },
    "couplekiss": {
        "keywords": ["pair", "valentines", "love", "like", "dating", "marriage"],
        "char": "💏",
        "category": "people"
    },
    "female_couplekiss": {
        "keywords": ["pair", "valentines", "love", "like", "dating", "marriage"],
        "char": "👩‍❤️‍💋‍👩",
        "category": "people"
    },
    "male_couplekiss": {
        "keywords": ["pair", "valentines", "love", "like", "dating", "marriage"],
        "char": "👨‍❤️‍💋‍👨",
        "category": "people"
    },
    "family": {
        "keywords": ["home", "parents", "child", "mom", "dad", "father", "mother", "people", "human"],
        "char": "👪",
        "category": "people"
    },
    "family_man_woman_girl": {
        "keywords": ["home", "parents", "people", "human", "child"],
        "char": "👨‍👩‍👧",
        "category": "people"
    },
    "family_man_woman_girl_boy": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👩‍👧‍👦",
        "category": "people"
    },
    "family_man_woman_boys": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👩‍👦‍👦",
        "category": "people"
    },
    "family_man_woman_girls": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👩‍👧‍👧",
        "category": "people"
    },
    "family_women_boy": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👩‍👩‍👦",
        "category": "people"
    },
    "family_women_girl": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👩‍👩‍👧",
        "category": "people"
    },
    "family_women_girl_boy": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👩‍👩‍👧‍👦",
        "category": "people"
    },
    "family_women_boys": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👩‍👩‍👦‍👦",
        "category": "people"
    },
    "family_women_girls": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👩‍👩‍👧‍👧",
        "category": "people"
    },
    "family_men_boy": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👨‍👦",
        "category": "people"
    },
    "family_men_girl": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👨‍👧",
        "category": "people"
    },
    "family_men_girl_boy": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👨‍👧‍👦",
        "category": "people"
    },
    "family_men_boys": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👨‍👦‍👦",
        "category": "people"
    },
    "family_men_girls": {
        "keywords": ["home", "parents", "people", "human", "children"],
        "char": "👨‍👨‍👧‍👧",
        "category": "people"
    },
    "womans_clothes": {
        "keywords": ["fashion", "shopping", "female"],
        "char": "👚",
        "category": "people"
    },
    "shirt": {
        "keywords": ["fashion", "cloth", "casual", "tshirt", "tee"],
        "char": "👕",
        "category": "people"
    },
    "jeans": {
        "keywords": ["fashion", "shopping"],
        "char": "👖",
        "category": "people"
    },
    "necktie": {
        "keywords": ["shirt", "suitup", "formal", "fashion", "cloth", "business"],
        "char": "👔",
        "category": "people"
    },
    "dress": {
        "keywords": ["clothes", "fashion", "shopping"],
        "char": "👗",
        "category": "people"
    },
    "bikini": {
        "keywords": ["swimming", "female", "woman", "girl", "fashion", "beach", "summer"],
        "char": "👙",
        "category": "people"
    },
    "kimono": {
        "keywords": ["dress", "fashion", "women", "female", "japanese"],
        "char": "👘",
        "category": "people"
    },
    "lipstick": {
        "keywords": ["female", "girl", "fashion", "woman"],
        "char": "💄",
        "category": "people"
    },
    "kiss": {
        "keywords": ["face", "lips", "love", "like", "affection", "valentines"],
        "char": "💋",
        "category": "people"
    },
    "footprints": {
        "keywords": ["feet", "tracking", "walking", "beach"],
        "char": "👣",
        "category": "people"
    },
    "high_heel": {
        "keywords": ["fashion", "shoes", "female", "pumps", "stiletto"],
        "char": "👠",
        "category": "people"
    },
    "sandal": {
        "keywords": ["shoes", "fashion", "flip flops"],
        "char": "👡",
        "category": "people"
    },
    "boot": {
        "keywords": ["shoes", "fashion"],
        "char": "👢",
        "category": "people"
    },
    "mans_shoe": {
        "keywords": ["fashion", "male"],
        "char": "👞",
        "category": "people"
    },
    "athletic_shoe": {
        "keywords": ["shoes", "sports", "sneakers"],
        "char": "👟",
        "category": "people"
    },
    "womans_hat": {
        "keywords": ["fashion", "accessories", "female", "lady", "spring"],
        "char": "👒",
        "category": "people"
    },
    "tophat": {
        "keywords": ["magic", "gentleman", "classy", "circus"],
        "char": "🎩",
        "category": "people"
    },
    "helmet": {
        "keywords": ["construction", "build"],
        "char": "⛑",
        "category": "people"
    },
    "mortar_board": {
        "keywords": ["school", "college", "degree", "university", "graduation", "cap", "hat", "legal", "learn", "education"],
        "char": "🎓",
        "category": "people"
    },
    "crown": {
        "keywords": ["king", "kod", "leader", "royalty", "lord"],
        "char": "👑",
        "category": "people"
    },
    "school_satchel": {
        "keywords": ["student", "education", "bag", "backpack"],
        "char": "🎒",
        "category": "people"
    },
    "pouch": {
        "keywords": ["bag", "accessories", "shopping"],
        "char": "👝",
        "category": "people"
    },
    "purse": {
        "keywords": ["fashion", "accessories", "money", "sales", "shopping"],
        "char": "👛",
        "category": "people"
    },
    "handbag": {
        "keywords": ["fashion", "accessory", "accessories", "shopping"],
        "char": "👜",
        "category": "people"
    },
    "briefcase": {
        "keywords": ["business", "documents", "work", "law", "legal"],
        "char": "💼",
        "category": "people"
    },
    "eyeglasses": {
        "keywords": ["fashion", "accessories", "eyesight", "nerdy", "dork", "geek"],
        "char": "👓",
        "category": "people"
    },
    "dark_sunglasses": {
        "keywords": ["face", "cool", "accessories"],
        "char": "🕶",
        "category": "people"
    },
    "ring": {
        "keywords": ["wedding", "propose", "marriage", "valentines", "diamond", "fashion", "jewelry", "gem", "engagement"],
        "char": "💍",
        "category": "people"
    },
    "closed_umbrella": {
        "keywords": ["weather", "rain", "drizzle"],
        "char": "🌂",
        "category": "people"
    },
    "dog": {
        "keywords": ["animal", "friend", "nature", "woof", "puppy", "pet", "faithful"],
        "char": "🐶",
        "category": "animals_and_nature"
    },
    "cat": {
        "keywords": ["animal", "meow", "nature", "pet", "kitten"],
        "char": "🐱",
        "category": "animals_and_nature"
    },
    "mouse": {
        "keywords": ["animal", "nature", "cheese", "rodent"],
        "char": "🐭",
        "category": "animals_and_nature"
    },
    "hamster": {
        "keywords": ["animal", "nature"],
        "char": "🐹",
        "category": "animals_and_nature"
    },
    "rabbit": {
        "keywords": ["animal", "nature", "pet", "spring", "magic", "bunny"],
        "char": "🐰",
        "category": "animals_and_nature"
    },
    "bear": {
        "keywords": ["animal", "nature", "wild"],
        "char": "🐻",
        "category": "animals_and_nature"
    },
    "panda_face": {
        "keywords": ["animal", "nature", "panda"],
        "char": "🐼",
        "category": "animals_and_nature"
    },
    "koala": {
        "keywords": ["animal", "nature"],
        "char": "🐨",
        "category": "animals_and_nature"
    },
    "tiger": {
        "keywords": ["animal", "cat", "danger", "wild", "nature", "roar"],
        "char": "🐯",
        "category": "animals_and_nature"
    },
    "lion_face": {
        "keywords": ["animal", "nature"],
        "char": "🦁",
        "category": "animals_and_nature"
    },
    "cow": {
        "keywords": ["beef", "ox", "animal", "nature", "moo", "milk"],
        "char": "🐮",
        "category": "animals_and_nature"
    },
    "pig": {
        "keywords": ["animal", "oink", "nature"],
        "char": "🐷",
        "category": "animals_and_nature"
    },
    "pig_nose": {
        "keywords": ["animal", "oink"],
        "char": "🐽",
        "category": "animals_and_nature"
    },
    "frog": {
        "keywords": ["animal", "nature", "croak", "toad"],
        "char": "🐸",
        "category": "animals_and_nature"
    },
    "octopus": {
        "keywords": ["animal", "creature", "ocean", "sea", "nature", "beach"],
        "char": "🐙",
        "category": "animals_and_nature"
    },
    "monkey_face": {
        "keywords": ["animal", "nature", "circus"],
        "char": "🐵",
        "category": "animals_and_nature"
    },
    "see_no_evil": {
        "keywords": ["monkey", "animal", "nature", "haha"],
        "char": "🙈",
        "category": "animals_and_nature"
    },
    "hear_no_evil": {
        "keywords": ["animal", "monkey", "nature"],
        "char": "🙉",
        "category": "animals_and_nature"
    },
    "speak_no_evil": {
        "keywords": ["monkey", "animal", "nature", "omg"],
        "char": "🙊",
        "category": "animals_and_nature"
    },
    "monkey": {
        "keywords": ["animal", "nature", "banana", "circus"],
        "char": "🐒",
        "category": "animals_and_nature"
    },
    "chicken": {
        "keywords": ["animal", "cluck", "nature", "bird"],
        "char": "🐔",
        "category": "animals_and_nature"
    },
    "penguin": {
        "keywords": ["animal", "nature"],
        "char": "🐧",
        "category": "animals_and_nature"
    },
    "bird": {
        "keywords": ["animal", "nature", "fly", "tweet", "spring"],
        "char": "🐦",
        "category": "animals_and_nature"
    },
    "baby_chick": {
        "keywords": ["animal", "chicken", "bird"],
        "char": "🐤",
        "category": "animals_and_nature"
    },
    "hatching_chick": {
        "keywords": ["animal", "chicken", "egg", "born", "baby", "bird"],
        "char": "🐣",
        "category": "animals_and_nature"
    },
    "hatched_chick": {
        "keywords": ["animal", "chicken", "baby", "bird"],
        "char": "🐥",
        "category": "animals_and_nature"
    },
    "wolf": {
        "keywords": ["animal", "nature", "wild"],
        "char": "🐺",
        "category": "animals_and_nature"
    },
    "boar": {
        "keywords": ["animal", "nature"],
        "char": "🐗",
        "category": "animals_and_nature"
    },
    "horse": {
        "keywords": ["animal", "brown", "nature"],
        "char": "🐴",
        "category": "animals_and_nature"
    },
    "unicorn_face": {
        "keywords": ["animal", "nature", "mystical"],
        "char": "🦄",
        "category": "animals_and_nature"
    },
    "bee": {
        "keywords": ["animal", "insect", "nature", "bug", "spring", "honey"],
        "char": "🐝",
        "category": "animals_and_nature"
    },
    "bug": {
        "keywords": ["animal", "insect", "nature", "worm"],
        "char": "🐛",
        "category": "animals_and_nature"
    },
    "snail": {
        "keywords": ["slow", "animal", "shell"],
        "char": "🐌",
        "category": "animals_and_nature"
    },
    "beetle": {
        "keywords": ["animal", "insect", "nature", "ladybug"],
        "char": "🐞",
        "category": "animals_and_nature"
    },
    "ant": {
        "keywords": ["animal", "insect", "nature", "bug"],
        "char": "🐜",
        "category": "animals_and_nature"
    },
    "spider": {
        "keywords": ["animal", "arachnid"],
        "char": "🕷",
        "category": "animals_and_nature"
    },
    "scorpion": {
        "keywords": ["animal", "arachnid"],
        "char": "🦂",
        "category": "animals_and_nature"
    },
    "crab": {
        "keywords": ["animal", "crustacean"],
        "char": "🦀",
        "category": "animals_and_nature"
    },
    "snake": {
        "keywords": ["animal", "evil", "nature", "hiss", "python"],
        "char": "🐍",
        "category": "animals_and_nature"
    },
    "turtle": {
        "keywords": ["animal", "slow", "nature", "tortoise"],
        "char": "🐢",
        "category": "animals_and_nature"
    },
    "tropical_fish": {
        "keywords": ["animal", "swim", "ocean", "beach", "nemo"],
        "char": "🐠",
        "category": "animals_and_nature"
    },
    "fish": {
        "keywords": ["animal", "food", "nature"],
        "char": "🐟",
        "category": "animals_and_nature"
    },
    "blowfish": {
        "keywords": ["animal", "nature", "food", "sea", "ocean"],
        "char": "🐡",
        "category": "animals_and_nature"
    },
    "dolphin": {
        "keywords": ["animal", "nature", "fish", "sea", "ocean", "flipper", "fins", "beach"],
        "char": "🐬",
        "category": "animals_and_nature"
    },
    "whale": {
        "keywords": ["animal", "nature", "sea", "ocean"],
        "char": "🐳",
        "category": "animals_and_nature"
    },
    "whale2": {
        "keywords": ["animal", "nature", "sea", "ocean"],
        "char": "🐋",
        "category": "animals_and_nature"
    },
    "crocodile": {
        "keywords": ["animal", "nature", "reptile", "lizard", "alligator"],
        "char": "🐊",
        "category": "animals_and_nature"
    },
    "leopard": {
        "keywords": ["animal", "nature"],
        "char": "🐆",
        "category": "animals_and_nature"
    },
    "tiger2": {
        "keywords": ["animal", "nature", "roar"],
        "char": "🐅",
        "category": "animals_and_nature"
    },
    "water_buffalo": {
        "keywords": ["animal", "nature", "ox", "cow"],
        "char": "🐃",
        "category": "animals_and_nature"
    },
    "ox": {
        "keywords": ["animal", "cow", "beef"],
        "char": "🐂",
        "category": "animals_and_nature"
    },
    "cow2": {
        "keywords": ["beef", "ox", "animal", "nature", "moo", "milk"],
        "char": "🐄",
        "category": "animals_and_nature"
    },
    "dromedary_camel": {
        "keywords": ["animal", "hot", "desert", "hump"],
        "char": "🐪",
        "category": "animals_and_nature"
    },
    "camel": {
        "keywords": ["animal", "nature", "hot", "desert", "hump"],
        "char": "🐫",
        "category": "animals_and_nature"
    },
    "elephant": {
        "keywords": ["animal", "nature", "nose", "thailand", "circus"],
        "char": "🐘",
        "category": "animals_and_nature"
    },
    "goat": {
        "keywords": ["animal", "nature"],
        "char": "🐐",
        "category": "animals_and_nature"
    },
    "ram": {
        "keywords": ["animal", "sheep", "nature"],
        "char": "🐏",
        "category": "animals_and_nature"
    },
    "sheep": {
        "keywords": ["animal", "nature", "wool", "shipit"],
        "char": "🐑",
        "category": "animals_and_nature"
    },
    "racehorse": {
        "keywords": ["animal", "gamble", "luck"],
        "char": "🐎",
        "category": "animals_and_nature"
    },
    "pig2": {
        "keywords": ["animal", "nature"],
        "char": "🐖",
        "category": "animals_and_nature"
    },
    "rat": {
        "keywords": ["animal", "mouse", "rodent"],
        "char": "🐀",
        "category": "animals_and_nature"
    },
    "mouse2": {
        "keywords": ["animal", "nature", "rodent"],
        "char": "🐁",
        "category": "animals_and_nature"
    },
    "rooster": {
        "keywords": ["animal", "nature", "chicken"],
        "char": "🐓",
        "category": "animals_and_nature"
    },
    "turkey": {
        "keywords": ["animal", "bird"],
        "char": "🦃",
        "category": "animals_and_nature"
    },
    "dove_of_peace": {
        "keywords": ["animal", "bird"],
        "char": "🕊",
        "category": "animals_and_nature"
    },
    "dog2": {
        "keywords": ["animal", "nature", "friend", "doge", "pet", "faithful"],
        "char": "🐕",
        "category": "animals_and_nature"
    },
    "poodle": {
        "keywords": ["dog", "animal", "101", "nature", "pet"],
        "char": "🐩",
        "category": "animals_and_nature"
    },
    "cat2": {
        "keywords": ["animal", "meow", "pet", "cats"],
        "char": "🐈",
        "category": "animals_and_nature"
    },
    "rabbit2": {
        "keywords": ["animal", "nature", "pet", "magic", "spring"],
        "char": "🐇",
        "category": "animals_and_nature"
    },
    "chipmunk": {
        "keywords": ["animal", "nature", "rodent", "squirrel"],
        "char": "🐿",
        "category": "animals_and_nature"
    },
    "feet": {
        "keywords": ["animal", "tracking", "footprints", "dog", "cat", "pet", "paw_prints"],
        "char": "🐾",
        "category": "animals_and_nature"
    },
    "dragon": {
        "keywords": ["animal", "myth", "nature", "chinese", "green"],
        "char": "🐉",
        "category": "animals_and_nature"
    },
    "dragon_face": {
        "keywords": ["animal", "myth", "nature", "chinese", "green"],
        "char": "🐲",
        "category": "animals_and_nature"
    },
    "cactus": {
        "keywords": ["vegetable", "plant", "nature"],
        "char": "🌵",
        "category": "animals_and_nature"
    },
    "christmas_tree": {
        "keywords": ["festival", "vacation", "december", "xmas", "celebration"],
        "char": "🎄",
        "category": "animals_and_nature"
    },
    "evergreen_tree": {
        "keywords": ["plant", "nature"],
        "char": "🌲",
        "category": "animals_and_nature"
    },
    "deciduous_tree": {
        "keywords": ["plant", "nature"],
        "char": "🌳",
        "category": "animals_and_nature"
    },
    "palm_tree": {
        "keywords": ["plant", "vegetable", "nature", "summer", "beach", "mojito", "tropical"],
        "char": "🌴",
        "category": "animals_and_nature"
    },
    "seedling": {
        "keywords": ["plant", "nature", "grass", "lawn", "spring"],
        "char": "🌱",
        "category": "animals_and_nature"
    },
    "herb": {
        "keywords": ["vegetable", "plant", "medicine", "weed", "grass", "lawn"],
        "char": "🌿",
        "category": "animals_and_nature"
    },
    "shamrock": {
        "keywords": ["vegetable", "plant", "nature", "irish", "clover"],
        "char": "☘",
        "category": "animals_and_nature"
    },
    "four_leaf_clover": {
        "keywords": ["vegetable", "plant", "nature", "lucky", "irish"],
        "char": "🍀",
        "category": "animals_and_nature"
    },
    "bamboo": {
        "keywords": ["plant", "nature", "vegetable", "panda", "pine_decoration"],
        "char": "🎍",
        "category": "animals_and_nature"
    },
    "tanabata_tree": {
        "keywords": ["plant", "nature", "branch", "summer"],
        "char": "🎋",
        "category": "animals_and_nature"
    },
    "leaves": {
        "keywords": ["nature", "plant", "tree", "vegetable", "grass", "lawn", "spring"],
        "char": "🍃",
        "category": "animals_and_nature"
    },
    "fallen_leaf": {
        "keywords": ["nature", "plant", "vegetable", "leaves"],
        "char": "🍂",
        "category": "animals_and_nature"
    },
    "maple_leaf": {
        "keywords": ["nature", "plant", "vegetable", "canada", "fall"],
        "char": "🍁",
        "category": "animals_and_nature"
    },
    "ear_of_rice": {
        "keywords": ["nature", "plant"],
        "char": "🌾",
        "category": "animals_and_nature"
    },
    "hibiscus": {
        "keywords": ["plant", "vegetable", "flowers", "beach"],
        "char": "🌺",
        "category": "animals_and_nature"
    },
    "sunflower": {
        "keywords": ["nature", "plant", "fall"],
        "char": "🌻",
        "category": "animals_and_nature"
    },
    "rose": {
        "keywords": ["flowers", "valentines", "love", "spring"],
        "char": "🌹",
        "category": "animals_and_nature"
    },
    "tulip": {
        "keywords": ["flowers", "plant", "nature", "summer", "spring"],
        "char": "🌷",
        "category": "animals_and_nature"
    },
    "blossom": {
        "keywords": ["nature", "flowers", "yellow"],
        "char": "🌼",
        "category": "animals_and_nature"
    },
    "cherry_blossom": {
        "keywords": ["nature", "plant", "spring", "flower"],
        "char": "🌸",
        "category": "animals_and_nature"
    },
    "bouquet": {
        "keywords": ["flowers", "nature", "spring"],
        "char": "💐",
        "category": "animals_and_nature"
    },
    "mushroom": {
        "keywords": ["plant", "vegetable"],
        "char": "🍄",
        "category": "animals_and_nature"
    },
    "chestnut": {
        "keywords": ["food", "squirrel"],
        "char": "🌰",
        "category": "animals_and_nature"
    },
    "jack_o_lantern": {
        "keywords": ["halloween", "light", "pumpkin", "creepy", "fall"],
        "char": "🎃",
        "category": "animals_and_nature"
    },
    "shell": {
        "keywords": ["nature", "sea", "beach"],
        "char": "🐚",
        "category": "animals_and_nature"
    },
    "spider_web": {
        "keywords": ["animal", "insect", "arachnid", "silk"],
        "char": "🕸",
        "category": "animals_and_nature"
    },
    "earth_americas": {
        "keywords": ["globe", "world", "USA", "international"],
        "char": "🌎",
        "category": "animals_and_nature"
    },
    "earth_africa": {
        "keywords": ["globe", "world", "international"],
        "char": "🌍",
        "category": "animals_and_nature"
    },
    "earth_asia": {
        "keywords": ["globe", "world", "east", "international"],
        "char": "🌏",
        "category": "animals_and_nature"
    },
    "full_moon": {
        "keywords": ["nature", "yellow", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌕",
        "category": "animals_and_nature"
    },
    "waning_gibbous_moon": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep", "waxing_gibbous_moon"],
        "char": "🌖",
        "category": "animals_and_nature"
    },
    "last_quarter_moon": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌗",
        "category": "animals_and_nature"
    },
    "waning_crescent_moon": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌘",
        "category": "animals_and_nature"
    },
    "new_moon": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌑",
        "category": "animals_and_nature"
    },
    "waxing_crescent_moon": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌒",
        "category": "animals_and_nature"
    },
    "first_quarter_moon": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌓",
        "category": "animals_and_nature"
    },
    "moon": {
        "keywords": ["nature", "night", "sky", "gray", "twilight", "planet", "space", "evening", "sleep"],
        "char": "🌔",
        "category": "animals_and_nature"
    },
    "new_moon_with_face": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌚",
        "category": "animals_and_nature"
    },
    "full_moon_with_face": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌝",
        "category": "animals_and_nature"
    },
    "first_quarter_moon_with_face": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌛",
        "category": "animals_and_nature"
    },
    "last_quarter_moon_with_face": {
        "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
        "char": "🌜",
        "category": "animals_and_nature"
    },
    "sun_with_face": {
        "keywords": ["nature", "morning", "sky"],
        "char": "🌞",
        "category": "animals_and_nature"
    },
    "crescent_moon": {
        "keywords": ["night", "sleep", "sky", "evening", "magic"],
        "char": "🌙",
        "category": "animals_and_nature"
    },
    "star": {
        "keywords": ["night", "yellow"],
        "char": "⭐",
        "category": "animals_and_nature"
    },
    "star2": {
        "keywords": ["night", "sparkle", "awesome", "good", "magic"],
        "char": "🌟",
        "category": "animals_and_nature"
    },
    "dizzy": {
        "keywords": ["star", "sparkle", "shoot", "magic"],
        "char": "💫",
        "category": "animals_and_nature"
    },
    "sparkles": {
        "keywords": ["stars", "shine", "shiny", "cool", "awesome", "good", "magic"],
        "char": "✨",
        "category": "animals_and_nature"
    },
    "comet": {
        "keywords": ["space"],
        "char": "☄",
        "category": "animals_and_nature"
    },
    "sunny": {
        "keywords": ["weather", "nature", "brightness", "summer", "beach", "spring"],
        "char": "☀️",
        "category": "animals_and_nature"
    },
    "white_sun_with_small_cloud": {
        "keywords": ["weather"],
        "char": "🌤",
        "category": "animals_and_nature"
    },
    "partly_sunny": {
        "keywords": ["weather", "nature", "cloudy", "morning", "fall", "spring"],
        "char": "⛅",
        "category": "animals_and_nature"
    },
    "white_sun_behind_cloud": {
        "keywords": ["weather"],
        "char": "🌥",
        "category": "animals_and_nature"
    },
    "white_sun_behind_cloud_with_rain": {
        "keywords": ["weather"],
        "char": "🌦",
        "category": "animals_and_nature"
    },
    "cloud": {
        "keywords": ["weather", "sky"],
        "char": "☁️",
        "category": "animals_and_nature"
    },
    "cloud_with_rain": {
        "keywords": ["weather"],
        "char": "🌧",
        "category": "animals_and_nature"
    },
    "thunder_cloud_and_rain": {
        "keywords": ["weather", "lightning"],
        "char": "⛈",
        "category": "animals_and_nature"
    },
    "cloud_with_lightning": {
        "keywords": ["weather", "thunder"],
        "char": "🌩",
        "category": "animals_and_nature"
    },
    "zap": {
        "keywords": ["thunder", "weather", "lightning bolt", "fast"],
        "char": "⚡",
        "category": "animals_and_nature"
    },
    "fire": {
        "keywords": ["hot", "cook", "flame"],
        "char": "🔥",
        "category": "animals_and_nature"
    },
    "boom": {
        "keywords": ["bomb", "explode", "explosion", "collision", "blown"],
        "char": "💥",
        "category": "animals_and_nature"
    },
    "snowflake": {
        "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas"],
        "char": "❄️",
        "category": "animals_and_nature"
    },
    "cloud_with_snow": {
        "keywords": ["weather"],
        "char": "🌨",
        "category": "animals_and_nature"
    },
    "snowman": {
        "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen", "without_snow"],
        "char": "⛄",
        "category": "animals_and_nature"
    },
    "snowman_with_snow": {
        "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen"],
        "char": "☃",
        "category": "animals_and_nature"
    },
    "wind_blowing_face": {
        "keywords": ["gust", "air"],
        "char": "🌬",
        "category": "animals_and_nature"
    },
    "dash": {
        "keywords": ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"],
        "char": "💨",
        "category": "animals_and_nature"
    },
    "cloud_with_tornado": {
        "keywords": ["weather", "cyclone", "twister"],
        "char": "🌪",
        "category": "animals_and_nature"
    },
    "fog": {
        "keywords": ["weather"],
        "char": "🌫",
        "category": "animals_and_nature"
    },
    "umbrella_without_rain": {
        "keywords": ["weather", "spring"],
        "char": "☂",
        "category": "animals_and_nature"
    },
    "umbrella": {
        "keywords": ["rainy", "weather", "spring"],
        "char": "☔",
        "category": "animals_and_nature"
    },
    "droplet": {
        "keywords": ["water", "drip", "faucet", "spring"],
        "char": "💧",
        "category": "animals_and_nature"
    },
    "sweat_drops": {
        "keywords": ["water", "drip", "oops"],
        "char": "💦",
        "category": "animals_and_nature"
    },
    "ocean": {
        "keywords": ["sea", "water", "wave", "nature", "tsunami", "disaster"],
        "char": "🌊",
        "category": "animals_and_nature"
    },
    "green_apple": {
        "keywords": ["fruit", "nature"],
        "char": "🍏",
        "category": "food_and_drink"
    },
    "apple": {
        "keywords": ["fruit", "mac", "school"],
        "char": "🍎",
        "category": "food_and_drink"
    },
    "pear": {
        "keywords": ["fruit", "nature", "food"],
        "char": "🍐",
        "category": "food_and_drink"
    },
    "tangerine": {
        "keywords": ["food", "fruit", "nature", "orange"],
        "char": "🍊",
        "category": "food_and_drink"
    },
    "lemon": {
        "keywords": ["fruit", "nature"],
        "char": "🍋",
        "category": "food_and_drink"
    },
    "banana": {
        "keywords": ["fruit", "food", "monkey"],
        "char": "🍌",
        "category": "food_and_drink"
    },
    "watermelon": {
        "keywords": ["fruit", "food", "picnic", "summer"],
        "char": "🍉",
        "category": "food_and_drink"
    },
    "grapes": {
        "keywords": ["fruit", "food", "wine"],
        "char": "🍇",
        "category": "food_and_drink"
    },
    "strawberry": {
        "keywords": ["fruit", "food", "nature"],
        "char": "🍓",
        "category": "food_and_drink"
    },
    "melon": {
        "keywords": ["fruit", "nature", "food"],
        "char": "🍈",
        "category": "food_and_drink"
    },
    "cherries": {
        "keywords": ["food", "fruit"],
        "char": "🍒",
        "category": "food_and_drink"
    },
    "peach": {
        "keywords": ["fruit", "nature", "food"],
        "char": "🍑",
        "category": "food_and_drink"
    },
    "pineapple": {
        "keywords": ["fruit", "nature", "food"],
        "char": "🍍",
        "category": "food_and_drink"
    },
    "tomato": {
        "keywords": ["fruit", "vegetable", "nature", "food"],
        "char": "🍅",
        "category": "food_and_drink"
    },
    "eggplant": {
        "keywords": ["vegetable", "nature", "food", "aubergine"],
        "char": "🍆",
        "category": "food_and_drink"
    },
    "hot_pepper": {
        "keywords": ["food", "spicy", "chilli", "chili"],
        "char": "🌶",
        "category": "food_and_drink"
    },
    "corn": {
        "keywords": ["food", "vegetable", "plant"],
        "char": "🌽",
        "category": "food_and_drink"
    },
    "sweet_potato": {
        "keywords": ["food", "nature"],
        "char": "🍠",
        "category": "food_and_drink"
    },
    "honey_pot": {
        "keywords": ["bees", "sweet", "kitchen"],
        "char": "🍯",
        "category": "food_and_drink"
    },
    "bread": {
        "keywords": ["food", "wheat", "breakfast", "toast"],
        "char": "🍞",
        "category": "food_and_drink"
    },
    "cheese_wedge": {
        "keywords": ["food", "chadder"],
        "char": "🧀",
        "category": "food_and_drink"
    },
    "poultry_leg": {
        "keywords": ["food", "meat", "drumstick", "bird", "chicken", "turkey"],
        "char": "🍗",
        "category": "food_and_drink"
    },
    "meat_on_bone": {
        "keywords": ["good", "food", "drumstick"],
        "char": "🍖",
        "category": "food_and_drink"
    },
    "fried_shrimp": {
        "keywords": ["food", "animal", "appetizer", "summer"],
        "char": "🍤",
        "category": "food_and_drink"
    },
    "egg": {
        "keywords": ["food", "breakfast", "kitchen"],
        "char": "🍳",
        "category": "food_and_drink"
    },
    "hamburger": {
        "keywords": ["meat", "fast food", "beef", "cheeseburger", "mcdonalds", "burger king"],
        "char": "🍔",
        "category": "food_and_drink"
    },
    "fries": {
        "keywords": ["chips", "snack", "fast food"],
        "char": "🍟",
        "category": "food_and_drink"
    },
    "hot_dog": {
        "keywords": ["food", "frankfurter", "hotdog"],
        "char": "🌭",
        "category": "food_and_drink"
    },
    "pizza": {
        "keywords": ["food", "party"],
        "char": "🍕",
        "category": "food_and_drink"
    },
    "spaghetti": {
        "keywords": ["food", "italian", "noodle"],
        "char": "🍝",
        "category": "food_and_drink"
    },
    "taco": {
        "keywords": ["food", "mexican"],
        "char": "🌮",
        "category": "food_and_drink"
    },
    "burrito": {
        "keywords": ["food", "mexican"],
        "char": "🌯",
        "category": "food_and_drink"
    },
    "ramen": {
        "keywords": ["food", "japanese", "noodle", "chopsticks"],
        "char": "🍜",
        "category": "food_and_drink"
    },
    "stew": {
        "keywords": ["food", "meat", "soup"],
        "char": "🍲",
        "category": "food_and_drink"
    },
    "fish_cake": {
        "keywords": ["food", "japan", "sea", "beach"],
        "char": "🍥",
        "category": "food_and_drink"
    },
    "sushi": {
        "keywords": ["food", "fish", "japanese", "rice"],
        "char": "🍣",
        "category": "food_and_drink"
    },
    "bento": {
        "keywords": ["food", "japanese", "box"],
        "char": "🍱",
        "category": "food_and_drink"
    },
    "curry": {
        "keywords": ["food", "spicy", "hot", "indian"],
        "char": "🍛",
        "category": "food_and_drink"
    },
    "rice_ball": {
        "keywords": ["food", "japanese"],
        "char": "🍙",
        "category": "food_and_drink"
    },
    "rice": {
        "keywords": ["food", "china", "asian"],
        "char": "🍚",
        "category": "food_and_drink"
    },
    "rice_cracker": {
        "keywords": ["food", "japanese"],
        "char": "🍘",
        "category": "food_and_drink"
    },
    "oden": {
        "keywords": ["food", "japanese"],
        "char": "🍢",
        "category": "food_and_drink"
    },
    "dango": {
        "keywords": ["food", "dessert", "sweet", "japanese", "barbecue", "meat"],
        "char": "🍡",
        "category": "food_and_drink"
    },
    "shaved_ice": {
        "keywords": ["hot", "dessert", "summer"],
        "char": "🍧",
        "category": "food_and_drink"
    },
    "ice_cream": {
        "keywords": ["food", "hot", "dessert"],
        "char": "🍨",
        "category": "food_and_drink"
    },
    "icecream": {
        "keywords": ["food", "hot", "dessert", "summer"],
        "char": "🍦",
        "category": "food_and_drink"
    },
    "cake": {
        "keywords": ["food", "dessert"],
        "char": "🍰",
        "category": "food_and_drink"
    },
    "birthday": {
        "keywords": ["food", "dessert", "cake"],
        "char": "🎂",
        "category": "food_and_drink"
    },
    "custard": {
        "keywords": ["dessert", "food"],
        "char": "🍮",
        "category": "food_and_drink"
    },
    "candy": {
        "keywords": ["snack", "dessert", "sweet", "lolly"],
        "char": "🍬",
        "category": "food_and_drink"
    },
    "lollipop": {
        "keywords": ["food", "snack", "candy", "sweet"],
        "char": "🍭",
        "category": "food_and_drink"
    },
    "chocolate_bar": {
        "keywords": ["food", "snack", "dessert", "sweet"],
        "char": "🍫",
        "category": "food_and_drink"
    },
    "popcorn": {
        "keywords": ["food", "movie theater", "films", "snack"],
        "char": "🍿",
        "category": "food_and_drink"
    },
    "doughnut": {
        "keywords": ["food", "dessert", "snack", "sweet", "donut"],
        "char": "🍩",
        "category": "food_and_drink"
    },
    "cookie": {
        "keywords": ["food", "snack", "oreo", "chocolate", "sweet", "dessert"],
        "char": "🍪",
        "category": "food_and_drink"
    },
    "beer": {
        "keywords": ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
        "char": "🍺",
        "category": "food_and_drink"
    },
    "beers": {
        "keywords": ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
        "char": "🍻",
        "category": "food_and_drink"
    },
    "wine_glass": {
        "keywords": ["drink", "beverage", "drunk", "alcohol", "booze"],
        "char": "🍷",
        "category": "food_and_drink"
    },
    "cocktail": {
        "keywords": ["drink", "drunk", "alcohol", "beverage", "booze", "mojito"],
        "char": "🍸",
        "category": "food_and_drink"
    },
    "tropical_drink": {
        "keywords": ["beverage", "cocktail", "summer", "beach", "alcohol", "booze", "mojito"],
        "char": "🍹",
        "category": "food_and_drink"
    },
    "bottle": {
        "keywords": ["drink", "wine", "champagne"],
        "char": "🍾",
        "category": "food_and_drink"
    },
    "sake": {
        "keywords": ["wine", "drink", "drunk", "beverage", "japanese", "alcohol", "booze"],
        "char": "🍶",
        "category": "food_and_drink"
    },
    "tea": {
        "keywords": ["drink", "bowl", "breakfast", "green", "british"],
        "char": "🍵",
        "category": "food_and_drink"
    },
    "coffee": {
        "keywords": ["beverage", "caffeine", "latte", "espresso"],
        "char": "☕",
        "category": "food_and_drink"
    },
    "baby_bottle": {
        "keywords": ["food", "container", "milk"],
        "char": "🍼",
        "category": "food_and_drink"
    },
    "fork_and_knife": {
        "keywords": ["cutlery", "kitchen"],
        "char": "🍴",
        "category": "food_and_drink"
    },
    "fork_and_knife_with_plate": {
        "keywords": ["food", "eat", "meal", "lunch", "dinner", "restaurant"],
        "char": "🍽",
        "category": "food_and_drink"
    },
    "soccer": {
        "keywords": ["sports", "football"],
        "char": "⚽",
        "category": "activity"
    },
    "basketball": {
        "keywords": ["sports", "balls", "NBA"],
        "char": "🏀",
        "category": "activity"
    },
    "football": {
        "keywords": ["sports", "balls", "NFL"],
        "char": "🏈",
        "category": "activity"
    },
    "baseball": {
        "keywords": ["sports", "balls"],
        "char": "⚾",
        "category": "activity"
    },
    "tennis": {
        "keywords": ["sports", "balls", "green"],
        "char": "🎾",
        "category": "activity"
    },
    "volleyball": {
        "keywords": ["sports", "balls"],
        "char": "🏐",
        "category": "activity"
    },
    "rugby_football": {
        "keywords": ["sports", "team"],
        "char": "🏉",
        "category": "activity"
    },
    "8ball": {
        "keywords": ["pool", "hobby", "game", "luck", "magic"],
        "char": "🎱",
        "category": "activity"
    },
    "golf": {
        "keywords": ["sports", "business", "flag", "hole", "summer"],
        "char": "⛳",
        "category": "activity"
    },
    "golfer": {
        "keywords": ["sports", "business"],
        "char": "🏌",
        "category": "activity"
    },
    "table_tennis": {
        "keywords": ["sports", "pingpong"],
        "char": "🏓",
        "category": "activity"
    },
    "badminton": {
        "keywords": ["sports"],
        "char": "🏸",
        "category": "activity"
    },
    "ice_hockey": {
        "keywords": ["sports"],
        "char": "🏒",
        "category": "activity"
    },
    "field_hockey": {
        "keywords": ["sports"],
        "char": "🏑",
        "category": "activity"
    },
    "cricket": {
        "keywords": ["sports"],
        "char": "🏏",
        "category": "activity"
    },
    "ski": {
        "keywords": ["sports", "winter", "cold", "snow"],
        "char": "🎿",
        "category": "activity"
    },
    "skier": {
        "keywords": ["sports", "winter", "snow"],
        "char": "⛷",
        "category": "activity"
    },
    "snowboarder": {
        "keywords": ["sports", "winter"],
        "char": "🏂",
        "category": "activity"
    },
    "ice_skate": {
        "keywords": ["sports"],
        "char": "⛸",
        "category": "activity"
    },
    "bow_and_arrow": {
        "keywords": ["sports"],
        "char": "🏹",
        "category": "activity"
    },
    "fishing_pole_and_fish": {
        "keywords": ["food", "hobby", "summer"],
        "char": "🎣",
        "category": "activity"
    },
    "rowboat": {
        "keywords": ["sports", "hobby", "water", "ship"],
        "char": "🚣",
        "category": "activity"
    },
    "swimmer": {
        "keywords": ["sports", "exercise", "human", "athlete", "water", "summer"],
        "char": "🏊",
        "category": "activity"
    },
    "surfer": {
        "keywords": ["sports", "ocean", "sea", "summer", "beach"],
        "char": "🏄",
        "category": "activity"
    },
    "bath": {
        "keywords": ["clean", "shower", "bathroom"],
        "char": "🛀",
        "category": "activity"
    },
    "person_with_ball": {
        "keywords": ["sports", "human"],
        "char": "⛹",
        "category": "activity"
    },
    "weight_lifter": {
        "keywords": ["sports", "training", "exercise"],
        "char": "🏋",
        "category": "activity"
    },
    "bicyclist": {
        "keywords": ["sports", "bike", "exercise", "hipster"],
        "char": "🚴",
        "category": "activity"
    },
    "mountain_bicyclist": {
        "keywords": ["transportation", "sports", "human", "race", "bike"],
        "char": "🚵",
        "category": "activity"
    },
    "horse_racing": {
        "keywords": ["animal", "betting", "competition", "gambling", "luck"],
        "char": "🏇",
        "category": "activity"
    },
    "man_levitating": {
        "keywords": ["suit", "business", "levitate", "hover", "jump"],
        "char": "🕴",
        "category": "activity"
    },
    "trophy": {
        "keywords": ["win", "award", "contest", "place", "ftw", "ceremony"],
        "char": "🏆",
        "category": "activity"
    },
    "running_shirt_with_sash": {
        "keywords": ["play", "pageant"],
        "char": "🎽",
        "category": "activity"
    },
    "sports_medal": {
        "keywords": ["award", "winning"],
        "char": "🏅",
        "category": "activity"
    },
    "military_medal": {
        "keywords": ["award", "winning", "army"],
        "char": "🎖",
        "category": "activity"
    },
    "reminder_ribbon": {
        "keywords": ["sports", "cause", "support", "awareness"],
        "char": "🎗",
        "category": "activity"
    },
    "rosette": {
        "keywords": ["flower", "decoration", "military"],
        "char": "🏵",
        "category": "activity"
    },
    "ticket": {
        "keywords": ["event", "concert", "pass"],
        "char": "🎫",
        "category": "activity"
    },
    "admission_ticket": {
        "keywords": ["sports", "concert", "entrance"],
        "char": "🎟",
        "category": "activity"
    },
    "performing_arts": {
        "keywords": ["acting", "theater", "drama"],
        "char": "🎭",
        "category": "activity"
    },
    "art": {
        "keywords": ["design", "paint", "draw", "colors"],
        "char": "🎨",
        "category": "activity"
    },
    "circus_tent": {
        "keywords": ["festival", "carnival", "party"],
        "char": "🎪",
        "category": "activity"
    },
    "microphone": {
        "keywords": ["sound", "music", "PA"],
        "char": "🎤",
        "category": "activity"
    },
    "headphones": {
        "keywords": ["music", "score", "gadgets"],
        "char": "🎧",
        "category": "activity"
    },
    "musical_score": {
        "keywords": ["treble", "clef"],
        "char": "🎼",
        "category": "activity"
    },
    "musical_keyboard": {
        "keywords": ["piano", "instrument"],
        "char": "🎹",
        "category": "activity"
    },
    "saxophone": {
        "keywords": ["music", "instrument", "jazz", "blues"],
        "char": "🎷",
        "category": "activity"
    },
    "trumpet": {
        "keywords": ["music", "brass"],
        "char": "🎺",
        "category": "activity"
    },
    "guitar": {
        "keywords": ["music", "instrument"],
        "char": "🎸",
        "category": "activity"
    },
    "violin": {
        "keywords": ["music", "instrument", "orchestra", "symphony"],
        "char": "🎻",
        "category": "activity"
    },
    "clapper": {
        "keywords": ["movie", "film", "record"],
        "char": "🎬",
        "category": "activity"
    },
    "video_game": {
        "keywords": ["play", "console", "PS4", "controller"],
        "char": "🎮",
        "category": "activity"
    },
    "space_invader": {
        "keywords": ["game", "arcade", "play"],
        "char": "👾",
        "category": "activity"
    },
    "dart": {
        "keywords": ["game", "play", "bar"],
        "char": "🎯",
        "category": "activity"
    },
    "game_die": {
        "keywords": ["dice", "random", "tabletop", "play", "luck"],
        "char": "🎲",
        "category": "activity"
    },
    "slot_machine": {
        "keywords": ["bet", "gamble", "vegas", "fruit machine", "luck", "casino"],
        "char": "🎰",
        "category": "activity"
    },
    "bowling": {
        "keywords": ["sports", "fun", "play"],
        "char": "🎳",
        "category": "activity"
    },
    "car": {
        "keywords": ["red", "transportation", "vehicle"],
        "char": "🚗",
        "category": "travel_and_places"
    },
    "taxi": {
        "keywords": ["uber", "vehicle", "cars", "transportation"],
        "char": "🚕",
        "category": "travel_and_places"
    },
    "blue_car": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚙",
        "category": "travel_and_places"
    },
    "bus": {
        "keywords": ["car", "vehicle", "transportation"],
        "char": "🚌",
        "category": "travel_and_places"
    },
    "trolleybus": {
        "keywords": ["bart", "transportation", "vehicle"],
        "char": "🚎",
        "category": "travel_and_places"
    },
    "racing_car": {
        "keywords": ["sports", "race", "fast", "formula", "f1"],
        "char": "🏎",
        "category": "travel_and_places"
    },
    "police_car": {
        "keywords": ["vehicle", "cars", "transportation", "law", "legal", "enforcement"],
        "char": "🚓",
        "category": "travel_and_places"
    },
    "ambulance": {
        "keywords": ["health", "911", "hospital"],
        "char": "🚑",
        "category": "travel_and_places"
    },
    "fire_engine": {
        "keywords": ["transportation", "cars", "vehicle"],
        "char": "🚒",
        "category": "travel_and_places"
    },
    "minibus": {
        "keywords": ["vehicle", "car", "transportation"],
        "char": "🚐",
        "category": "travel_and_places"
    },
    "truck": {
        "keywords": ["cars", "transportation"],
        "char": "🚚",
        "category": "travel_and_places"
    },
    "articulated_lorry": {
        "keywords": ["vehicle", "cars", "transportation", "express"],
        "char": "🚛",
        "category": "travel_and_places"
    },
    "tractor": {
        "keywords": ["vehicle", "car", "farming", "agriculture"],
        "char": "🚜",
        "category": "travel_and_places"
    },
    "racing_motorcycle": {
        "keywords": ["race", "sports", "fast"],
        "char": "🏍",
        "category": "travel_and_places"
    },
    "bike": {
        "keywords": ["sports", "bicycle", "exercise", "hipster"],
        "char": "🚲",
        "category": "travel_and_places"
    },
    "rotating_light": {
        "keywords": ["police", "ambulance", "911", "emergency", "alert", "error", "pinged", "law", "legal"],
        "char": "🚨",
        "category": "travel_and_places"
    },
    "oncoming_police_car": {
        "keywords": ["vehicle", "law", "legal", "enforcement", "911"],
        "char": "🚔",
        "category": "travel_and_places"
    },
    "oncoming_bus": {
        "keywords": ["vehicle", "transportation"],
        "char": "🚍",
        "category": "travel_and_places"
    },
    "oncoming_automobile": {
        "keywords": ["car", "vehicle", "transportation"],
        "char": "🚘",
        "category": "travel_and_places"
    },
    "oncoming_taxi": {
        "keywords": ["vehicle", "cars", "uber"],
        "char": "🚖",
        "category": "travel_and_places"
    },
    "aerial_tramway": {
        "keywords": ["transportation", "vehicle", "ski"],
        "char": "🚡",
        "category": "travel_and_places"
    },
    "mountain_cableway": {
        "keywords": ["transportation", "vehicle", "ski"],
        "char": "🚠",
        "category": "travel_and_places"
    },
    "suspension_railway": {
        "keywords": ["vehicle", "transportation"],
        "char": "🚟",
        "category": "travel_and_places"
    },
    "railway_car": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚃",
        "category": "travel_and_places"
    },
    "train": {
        "keywords": ["transportation", "vehicle", "carriage", "public", "travel"],
        "char": "🚋",
        "category": "travel_and_places"
    },
    "monorail": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚝",
        "category": "travel_and_places"
    },
    "bullettrain_side": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚄",
        "category": "travel_and_places"
    },
    "bullettrain_front": {
        "keywords": ["transportation", "vehicle", "speed", "fast", "public", "travel"],
        "char": "🚅",
        "category": "travel_and_places"
    },
    "light_rail": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚈",
        "category": "travel_and_places"
    },
    "mountain_railway": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚞",
        "category": "travel_and_places"
    },
    "steam_locomotive": {
        "keywords": ["transportation", "vehicle", "train"],
        "char": "🚂",
        "category": "travel_and_places"
    },
    "train2": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚆",
        "category": "travel_and_places"
    },
    "metro": {
        "keywords": ["transportation", "blue-square", "mrt", "underground", "tube"],
        "char": "🚇",
        "category": "travel_and_places"
    },
    "tram": {
        "keywords": ["transportation", "vehicle"],
        "char": "🚊",
        "category": "travel_and_places"
    },
    "station": {
        "keywords": ["transportation", "vehicle", "public"],
        "char": "🚉",
        "category": "travel_and_places"
    },
    "helicopter": {
        "keywords": ["transportation", "vehicle", "fly"],
        "char": "🚁",
        "category": "travel_and_places"
    },
    "small_airplane": {
        "keywords": ["flight", "transportation", "fly", "vehicle"],
        "char": "🛩",
        "category": "travel_and_places"
    },
    "airplane": {
        "keywords": ["vehicle", "transportation", "flight", "fly"],
        "char": "✈️",
        "category": "travel_and_places"
    },
    "airplane_departure": {
        "keywords": ["airport", "flight", "landing"],
        "char": "🛫",
        "category": "travel_and_places"
    },
    "airplane_arrival": {
        "keywords": ["airport", "flight", "boarding"],
        "char": "🛬",
        "category": "travel_and_places"
    },
    "boat": {
        "keywords": ["ship", "summer", "transportation", "water", "sailing", "sailboat"],
        "char": "⛵",
        "category": "travel_and_places"
    },
    "motor_boat": {
        "keywords": ["ship"],
        "char": "🛥",
        "category": "travel_and_places"
    },
    "speedboat": {
        "keywords": ["ship", "transportation", "vehicle", "summer"],
        "char": "🚤",
        "category": "travel_and_places"
    },
    "ferry": {
        "keywords": ["boat", "ship", "yacht"],
        "char": "⛴",
        "category": "travel_and_places"
    },
    "passenger_ship": {
        "keywords": ["yacht", "cruise", "ferry"],
        "char": "🛳",
        "category": "travel_and_places"
    },
    "rocket": {
        "keywords": ["launch", "ship", "staffmode", "NASA", "outer space", "outer_space", "fly"],
        "char": "🚀",
        "category": "travel_and_places"
    },
    "artificial_satellite": {
        "keywords": ["communication", "gps", "orbit", "spaceflight", "NASA", "ISS"],
        "char": "🛰",
        "category": "travel_and_places"
    },
    "seat": {
        "keywords": ["sit", "airplane", "transport", "bus", "flight", "fly"],
        "char": "💺",
        "category": "travel_and_places"
    },
    "anchor": {
        "keywords": ["ship", "ferry", "sea", "boat"],
        "char": "⚓",
        "category": "travel_and_places"
    },
    "construction": {
        "keywords": ["wip", "progress", "caution", "warning"],
        "char": "🚧",
        "category": "travel_and_places"
    },
    "fuelpump": {
        "keywords": ["gas station", "petroleum"],
        "char": "⛽",
        "category": "travel_and_places"
    },
    "busstop": {
        "keywords": ["transportation", "wait"],
        "char": "🚏",
        "category": "travel_and_places"
    },
    "vertical_traffic_light": {
        "keywords": ["transportation", "driving"],
        "char": "🚦",
        "category": "travel_and_places"
    },
    "traffic_light": {
        "keywords": ["transportation", "signal"],
        "char": "🚥",
        "category": "travel_and_places"
    },
    "checkered_flag": {
        "keywords": ["contest", "finishline", "race", "gokart"],
        "char": "🏁",
        "category": "travel_and_places"
    },
    "ship": {
        "keywords": ["transportation", "titanic", "deploy"],
        "char": "🚢",
        "category": "travel_and_places"
    },
    "ferris_wheel": {
        "keywords": ["photo", "carnival", "londoneye"],
        "char": "🎡",
        "category": "travel_and_places"
    },
    "roller_coaster": {
        "keywords": ["carnival", "playground", "photo", "fun"],
        "char": "🎢",
        "category": "travel_and_places"
    },
    "carousel_horse": {
        "keywords": ["photo", "carnival"],
        "char": "🎠",
        "category": "travel_and_places"
    },
    "building_construction": {
        "keywords": ["wip", "working", "progress"],
        "char": "🏗",
        "category": "travel_and_places"
    },
    "foggy": {
        "keywords": ["photo", "mountain"],
        "char": "🌁",
        "category": "travel_and_places"
    },
    "tokyo_tower": {
        "keywords": ["photo", "japanese"],
        "char": "🗼",
        "category": "travel_and_places"
    },
    "factory": {
        "keywords": ["building", "industry", "pollution", "smoke"],
        "char": "🏭",
        "category": "travel_and_places"
    },
    "fountain": {
        "keywords": ["photo", "summer", "water", "fresh"],
        "char": "⛲",
        "category": "travel_and_places"
    },
    "rice_scene": {
        "keywords": ["photo", "japan", "asia", "tsukimi"],
        "char": "🎑",
        "category": "travel_and_places"
    },
    "mountain": {
        "keywords": ["photo", "nature", "environment"],
        "char": "⛰",
        "category": "travel_and_places"
    },
    "snow_capped_mountain": {
        "keywords": ["photo", "nature", "environment", "winter", "cold"],
        "char": "🏔",
        "category": "travel_and_places"
    },
    "mount_fuji": {
        "keywords": ["photo", "mountain", "nature", "japanese"],
        "char": "🗻",
        "category": "travel_and_places"
    },
    "volcano": {
        "keywords": ["photo", "nature", "disaster"],
        "char": "🌋",
        "category": "travel_and_places"
    },
    "japan": {
        "keywords": ["nation", "country", "japanese", "asia"],
        "char": "🗾",
        "category": "travel_and_places"
    },
    "camping": {
        "keywords": ["photo", "outdoors", "tent"],
        "char": "🏕",
        "category": "travel_and_places"
    },
    "tent": {
        "keywords": ["photo", "camping", "outdoors"],
        "char": "⛺",
        "category": "travel_and_places"
    },
    "national_park": {
        "keywords": ["photo", "environment", "nature"],
        "char": "🏞",
        "category": "travel_and_places"
    },
    "motorway": {
        "keywords": ["road", "cupertino", "interstate", "highway"],
        "char": "🛣",
        "category": "travel_and_places"
    },
    "railway_track": {
        "keywords": ["train", "transportation"],
        "char": "🛤",
        "category": "travel_and_places"
    },
    "sunrise": {
        "keywords": ["morning", "view", "vacation", "photo"],
        "char": "🌅",
        "category": "travel_and_places"
    },
    "sunrise_over_mountains": {
        "keywords": ["view", "vacation", "photo"],
        "char": "🌄",
        "category": "travel_and_places"
    },
    "desert": {
        "keywords": ["photo", "warm", "saharah"],
        "char": "🏜",
        "category": "travel_and_places"
    },
    "beach_with_umbrella": {
        "keywords": ["weather", "summer", "sunny", "sand", "mojito"],
        "char": "🏖",
        "category": "travel_and_places"
    },
    "desert_island": {
        "keywords": ["photo", "tropical", "mojito"],
        "char": "🏝",
        "category": "travel_and_places"
    },
    "city_sunrise": {
        "keywords": ["photo", "good morning", "dawn"],
        "char": "🌇",
        "category": "travel_and_places"
    },
    "city_sunset": {
        "keywords": ["photo", "evening", "sky", "buildings"],
        "char": "🌆",
        "category": "travel_and_places"
    },
    "cityscape": {
        "keywords": ["photo", "night life", "urban"],
        "char": "🏙",
        "category": "travel_and_places"
    },
    "night_with_stars": {
        "keywords": ["evening", "city", "downtown"],
        "char": "🌃",
        "category": "travel_and_places"
    },
    "bridge_at_night": {
        "keywords": ["photo", "sanfrancisco"],
        "char": "🌉",
        "category": "travel_and_places"
    },
    "milky_way": {
        "keywords": ["photo", "space", "stars"],
        "char": "🌌",
        "category": "travel_and_places"
    },
    "stars": {
        "keywords": ["night", "photo"],
        "char": "🌠",
        "category": "travel_and_places"
    },
    "sparkler": {
        "keywords": ["stars", "night", "shine"],
        "char": "🎇",
        "category": "travel_and_places"
    },
    "fireworks": {
        "keywords": ["photo", "festival", "carnival", "congratulations"],
        "char": "🎆",
        "category": "travel_and_places"
    },
    "rainbow": {
        "keywords": ["nature", "happy", "unicorn", "photo", "sky", "spring"],
        "char": "🌈",
        "category": "travel_and_places"
    },
    "buildings": {
        "keywords": ["houses", "photo"],
        "char": "🏘",
        "category": "travel_and_places"
    },
    "european_castle": {
        "keywords": ["building", "royalty", "history"],
        "char": "🏰",
        "category": "travel_and_places"
    },
    "japanese_castle": {
        "keywords": ["photo", "building"],
        "char": "🏯",
        "category": "travel_and_places"
    },
    "stadium": {
        "keywords": ["photo", "place", "sports", "concert", "venue"],
        "char": "🏟",
        "category": "travel_and_places"
    },
    "statue_of_liberty": {
        "keywords": ["american", "newyork"],
        "char": "🗽",
        "category": "travel_and_places"
    },
    "house": {
        "keywords": ["building", "home"],
        "char": "🏠",
        "category": "travel_and_places"
    },
    "house_with_garden": {
        "keywords": ["home", "plant", "nature"],
        "char": "🏡",
        "category": "travel_and_places"
    },
    "derelict_house": {
        "keywords": ["abandon", "evict", "broken", "building"],
        "char": "🏚",
        "category": "travel_and_places"
    },
    "office": {
        "keywords": ["building", "bureau", "work"],
        "char": "🏢",
        "category": "travel_and_places"
    },
    "department_store": {
        "keywords": ["building", "shopping", "mall"],
        "char": "🏬",
        "category": "travel_and_places"
    },
    "post_office": {
        "keywords": ["building", "email", "communication"],
        "char": "🏣",
        "category": "travel_and_places"
    },
    "european_post_office": {
        "keywords": ["building", "email"],
        "char": "🏤",
        "category": "travel_and_places"
    },
    "hospital": {
        "keywords": ["building", "health", "surgery", "doctor"],
        "char": "🏥",
        "category": "travel_and_places"
    },
    "bank": {
        "keywords": ["building", "money", "sales", "cash", "business", "enterprise"],
        "char": "🏦",
        "category": "travel_and_places"
    },
    "hotel": {
        "keywords": ["building", "accomodation", "checkin"],
        "char": "🏨",
        "category": "travel_and_places"
    },
    "convenience_store": {
        "keywords": ["building", "shopping", "groceries"],
        "char": "🏪",
        "category": "travel_and_places"
    },
    "school": {
        "keywords": ["building", "student", "education", "learn", "teach"],
        "char": "🏫",
        "category": "travel_and_places"
    },
    "love_hotel": {
        "keywords": ["like", "affection", "dating"],
        "char": "🏩",
        "category": "travel_and_places"
    },
    "wedding": {
        "keywords": ["love", "like", "affection", "couple", "marriage", "bride", "groom"],
        "char": "💒",
        "category": "travel_and_places"
    },
    "museum": {
        "keywords": ["art", "culture", "history"],
        "char": "🏛",
        "category": "travel_and_places"
    },
    "church": {
        "keywords": ["building", "religion", "christ"],
        "char": "⛪",
        "category": "travel_and_places"
    },
    "mosque": {
        "keywords": ["islam", "worship", "minaret"],
        "char": "🕌",
        "category": "travel_and_places"
    },
    "synagogue": {
        "keywords": ["judaism", "worship", "temple", "jewish"],
        "char": "🕍",
        "category": "travel_and_places"
    },
    "kaaba": {
        "keywords": ["mecca", "mosque", "islam"],
        "char": "🕋",
        "category": "travel_and_places"
    },
    "shinto_shrine": {
        "keywords": ["temple", "japan", "kyoto"],
        "char": "⛩",
        "category": "travel_and_places"
    },
    "watch": {
        "keywords": ["time", "accessories"],
        "char": "⌚",
        "category": "objects"
    },
    "iphone": {
        "keywords": ["technology", "apple", "gadgets", "dial"],
        "char": "📱",
        "category": "objects"
    },
    "calling": {
        "keywords": ["iphone", "incoming"],
        "char": "📲",
        "category": "objects"
    },
    "computer": {
        "keywords": ["technology", "laptop", "screen", "display", "monitor"],
        "char": "💻",
        "category": "objects"
    },
    "keyboard": {
        "keywords": ["technology", "computer", "type", "input", "text"],
        "char": "⌨",
        "category": "objects"
    },
    "desktop_computer": {
        "keywords": ["technology", "computing", "screen"],
        "char": "🖥",
        "category": "objects"
    },
    "printer": {
        "keywords": ["paper", "ink"],
        "char": "🖨",
        "category": "objects"
    },
    "three_button_mouse": {
        "keywords": ["click"],
        "char": "🖱",
        "category": "objects"
    },
    "trackball": {
        "keywords": ["technology", "trackpad"],
        "char": "🖲",
        "category": "objects"
    },
    "joystick": {
        "keywords": ["game", "play"],
        "char": "🕹",
        "category": "objects"
    },
    "compression": {
        "keywords": ["tool"],
        "char": "🗜",
        "category": "objects"
    },
    "minidisc": {
        "keywords": ["technology", "record", "data", "disk", "90s"],
        "char": "💽",
        "category": "objects"
    },
    "floppy_disk": {
        "keywords": ["oldschool", "technology", "save", "90s", "80s"],
        "char": "💾",
        "category": "objects"
    },
    "cd": {
        "keywords": ["technology", "dvd", "disk", "disc", "90s"],
        "char": "💿",
        "category": "objects"
    },
    "dvd": {
        "keywords": ["cd", "disk", "disc"],
        "char": "📀",
        "category": "objects"
    },
    "vhs": {
        "keywords": ["record", "video", "oldschool", "90s", "80s"],
        "char": "📼",
        "category": "objects"
    },
    "camera": {
        "keywords": ["gadgets", "photography"],
        "char": "📷",
        "category": "objects"
    },
    "camera_with_flash": {
        "keywords": ["photography", "gadgets"],
        "char": "📸",
        "category": "objects"
    },
    "video_camera": {
        "keywords": ["film", "record"],
        "char": "📹",
        "category": "objects"
    },
    "movie_camera": {
        "keywords": ["film", "record"],
        "char": "🎥",
        "category": "objects"
    },
    "film_projector": {
        "keywords": ["video", "tape", "record", "movie"],
        "char": "📽",
        "category": "objects"
    },
    "film_frames": {
        "keywords": ["movie"],
        "char": "🎞",
        "category": "objects"
    },
    "telephone_receiver": {
        "keywords": ["technology", "communication", "dial"],
        "char": "📞",
        "category": "objects"
    },
    "phone": {
        "keywords": ["technology", "communication", "dial", "telephone"],
        "char": "☎️",
        "category": "objects"
    },
    "pager": {
        "keywords": ["bbcall", "oldschool", "90s"],
        "char": "📟",
        "category": "objects"
    },
    "fax": {
        "keywords": ["communication", "technology"],
        "char": "📠",
        "category": "objects"
    },
    "tv": {
        "keywords": ["technology", "program", "oldschool", "show", "television"],
        "char": "📺",
        "category": "objects"
    },
    "radio": {
        "keywords": ["communication", "music", "podcast", "program"],
        "char": "📻",
        "category": "objects"
    },
    "studio_microphone": {
        "keywords": ["singer", "recording", "artist"],
        "char": "🎙",
        "category": "objects"
    },
    "level_slider": {
        "keywords": ["scale"],
        "char": "🎚",
        "category": "objects"
    },
    "control_knobs": {
        "keywords": ["dial"],
        "char": "🎛",
        "category": "objects"
    },
    "stopwatch": {
        "keywords": ["time", "deadline"],
        "char": "⏱",
        "category": "objects"
    },
    "timer_clock": {
        "keywords": ["alarm"],
        "char": "⏲",
        "category": "objects"
    },
    "alarm_clock": {
        "keywords": ["time", "wake"],
        "char": "⏰",
        "category": "objects"
    },
    "mantelpiece_clock": {
        "keywords": ["time"],
        "char": "🕰",
        "category": "objects"
    },
    "hourglass_flowing_sand": {
        "keywords": ["oldschool", "time", "countdown"],
        "char": "⏳",
        "category": "objects"
    },
    "hourglass": {
        "keywords": ["time", "clock", "oldschool", "limit", "exam", "quiz", "test"],
        "char": "⌛",
        "category": "objects"
    },
    "satellite": {
        "keywords": ["communication", "future", "radio", "space"],
        "char": "📡",
        "category": "objects"
    },
    "battery": {
        "keywords": ["power", "energy", "sustain"],
        "char": "🔋",
        "category": "objects"
    },
    "electric_plug": {
        "keywords": ["charger", "power"],
        "char": "🔌",
        "category": "objects"
    },
    "bulb": {
        "keywords": ["light", "electricity", "idea"],
        "char": "💡",
        "category": "objects"
    },
    "flashlight": {
        "keywords": ["dark", "camping", "sight", "night"],
        "char": "🔦",
        "category": "objects"
    },
    "candle": {
        "keywords": ["fire", "wax"],
        "char": "🕯",
        "category": "objects"
    },
    "wastebasket": {
        "keywords": ["bin", "trash", "rubbish", "garbage", "toss"],
        "char": "🗑",
        "category": "objects"
    },
    "oil_drum": {
        "keywords": ["barrell"],
        "char": "🛢",
        "category": "objects"
    },
    "money_with_wings": {
        "keywords": ["dollar", "bills", "payment", "sale"],
        "char": "💸",
        "category": "objects"
    },
    "dollar": {
        "keywords": ["money", "sales", "bill", "currency"],
        "char": "💵",
        "category": "objects"
    },
    "yen": {
        "keywords": ["money", "sales", "japanese", "dollar", "currency"],
        "char": "💴",
        "category": "objects"
    },
    "euro": {
        "keywords": ["money", "sales", "dollar", "currency"],
        "char": "💶",
        "category": "objects"
    },
    "pound": {
        "keywords": ["british", "sterling", "money", "sales", "bills", "uk", "england", "currency"],
        "char": "💷",
        "category": "objects"
    },
    "moneybag": {
        "keywords": ["dollar", "payment", "coins", "sale"],
        "char": "💰",
        "category": "objects"
    },
    "credit_card": {
        "keywords": ["money", "sales", "dollar", "bill", "payment", "shopping"],
        "char": "💳",
        "category": "objects"
    },
    "gem": {
        "keywords": ["blue", "ruby", "diamond", "jewelry"],
        "char": "💎",
        "category": "objects"
    },
    "scales": {
        "keywords": ["law", "fairness", "weight"],
        "char": "⚖",
        "category": "objects"
    },
    "wrench": {
        "keywords": ["tools", "diy", "ikea", "fix", "maintainer"],
        "char": "🔧",
        "category": "objects"
    },
    "hammer": {
        "keywords": ["tools", "build", "create"],
        "char": "🔨",
        "category": "objects"
    },
    "hammer_and_pick": {
        "keywords": ["tools", "build", "create"],
        "char": "⚒",
        "category": "objects"
    },
    "hammer_and_wrench": {
        "keywords": ["tools", "build", "create"],
        "char": "🛠",
        "category": "objects"
    },
    "pick": {
        "keywords": ["tools", "dig"],
        "char": "⛏",
        "category": "objects"
    },
    "nut_and_bolt": {
        "keywords": ["handy", "tools", "fix"],
        "char": "🔩",
        "category": "objects"
    },
    "gear": {
        "keywords": ["cog"],
        "char": "⚙",
        "category": "objects"
    },
    "chains": {
        "keywords": ["lock", "arrest"],
        "char": "⛓",
        "category": "objects"
    },
    "gun": {
        "keywords": ["violence", "weapon", "pistol", "revolver"],
        "char": "🔫",
        "category": "objects"
    },
    "bomb": {
        "keywords": ["boom", "explode", "explosion", "terrorism"],
        "char": "💣",
        "category": "objects"
    },
    "hocho": {
        "keywords": ["knife", "blade", "cutlery", "kitchen", "weapon"],
        "char": "🔪",
        "category": "objects"
    },
    "dagger_knife": {
        "keywords": ["weapon"],
        "char": "🗡",
        "category": "objects"
    },
    "crossed_swords": {
        "keywords": ["weapon"],
        "char": "⚔",
        "category": "objects"
    },
    "shield": {
        "keywords": ["protection", "security"],
        "char": "🛡",
        "category": "objects"
    },
    "smoking": {
        "keywords": ["kills", "tobacco", "cigarette", "joint", "smoke"],
        "char": "🚬",
        "category": "objects"
    },
    "skull_and_crossbones": {
        "keywords": ["poison", "danger", "deadly", "scary"],
        "char": "☠",
        "category": "objects"
    },
    "coffin": {
        "keywords": ["vampire", "dead", "die", "death", "rip", "graveyard", "cemetery"],
        "char": "⚰",
        "category": "objects"
    },
    "funeral_urn": {
        "keywords": ["dead", "die", "death", "rip", "ashes"],
        "char": "⚱",
        "category": "objects"
    },
    "amphora": {
        "keywords": ["vase", "jar"],
        "char": "🏺",
        "category": "objects"
    },
    "crystal_ball": {
        "keywords": ["disco", "party", "magic", "circus", "fortune_teller"],
        "char": "🔮",
        "category": "objects"
    },
    "prayer_beads": {
        "keywords": ["dhikr", "religious"],
        "char": "📿",
        "category": "objects"
    },
    "barber": {
        "keywords": ["hair", "salon", "style"],
        "char": "💈",
        "category": "objects"
    },
    "alembic": {
        "keywords": ["distilling", "science", "experiment"],
        "char": "⚗",
        "category": "objects"
    },
    "telescope": {
        "keywords": ["stars", "space", "zoom"],
        "char": "🔭",
        "category": "objects"
    },
    "microscope": {
        "keywords": ["laboratory", "experiment", "zoomin", "science", "study"],
        "char": "🔬",
        "category": "objects"
    },
    "hole": {
        "keywords": ["embarrassing"],
        "char": "🕳",
        "category": "objects"
    },
    "pill": {
        "keywords": ["health", "medicine", "doctor", "pharmacy", "drug"],
        "char": "💊",
        "category": "objects"
    },
    "syringe": {
        "keywords": ["health", "hospital", "drugs", "blood", "medicine", "needle", "doctor", "nurse"],
        "char": "💉",
        "category": "objects"
    },
    "thermometer": {
        "keywords": ["weather", "temperature", "hot", "cold"],
        "char": "🌡",
        "category": "objects"
    },
    "label": {
        "keywords": ["sale", "tag"],
        "char": "🏷",
        "category": "objects"
    },
    "bookmark": {
        "keywords": ["favorite", "label", "save"],
        "char": "🔖",
        "category": "objects"
    },
    "toilet": {
        "keywords": ["restroom", "wc", "washroom", "bathroom", "potty"],
        "char": "🚽",
        "category": "objects"
    },
    "shower": {
        "keywords": ["clean", "water", "bathroom"],
        "char": "🚿",
        "category": "objects"
    },
    "bathtub": {
        "keywords": ["clean", "shower", "bathroom"],
        "char": "🛁",
        "category": "objects"
    },
    "key": {
        "keywords": ["lock", "door", "password"],
        "char": "🔑",
        "category": "objects"
    },
    "old_key": {
        "keywords": ["lock", "door", "password"],
        "char": "🗝",
        "category": "objects"
    },
    "couch_and_lamp": {
        "keywords": ["read", "chill"],
        "char": "🛋",
        "category": "objects"
    },
    "sleeping_accommodation": {
        "keywords": ["bed", "rest"],
        "char": "🛌",
        "category": "objects"
    },
    "bed": {
        "keywords": ["sleep", "rest"],
        "char": "🛏",
        "category": "objects"
    },
    "door": {
        "keywords": ["house", "entry", "exit"],
        "char": "🚪",
        "category": "objects"
    },
    "bellhop_bell": {
        "keywords": ["service"],
        "char": "🛎",
        "category": "objects"
    },
    "frame_with_picture": {
        "keywords": ["photography"],
        "char": "🖼",
        "category": "objects"
    },
    "world_map": {
        "keywords": ["location", "direction"],
        "char": "🗺",
        "category": "objects"
    },
    "umbrella_on_ground": {
        "keywords": ["weather", "summer"],
        "char": "⛱",
        "category": "objects"
    },
    "moyai": {
        "keywords": ["rock", "easter island", "moai"],
        "char": "🗿",
        "category": "objects"
    },
    "shopping_bags": {
        "keywords": ["mall", "buy", "purchase"],
        "char": "🛍",
        "category": "objects"
    },
    "balloon": {
        "keywords": ["party", "celebration", "birthday", "circus"],
        "char": "🎈",
        "category": "objects"
    },
    "flags": {
        "keywords": ["fish", "japanese", "koinobori", "carp", "banner"],
        "char": "🎏",
        "category": "objects"
    },
    "ribbon": {
        "keywords": ["decoration", "pink", "girl", "bowtie"],
        "char": "🎀",
        "category": "objects"
    },
    "gift": {
        "keywords": ["present", "birthday", "christmas", "xmas"],
        "char": "🎁",
        "category": "objects"
    },
    "confetti_ball": {
        "keywords": ["festival", "party", "birthday", "circus"],
        "char": "🎊",
        "category": "objects"
    },
    "tada": {
        "keywords": ["party", "contulations", "birthday", "magic", "circus"],
        "char": "🎉",
        "category": "objects"
    },
    "dolls": {
        "keywords": ["japanese", "toy", "kimono"],
        "char": "🎎",
        "category": "objects"
    },
    "wind_chime": {
        "keywords": ["nature", "ding", "spring", "bell"],
        "char": "🎐",
        "category": "objects"
    },
    "crossed_flags": {
        "keywords": ["japanese", "nation", "country", "border"],
        "char": "🎌",
        "category": "objects"
    },
    "izakaya_lantern": {
        "keywords": ["light", "paper", "halloween", "spooky"],
        "char": "🏮",
        "category": "objects"
    },
    "envelope": {
        "keywords": ["letter", "postal", "inbox", "communication"],
        "char": "✉️",
        "category": "objects"
    },
    "envelope_with_arrow": {
        "keywords": ["email", "communication"],
        "char": "📩",
        "category": "objects"
    },
    "incoming_envelope": {
        "keywords": ["email", "inbox"],
        "char": "📨",
        "category": "objects"
    },
    "email": {
        "keywords": ["communication", "inbox"],
        "char": "📧",
        "category": "objects"
    },
    "love_letter": {
        "keywords": ["email", "like", "affection", "envelope", "valentines"],
        "char": "💌",
        "category": "objects"
    },
    "postbox": {
        "keywords": ["email", "letter", "envelope"],
        "char": "📮",
        "category": "objects"
    },
    "mailbox_closed": {
        "keywords": ["email", "communication", "inbox"],
        "char": "📪",
        "category": "objects"
    },
    "mailbox": {
        "keywords": ["email", "inbox", "communication"],
        "char": "📫",
        "category": "objects"
    },
    "mailbox_with_mail": {
        "keywords": ["email", "inbox", "communication"],
        "char": "📬",
        "category": "objects"
    },
    "mailbox_with_no_mail": {
        "keywords": ["email", "inbox"],
        "char": "📭",
        "category": "objects"
    },
    "package": {
        "keywords": ["mail", "gift", "cardboard", "box", "moving"],
        "char": "📦",
        "category": "objects"
    },
    "postal_horn": {
        "keywords": ["instrument", "music"],
        "char": "📯",
        "category": "objects"
    },
    "inbox_tray": {
        "keywords": ["email", "documents"],
        "char": "📥",
        "category": "objects"
    },
    "outbox_tray": {
        "keywords": ["inbox", "email"],
        "char": "📤",
        "category": "objects"
    },
    "scroll": {
        "keywords": ["documents", "ancient", "history", "paper"],
        "char": "📜",
        "category": "objects"
    },
    "page_with_curl": {
        "keywords": ["documents", "office", "paper"],
        "char": "📃",
        "category": "objects"
    },
    "bookmark_tabs": {
        "keywords": ["favorite", "save", "order", "tidy"],
        "char": "📑",
        "category": "objects"
    },
    "bar_chart": {
        "keywords": ["graph", "presentation", "stats"],
        "char": "📊",
        "category": "objects"
    },
    "chart_with_upwards_trend": {
        "keywords": ["graph", "presentation", "stats", "recovery", "business", "economics", "money", "sales", "good", "success"],
        "char": "📈",
        "category": "objects"
    },
    "chart_with_downwards_trend": {
        "keywords": ["graph", "presentation", "stats", "recession", "business", "economics", "money", "sales", "bad", "failure"],
        "char": "📉",
        "category": "objects"
    },
    "page_facing_up": {
        "keywords": ["documents", "office", "paper", "information"],
        "char": "📄",
        "category": "objects"
    },
    "date": {
        "keywords": ["calendar", "schedule"],
        "char": "📅",
        "category": "objects"
    },
    "calendar": {
        "keywords": ["schedule", "date", "planning"],
        "char": "📆",
        "category": "objects"
    },
    "spiral_calendar_pad": {
        "keywords": ["date", "schedule", "planning"],
        "char": "🗓",
        "category": "objects"
    },
    "card_index": {
        "keywords": ["business", "stationery"],
        "char": "📇",
        "category": "objects"
    },
    "card_file_box": {
        "keywords": ["business", "stationery"],
        "char": "🗃",
        "category": "objects"
    },
    "ballot_box_with_ballot": {
        "keywords": ["election", "vote"],
        "char": "🗳",
        "category": "objects"
    },
    "file_cabinet": {
        "keywords": ["filing", "organizing"],
        "char": "🗄",
        "category": "objects"
    },
    "clipboard": {
        "keywords": ["stationery", "documents"],
        "char": "📋",
        "category": "objects"
    },
    "spiral_note_pad": {
        "keywords": ["memo", "stationery"],
        "char": "🗒",
        "category": "objects"
    },
    "file_folder": {
        "keywords": ["documents", "business", "office"],
        "char": "📁",
        "category": "objects"
    },
    "open_file_folder": {
        "keywords": ["documents", "load"],
        "char": "📂",
        "category": "objects"
    },
    "card_index_dividers": {
        "keywords": ["organizing", "business", "stationery"],
        "char": "🗂",
        "category": "objects"
    },
    "rolled_up_newspaper": {
        "keywords": ["press", "headline"],
        "char": "🗞",
        "category": "objects"
    },
    "newspaper": {
        "keywords": ["press", "headline"],
        "char": "📰",
        "category": "objects"
    },
    "notebook": {
        "keywords": ["stationery", "record", "notes", "paper", "study"],
        "char": "📓",
        "category": "objects"
    },
    "closed_book": {
        "keywords": ["read", "library", "knowledge", "textbook", "learn"],
        "char": "📕",
        "category": "objects"
    },
    "green_book": {
        "keywords": ["read", "library", "knowledge", "study"],
        "char": "📗",
        "category": "objects"
    },
    "blue_book": {
        "keywords": ["read", "library", "knowledge", "learn", "study"],
        "char": "📘",
        "category": "objects"
    },
    "orange_book": {
        "keywords": ["read", "library", "knowledge", "textbook", "study"],
        "char": "📙",
        "category": "objects"
    },
    "notebook_with_decorative_cover": {
        "keywords": ["classroom", "notes", "record", "paper", "study"],
        "char": "📔",
        "category": "objects"
    },
    "ledger": {
        "keywords": ["notes", "paper"],
        "char": "📒",
        "category": "objects"
    },
    "books": {
        "keywords": ["literature", "library", "study"],
        "char": "📚",
        "category": "objects"
    },
    "book": {
        "keywords": ["open_book", "read", "library", "knowledge", "literature", "learn", "study"],
        "char": "📖",
        "category": "objects"
    },
    "link": {
        "keywords": ["rings", "url"],
        "char": "🔗",
        "category": "objects"
    },
    "paperclip": {
        "keywords": ["documents", "stationery"],
        "char": "📎",
        "category": "objects"
    },
    "linked_paperclips": {
        "keywords": ["documents", "stationery"],
        "char": "🖇",
        "category": "objects"
    },
    "scissors": {
        "keywords": ["stationery", "cut"],
        "char": "✂️",
        "category": "objects"
    },
    "triangular_ruler": {
        "keywords": ["stationery", "math", "architect", "sketch"],
        "char": "📐",
        "category": "objects"
    },
    "straight_ruler": {
        "keywords": ["stationery", "calculate", "length", "math", "school", "drawing", "architect", "sketch"],
        "char": "📏",
        "category": "objects"
    },
    "pushpin": {
        "keywords": ["stationery", "mark", "here"],
        "char": "📌",
        "category": "objects"
    },
    "round_pushpin": {
        "keywords": ["stationery", "location", "map", "here"],
        "char": "📍",
        "category": "objects"
    },
    "triangular_flag_on_post": {
        "keywords": ["mark", "milestone", "place"],
        "char": "🚩",
        "category": "objects"
    },
    "waving_white_flag": {
        "keywords": ["losing", "loser", "lost", "surrender", "give up", "fail"],
        "char": "🏳",
        "category": "objects"
    },
    "waving_black_flag": {
        "keywords": ["pirate"],
        "char": "🏴",
        "category": "objects"
    },
    "closed_lock_with_key": {
        "keywords": ["security", "privacy"],
        "char": "🔐",
        "category": "objects"
    },
    "lock": {
        "keywords": ["security", "password", "padlock"],
        "char": "🔒",
        "category": "objects"
    },
    "unlock": {
        "keywords": ["privacy", "security"],
        "char": "🔓",
        "category": "objects"
    },
    "lock_with_ink_pen": {
        "keywords": ["security", "secret"],
        "char": "🔏",
        "category": "objects"
    },
    "lower_left_ballpoint_pen": {
        "keywords": ["stationery", "writing", "write"],
        "char": "🖊",
        "category": "objects"
    },
    "lower_left_fountain_pen": {
        "keywords": ["stationery", "writing", "write"],
        "char": "🖋",
        "category": "objects"
    },
    "black_nib": {
        "keywords": ["pen", "stationery", "writing", "write"],
        "char": "✒️",
        "category": "objects"
    },
    "memo": {
        "keywords": ["write", "documents", "stationery", "pencil", "paper", "writing", "legal", "exam", "quiz", "test", "study"],
        "char": "📝",
        "category": "objects"
    },
    "pencil2": {
        "keywords": ["stationery", "write", "paper", "writing", "school", "study"],
        "char": "✏️",
        "category": "objects"
    },
    "lower_left_crayon": {
        "keywords": ["drawing", "creativity"],
        "char": "🖍",
        "category": "objects"
    },
    "lower_left_paintbrush": {
        "keywords": ["drawing", "creativity", "art"],
        "char": "🖌",
        "category": "objects"
    },
    "mag": {
        "keywords": ["search", "zoom", "find", "detective"],
        "char": "🔍",
        "category": "objects"
    },
    "mag_right": {
        "keywords": ["search", "zoom", "find", "detective"],
        "char": "🔎",
        "category": "objects"
    },
    "heart": {
        "keywords": ["love", "like", "valentines"],
        "char": "❤️",
        "category": "symbols"
    },
    "yellow_heart": {
        "keywords": ["love", "like", "affection", "valentines"],
        "char": "💛",
        "category": "symbols"
    },
    "green_heart": {
        "keywords": ["love", "like", "affection", "valentines"],
        "char": "💚",
        "category": "symbols"
    },
    "blue_heart": {
        "keywords": ["love", "like", "affection", "valentines"],
        "char": "💙",
        "category": "symbols"
    },
    "purple_heart": {
        "keywords": ["love", "like", "affection", "valentines"],
        "char": "💜",
        "category": "symbols"
    },
    "broken_heart": {
        "keywords": ["sad", "sorry", "break", "heart", "heartbreak"],
        "char": "💔",
        "category": "symbols"
    },
    "heavy_heart_exclamation_mark_ornament": {
        "keywords": ["decoration", "love"],
        "char": "❣",
        "category": "symbols"
    },
    "two_hearts": {
        "keywords": ["love", "like", "affection", "valentines", "heart"],
        "char": "💕",
        "category": "symbols"
    },
    "revolving_hearts": {
        "keywords": ["love", "like", "affection", "valentines"],
        "char": "💞",
        "category": "symbols"
    },
    "heartbeat": {
        "keywords": ["love", "like", "affection", "valentines", "pink", "heart"],
        "char": "💓",
        "category": "symbols"
    },
    "heartpulse": {
        "keywords": ["like", "love", "affection", "valentines", "pink"],
        "char": "💗",
        "category": "symbols"
    },
    "sparkling_heart": {
        "keywords": ["love", "like", "affection", "valentines"],
        "char": "💖",
        "category": "symbols"
    },
    "cupid": {
        "keywords": ["love", "like", "heart", "affection", "valentines"],
        "char": "💘",
        "category": "symbols"
    },
    "gift_heart": {
        "keywords": ["love", "valentines"],
        "char": "💝",
        "category": "symbols"
    },
    "heart_decoration": {
        "keywords": ["purple-square", "love", "like"],
        "char": "💟",
        "category": "symbols"
    },
    "peace_symbol": {
        "keywords": ["hippie"],
        "char": "☮",
        "category": "symbols"
    },
    "latin_cross": {
        "keywords": ["christianity"],
        "char": "✝",
        "category": "symbols"
    },
    "star_and_crescent": {
        "keywords": ["islam"],
        "char": "☪",
        "category": "symbols"
    },
    "om_symbol": {
        "keywords": ["hinduism", "buddhism", "sikhism", "jainism"],
        "char": "🕉",
        "category": "symbols"
    },
    "wheel_of_dharma": {
        "keywords": ["hinduism", "buddhism", "sikhism", "jainism"],
        "char": "☸",
        "category": "symbols"
    },
    "star_of_david": {
        "keywords": ["judaism"],
        "char": "✡",
        "category": "symbols"
    },
    "six_pointed_star": {
        "keywords": ["purple-square", "religion", "jewish", "hexagram"],
        "char": "🔯",
        "category": "symbols"
    },
    "menorah_with_nine_branches": {
        "keywords": ["hanukkah", "candles", "jewish"],
        "char": "🕎",
        "category": "symbols"
    },
    "yin_yang": {
        "keywords": ["balance"],
        "char": "☯",
        "category": "symbols"
    },
    "orthodox_cross": {
        "keywords": ["suppedaneum", "religion"],
        "char": "☦",
        "category": "symbols"
    },
    "place_of_worship": {
        "keywords": ["religion", "church", "temple", "prayer"],
        "char": "🛐",
        "category": "symbols"
    },
    "ophiuchus": {
        "keywords": ["sign", "purple-square", "constellation", "astrology"],
        "char": "⛎",
        "category": "symbols"
    },
    "aries": {
        "keywords": ["sign", "purple-square", "zodiac", "astrology"],
        "char": "♈",
        "category": "symbols"
    },
    "taurus": {
        "keywords": ["purple-square", "sign", "zodiac", "astrology"],
        "char": "♉",
        "category": "symbols"
    },
    "gemini": {
        "keywords": ["sign", "zodiac", "purple-square", "astrology"],
        "char": "♊",
        "category": "symbols"
    },
    "cancer": {
        "keywords": ["sign", "zodiac", "purple-square", "astrology"],
        "char": "♋",
        "category": "symbols"
    },
    "leo": {
        "keywords": ["sign", "purple-square", "zodiac", "astrology"],
        "char": "♌",
        "category": "symbols"
    },
    "virgo": {
        "keywords": ["sign", "zodiac", "purple-square", "astrology"],
        "char": "♍",
        "category": "symbols"
    },
    "libra": {
        "keywords": ["sign", "purple-square", "zodiac", "astrology"],
        "char": "♎",
        "category": "symbols"
    },
    "scorpius": {
        "keywords": ["sign", "zodiac", "purple-square", "astrology", "scorpio"],
        "char": "♏",
        "category": "symbols"
    },
    "sagittarius": {
        "keywords": ["sign", "zodiac", "purple-square", "astrology"],
        "char": "♐",
        "category": "symbols"
    },
    "capricorn": {
        "keywords": ["sign", "zodiac", "purple-square", "astrology"],
        "char": "♑",
        "category": "symbols"
    },
    "aquarius": {
        "keywords": ["sign", "purple-square", "zodiac", "astrology"],
        "char": "♒",
        "category": "symbols"
    },
    "pisces": {
        "keywords": ["purple-square", "sign", "zodiac", "astrology"],
        "char": "♓",
        "category": "symbols"
    },
    "id": {
        "keywords": ["purple-square", "words"],
        "char": "🆔",
        "category": "symbols"
    },
    "atom_symbol": {
        "keywords": ["science"],
        "char": "⚛",
        "category": "symbols"
    },
    "u7a7a": {
        "keywords": ["kanji", "japanese", "chinese", "empty", "sky", "blue-square"],
        "char": "🈳",
        "category": "symbols"
    },
    "u5272": {
        "keywords": ["cut", "divide", "chinese", "kanji", "pink-square"],
        "char": "🈹",
        "category": "symbols"
    },
    "radioactive_sign": {
        "keywords": ["nuclear", "danger"],
        "char": "☢",
        "category": "symbols"
    },
    "biohazard_sign": {
        "keywords": ["danger"],
        "char": "☣",
        "category": "symbols"
    },
    "mobile_phone_off": {
        "keywords": ["mute", "orange-square", "silence", "quiet"],
        "char": "📴",
        "category": "symbols"
    },
    "vibration_mode": {
        "keywords": ["orange-square", "phone"],
        "char": "📳",
        "category": "symbols"
    },
    "u6709": {
        "keywords": ["orange-square", "chinese", "have", "kanji"],
        "char": "🈶",
        "category": "symbols"
    },
    "u7121": {
        "keywords": ["nothing", "chinese", "kanji", "japanese", "orange-square"],
        "char": "🈚",
        "category": "symbols"
    },
    "u7533": {
        "keywords": ["chinese", "japanese", "kanji", "orange-square"],
        "char": "🈸",
        "category": "symbols"
    },
    "u55b6": {
        "keywords": ["japanese", "opening hours", "orange-square"],
        "char": "🈺",
        "category": "symbols"
    },
    "u6708": {
        "keywords": ["chinese", "month", "moon", "japanese", "orange-square", "kanji"],
        "char": "🈷️",
        "category": "symbols"
    },
    "eight_pointed_black_star": {
        "keywords": ["orange-square", "shape", "polygon"],
        "char": "✴️",
        "category": "symbols"
    },
    "vs": {
        "keywords": ["words", "orange-square"],
        "char": "🆚",
        "category": "symbols"
    },
    "accept": {
        "keywords": ["ok", "good", "chinese", "kanji", "agree", "yes", "orange-circle"],
        "char": "🉑",
        "category": "symbols"
    },
    "white_flower": {
        "keywords": ["japanese", "spring"],
        "char": "💮",
        "category": "symbols"
    },
    "ideograph_advantage": {
        "keywords": ["chinese", "kanji", "obtain", "get", "circle"],
        "char": "🉐",
        "category": "symbols"
    },
    "secret": {
        "keywords": ["privacy", "chinese", "sshh", "kanji", "red-circle"],
        "char": "㊙️",
        "category": "symbols"
    },
    "congratulations": {
        "keywords": ["chinese", "kanji", "japanese", "red-circle"],
        "char": "㊗️",
        "category": "symbols"
    },
    "u5408": {
        "keywords": ["japanese", "chinese", "join", "kanji", "red-square"],
        "char": "🈴",
        "category": "symbols"
    },
    "u6e80": {
        "keywords": ["full", "chinese", "japanese", "red-square", "kanji"],
        "char": "🈵",
        "category": "symbols"
    },
    "u7981": {
        "keywords": ["kanji", "japanese", "chinese", "forbidden", "limit", "restricted", "red-square"],
        "char": "🈲",
        "category": "symbols"
    },
    "a": {
        "keywords": ["red-square", "alphabet", "letter"],
        "char": "🅰️",
        "category": "symbols"
    },
    "b": {
        "keywords": ["red-square", "alphabet", "letter"],
        "char": "🅱️",
        "category": "symbols"
    },
    "ab": {
        "keywords": ["red-square", "alphabet"],
        "char": "🆎",
        "category": "symbols"
    },
    "cl": {
        "keywords": ["alphabet", "words", "red-square"],
        "char": "🆑",
        "category": "symbols"
    },
    "o2": {
        "keywords": ["alphabet", "red-square", "letter"],
        "char": "🅾️",
        "category": "symbols"
    },
    "sos": {
        "keywords": ["help", "red-square", "words", "emergency", "911"],
        "char": "🆘",
        "category": "symbols"
    },
    "no_entry": {
        "keywords": ["limit", "security", "privacy", "bad", "denied", "stop", "circle"],
        "char": "⛔",
        "category": "symbols"
    },
    "name_badge": {
        "keywords": ["fire", "forbid"],
        "char": "📛",
        "category": "symbols"
    },
    "no_entry_sign": {
        "keywords": ["forbid", "stop", "limit", "denied", "disallow", "circle"],
        "char": "🚫",
        "category": "symbols"
    },
    "x": {
        "keywords": ["no", "delete", "remove", "cancel"],
        "char": "❌",
        "category": "symbols"
    },
    "o": {
        "keywords": ["circle", "round"],
        "char": "⭕",
        "category": "symbols"
    },
    "anger": {
        "keywords": ["angry", "mad"],
        "char": "💢",
        "category": "symbols"
    },
    "hotsprings": {
        "keywords": ["bath", "warm", "relax"],
        "char": "♨️",
        "category": "symbols"
    },
    "no_pedestrians": {
        "keywords": ["rules", "crossing", "walking", "circle"],
        "char": "🚷",
        "category": "symbols"
    },
    "do_not_litter": {
        "keywords": ["trash", "bin", "garbage", "circle"],
        "char": "🚯",
        "category": "symbols"
    },
    "no_bicycles": {
        "keywords": ["cyclist", "prohibited", "circle"],
        "char": "🚳",
        "category": "symbols"
    },
    "non-potable_water": {
        "keywords": ["drink", "faucet", "tap", "circle"],
        "char": "🚱",
        "category": "symbols"
    },
    "underage": {
        "keywords": ["18", "drink", "pub", "night", "minor", "circle"],
        "char": "🔞",
        "category": "symbols"
    },
    "no_mobile_phones": {
        "keywords": ["iphone", "mute", "circle"],
        "char": "📵",
        "category": "symbols"
    },
    "exclamation": {
        "keywords": ["heavy_exclamation_mark", "danger", "surprise", "punctuation", "wow", "warning"],
        "char": "❗",
        "category": "symbols"
    },
    "grey_exclamation": {
        "keywords": ["surprise", "punctuation", "gray", "wow", "warning"],
        "char": "❕",
        "category": "symbols"
    },
    "question": {
        "keywords": ["doubt", "confused"],
        "char": "❓",
        "category": "symbols"
    },
    "grey_question": {
        "keywords": ["doubts", "gray", "huh", "confused"],
        "char": "❔",
        "category": "symbols"
    },
    "bangbang": {
        "keywords": ["exclamation", "surprise"],
        "char": "‼️",
        "category": "symbols"
    },
    "interrobang": {
        "keywords": ["wat", "punctuation", "surprise"],
        "char": "⁉️",
        "category": "symbols"
    },
    "100": {
        "keywords": ["score", "perfect", "numbers", "century", "exam", "quiz", "test", "pass", "hundred"],
        "char": "💯",
        "category": "symbols"
    },
    "low_brightness": {
        "keywords": ["sun", "afternoon", "warm", "summer"],
        "char": "🔅",
        "category": "symbols"
    },
    "high_brightness": {
        "keywords": ["sun", "light"],
        "char": "🔆",
        "category": "symbols"
    },
    "trident": {
        "keywords": ["weapon", "spear"],
        "char": "🔱",
        "category": "symbols"
    },
    "fleur_de_lis": {
        "keywords": ["decorative", "scout"],
        "char": "⚜",
        "category": "symbols"
    },
    "part_alternation_mark": {
        "keywords": ["graph", "presentation", "stats", "business", "economics", "bad"],
        "char": "〽️",
        "category": "symbols"
    },
    "warning": {
        "keywords": ["exclamation", "wip", "alert", "error", "problem", "issue"],
        "char": "⚠️",
        "category": "symbols"
    },
    "children_crossing": {
        "keywords": ["school", "warning", "danger", "sign", "driving", "yellow-diamond"],
        "char": "🚸",
        "category": "symbols"
    },
    "beginner": {
        "keywords": ["badge", "shield"],
        "char": "🔰",
        "category": "symbols"
    },
    "recycle": {
        "keywords": ["arrow", "environment", "garbage", "trash"],
        "char": "♻️",
        "category": "symbols"
    },
    "u6307": {
        "keywords": ["chinese", "point", "green-square", "kanji"],
        "char": "🈯",
        "category": "symbols"
    },
    "chart": {
        "keywords": ["green-square", "graph", "presentation", "stats"],
        "char": "💹",
        "category": "symbols"
    },
    "sparkle": {
        "keywords": ["stars", "green-square", "awesome", "good", "fireworks"],
        "char": "❇️",
        "category": "symbols"
    },
    "eight_spoked_asterisk": {
        "keywords": ["star", "sparkle", "green-square"],
        "char": "✳️",
        "category": "symbols"
    },
    "negative_squared_cross_mark": {
        "keywords": ["x", "green-square", "no", "deny"],
        "char": "❎",
        "category": "symbols"
    },
    "white_check_mark": {
        "keywords": ["green-square", "ok", "agree", "vote", "election", "answer"],
        "char": "✅",
        "category": "symbols"
    },
    "diamond_shape_with_a_dot_inside": {
        "keywords": ["jewel", "blue", "gem", "crystal", "fancy"],
        "char": "💠",
        "category": "symbols"
    },
    "cyclone": {
        "keywords": ["weather", "swirl", "blue", "cloud", "vortex", "spiral", "whirlpool", "spin"],
        "char": "🌀",
        "category": "symbols"
    },
    "loop": {
        "keywords": ["tape", "cassette"],
        "char": "➿",
        "category": "symbols"
    },
    "globe_with_meridians": {
        "keywords": ["earth", "international", "world", "internet", "interweb", "i18n"],
        "char": "🌐",
        "category": "symbols"
    },
    "m": {
        "keywords": ["alphabet", "blue-circle", "letter"],
        "char": "Ⓜ️",
        "category": "symbols"
    },
    "atm": {
        "keywords": ["money", "sales", "cash", "blue-square", "payment", "bank"],
        "char": "🏧",
        "category": "symbols"
    },
    "sa": {
        "keywords": ["japanese", "blue-square", "katakana"],
        "char": "🈂️",
        "category": "symbols"
    },
    "passport_control": {
        "keywords": ["custom", "blue-square"],
        "char": "🛂",
        "category": "symbols"
    },
    "customs": {
        "keywords": ["passport", "border", "blue-square"],
        "char": "🛃",
        "category": "symbols"
    },
    "baggage_claim": {
        "keywords": ["blue-square", "airport", "transport"],
        "char": "🛄",
        "category": "symbols"
    },
    "left_luggage": {
        "keywords": ["blue-square", "travel"],
        "char": "🛅",
        "category": "symbols"
    },
    "wheelchair": {
        "keywords": ["blue-square", "disabled", "a11y", "accessibility"],
        "char": "♿",
        "category": "symbols"
    },
    "no_smoking": {
        "keywords": ["cigarette", "blue-square", "smell", "smoke"],
        "char": "🚭",
        "category": "symbols"
    },
    "wc": {
        "keywords": ["toilet", "restroom", "blue-square"],
        "char": "🚾",
        "category": "symbols"
    },
    "parking": {
        "keywords": ["cars", "blue-square", "alphabet", "letter"],
        "char": "🅿️",
        "category": "symbols"
    },
    "potable_water": {
        "keywords": ["blue-square", "liquid", "restroom", "cleaning", "faucet"],
        "char": "🚰",
        "category": "symbols"
    },
    "mens": {
        "keywords": ["toilet", "restroom", "wc", "blue-square", "gender", "male"],
        "char": "🚹",
        "category": "symbols"
    },
    "womens": {
        "keywords": ["purple-square", "woman", "female", "toilet", "loo", "restroom", "gender"],
        "char": "🚺",
        "category": "symbols"
    },
    "baby_symbol": {
        "keywords": ["orange-square", "child"],
        "char": "🚼",
        "category": "symbols"
    },
    "restroom": {
        "keywords": ["blue-square", "toilet", "refresh", "wc", "gender"],
        "char": "🚻",
        "category": "symbols"
    },
    "put_litter_in_its_place": {
        "keywords": ["blue-square", "sign", "human", "info"],
        "char": "🚮",
        "category": "symbols"
    },
    "cinema": {
        "keywords": ["blue-square", "record", "film", "movie", "curtain", "stage", "theater"],
        "char": "🎦",
        "category": "symbols"
    },
    "signal_strength": {
        "keywords": ["blue-square", "reception", "phone", "internet", "connection", "wifi", "bluetooth", "bars"],
        "char": "📶",
        "category": "symbols"
    },
    "koko": {
        "keywords": ["blue-square", "here", "katakana", "japanese", "destination"],
        "char": "🈁",
        "category": "symbols"
    },
    "ng": {
        "keywords": ["blue-square", "words", "shape", "icon"],
        "char": "🆖",
        "category": "symbols"
    },
    "ok": {
        "keywords": ["good", "agree", "yes", "blue-square"],
        "char": "🆗",
        "category": "symbols"
    },
    "up": {
        "keywords": ["blue-square", "above", "high"],
        "char": "🆙",
        "category": "symbols"
    },
    "cool": {
        "keywords": ["words", "blue-square"],
        "char": "🆒",
        "category": "symbols"
    },
    "new": {
        "keywords": ["blue-square", "words", "start"],
        "char": "🆕",
        "category": "symbols"
    },
    "free": {
        "keywords": ["blue-square", "words"],
        "char": "🆓",
        "category": "symbols"
    },
    "zero": {
        "keywords": ["0", "numbers", "blue-square", "null"],
        "char": "0️⃣",
        "category": "symbols"
    },
    "one": {
        "keywords": ["blue-square", "numbers", "1"],
        "char": "1️⃣",
        "category": "symbols"
    },
    "two": {
        "keywords": ["numbers", "2", "prime", "blue-square"],
        "char": "2️⃣",
        "category": "symbols"
    },
    "three": {
        "keywords": ["3", "numbers", "prime", "blue-square"],
        "char": "3️⃣",
        "category": "symbols"
    },
    "four": {
        "keywords": ["4", "numbers", "blue-square"],
        "char": "4️⃣",
        "category": "symbols"
    },
    "five": {
        "keywords": ["5", "numbers", "blue-square", "prime"],
        "char": "5️⃣",
        "category": "symbols"
    },
    "six": {
        "keywords": ["6", "numbers", "blue-square"],
        "char": "6️⃣",
        "category": "symbols"
    },
    "seven": {
        "keywords": ["7", "numbers", "blue-square", "prime"],
        "char": "7️⃣",
        "category": "symbols"
    },
    "eight": {
        "keywords": ["8", "blue-square", "numbers"],
        "char": "8️⃣",
        "category": "symbols"
    },
    "nine": {
        "keywords": ["blue-square", "numbers", "9"],
        "char": "9️⃣",
        "category": "symbols"
    },
    "keycap_ten": {
        "keywords": ["numbers", "10", "blue-square"],
        "char": "🔟",
        "category": "symbols"
    },
    "keycap_star": {
        "keywords": ["asterisk"],
        "char": "*⃣",
        "category": "symbols"
    },
    "1234": {
        "keywords": ["numbers", "blue-square"],
        "char": "🔢",
        "category": "symbols"
    },
    "arrow_forward": {
        "keywords": ["blue-square", "right", "direction", "play"],
        "char": "▶️",
        "category": "symbols"
    },
    "double_vertical_bar": {
        "keywords": ["pause", "blue-square"],
        "char": "⏸",
        "category": "symbols"
    },
    "black_right_pointing_triangle_with_double_vertical_bar": {
        "keywords": ["forward", "next", "blue-square"],
        "char": "⏭",
        "category": "symbols"
    },
    "black_square_for_stop": {
        "keywords": ["blue-square"],
        "char": "⏹",
        "category": "symbols"
    },
    "black_circle_for_record": {
        "keywords": ["blue-square"],
        "char": "⏺",
        "category": "symbols"
    },
    "black_right_pointing_double_triangle_with_vertical_bar": {
        "keywords": ["blue-square", "play", "pause"],
        "char": "⏯",
        "category": "symbols"
    },
    "black_left_pointing_double_triangle_with_vertical_bar": {
        "keywords": ["backward"],
        "char": "⏮",
        "category": "symbols"
    },
    "fast_forward": {
        "keywords": ["blue-square", "play", "speed", "continue"],
        "char": "⏩",
        "category": "symbols"
    },
    "rewind": {
        "keywords": ["play", "blue-square"],
        "char": "⏪",
        "category": "symbols"
    },
    "twisted_rightwards_arrows": {
        "keywords": ["blue-square", "shuffle", "music", "random"],
        "char": "🔀",
        "category": "symbols"
    },
    "repeat": {
        "keywords": ["loop", "record"],
        "char": "🔁",
        "category": "symbols"
    },
    "repeat_one": {
        "keywords": ["blue-square", "loop"],
        "char": "🔂",
        "category": "symbols"
    },
    "arrow_backward": {
        "keywords": ["blue-square", "left", "direction"],
        "char": "◀️",
        "category": "symbols"
    },
    "arrow_up_small": {
        "keywords": ["blue-square", "triangle", "direction", "point", "forward", "top"],
        "char": "🔼",
        "category": "symbols"
    },
    "arrow_down_small": {
        "keywords": ["blue-square", "direction", "bottom"],
        "char": "🔽",
        "category": "symbols"
    },
    "arrow_double_up": {
        "keywords": ["blue-square", "direction", "top"],
        "char": "⏫",
        "category": "symbols"
    },
    "arrow_double_down": {
        "keywords": ["blue-square", "direction", "bottom"],
        "char": "⏬",
        "category": "symbols"
    },
    "arrow_right": {
        "keywords": ["blue-square", "next"],
        "char": "➡️",
        "category": "symbols"
    },
    "arrow_left": {
        "keywords": ["blue-square", "previous", "back"],
        "char": "⬅️",
        "category": "symbols"
    },
    "arrow_up": {
        "keywords": ["blue-square", "continue", "top", "direction"],
        "char": "⬆️",
        "category": "symbols"
    },
    "arrow_down": {
        "keywords": ["blue-square", "direction", "bottom"],
        "char": "⬇️",
        "category": "symbols"
    },
    "arrow_upper_right": {
        "keywords": ["blue-square", "point", "direction", "diagonal", "northeast"],
        "char": "↗️",
        "category": "symbols"
    },
    "arrow_lower_right": {
        "keywords": ["blue-square", "direction", "diagonal", "southeast"],
        "char": "↘️",
        "category": "symbols"
    },
    "arrow_lower_left": {
        "keywords": ["blue-square", "direction", "diagonal", "southwest"],
        "char": "↙️",
        "category": "symbols"
    },
    "arrow_upper_left": {
        "keywords": ["blue-square", "point", "direction", "diagonal", "northwest"],
        "char": "↖️",
        "category": "symbols"
    },
    "arrow_up_down": {
        "keywords": ["blue-square", "direction", "way", "vertical"],
        "char": "↕️",
        "category": "symbols"
    },
    "left_right_arrow": {
        "keywords": ["shape", "direction", "horizontal", "sideways"],
        "char": "↔️",
        "category": "symbols"
    },
    "arrows_counterclockwise": {
        "keywords": ["blue-square", "sync", "cycle"],
        "char": "🔄",
        "category": "symbols"
    },
    "arrow_right_hook": {
        "keywords": ["blue-square", "return", "rotate", "direction"],
        "char": "↪️",
        "category": "symbols"
    },
    "leftwards_arrow_with_hook": {
        "keywords": ["back", "return", "blue-square", "undo", "enter"],
        "char": "↩️",
        "category": "symbols"
    },
    "arrow_heading_up": {
        "keywords": ["blue-square", "direction", "top"],
        "char": "⤴️",
        "category": "symbols"
    },
    "arrow_heading_down": {
        "keywords": ["blue-square", "direction", "bottom"],
        "char": "⤵️",
        "category": "symbols"
    },
    "hash": {
        "keywords": ["symbol", "blue-square", "twitter"],
        "char": "#️⃣",
        "category": "symbols"
    },
    "information_source": {
        "keywords": ["blue-square", "alphabet", "letter"],
        "char": "ℹ️",
        "category": "symbols"
    },
    "abc": {
        "keywords": ["blue-square", "alphabet"],
        "char": "🔤",
        "category": "symbols"
    },
    "abcd": {
        "keywords": ["blue-square", "alphabet"],
        "char": "🔡",
        "category": "symbols"
    },
    "capital_abcd": {
        "keywords": ["alphabet", "words", "blue-square"],
        "char": "🔠",
        "category": "symbols"
    },
    "symbols": {
        "keywords": ["blue-square", "music", "note", "ampersand", "percent", "glyphs", "characters"],
        "char": "🔣",
        "category": "symbols"
    },
    "musical_note": {
        "keywords": ["score", "tone", "sound"],
        "char": "🎵",
        "category": "symbols"
    },
    "notes": {
        "keywords": ["music", "score"],
        "char": "🎶",
        "category": "symbols"
    },
    "wavy_dash": {
        "keywords": ["draw", "line", "moustache", "mustache", "squiggle", "scribble"],
        "char": "〰️",
        "category": "symbols"
    },
    "curly_loop": {
        "keywords": ["scribble", "draw", "shape", "squiggle"],
        "char": "➰",
        "category": "symbols"
    },
    "heavy_check_mark": {
        "keywords": ["ok", "nike", "answer", "yes", "tick"],
        "char": "✔️",
        "category": "symbols"
    },
    "arrows_clockwise": {
        "keywords": ["sync", "cycle", "round", "repeat"],
        "char": "🔃",
        "category": "symbols"
    },
    "heavy_plus_sign": {
        "keywords": ["math", "calculation", "addition", "more", "increase"],
        "char": "➕",
        "category": "symbols"
    },
    "heavy_minus_sign": {
        "keywords": ["math", "calculation", "subtract", "less"],
        "char": "➖",
        "category": "symbols"
    },
    "heavy_division_sign": {
        "keywords": ["divide", "math", "calculation"],
        "char": "➗",
        "category": "symbols"
    },
    "heavy_multiplication_x": {
        "keywords": ["math", "calculation"],
        "char": "✖️",
        "category": "symbols"
    },
    "heavy_dollar_sign": {
        "keywords": ["money", "sales", "payment", "currency", "buck"],
        "char": "💲",
        "category": "symbols"
    },
    "currency_exchange": {
        "keywords": ["money", "sales", "dollar", "travel"],
        "char": "💱",
        "category": "symbols"
    },
    "copyright": {
        "keywords": ["ip", "license", "circle", "law", "legal"],
        "char": "©️",
        "category": "symbols"
    },
    "registered": {
        "keywords": ["alphabet", "circle"],
        "char": "®️",
        "category": "symbols"
    },
    "tm": {
        "keywords": ["trademark", "brand", "law", "legal"],
        "char": "™️",
        "category": "symbols"
    },
    "end": {
        "keywords": ["words", "arrow"],
        "char": "🔚",
        "category": "symbols"
    },
    "back": {
        "keywords": ["arrow", "words", "return"],
        "char": "🔙",
        "category": "symbols"
    },
    "on": {
        "keywords": ["arrow", "words"],
        "char": "🔛",
        "category": "symbols"
    },
    "top": {
        "keywords": ["words", "blue-square"],
        "char": "🔝",
        "category": "symbols"
    },
    "soon": {
        "keywords": ["arrow", "words"],
        "char": "🔜",
        "category": "symbols"
    },
    "ballot_box_with_check": {
        "keywords": ["ok", "agree", "confirm", "black-square", "vote", "election", "yes"],
        "char": "☑️",
        "category": "symbols"
    },
    "radio_button": {
        "keywords": ["input", "old", "music", "circle"],
        "char": "🔘",
        "category": "symbols"
    },
    "white_circle": {
        "keywords": ["shape", "round"],
        "char": "⚪",
        "category": "symbols"
    },
    "black_circle": {
        "keywords": ["shape", "button", "round"],
        "char": "⚫",
        "category": "symbols"
    },
    "red_circle": {
        "keywords": ["shape", "error", "danger"],
        "char": "🔴",
        "category": "symbols"
    },
    "large_blue_circle": {
        "keywords": ["shape", "icon", "button"],
        "char": "🔵",
        "category": "symbols"
    },
    "small_orange_diamond": {
        "keywords": ["shape", "jewel", "gem"],
        "char": "🔸",
        "category": "symbols"
    },
    "small_blue_diamond": {
        "keywords": ["shape", "jewel", "gem"],
        "char": "🔹",
        "category": "symbols"
    },
    "large_orange_diamond": {
        "keywords": ["shape", "jewel", "gem"],
        "char": "🔶",
        "category": "symbols"
    },
    "large_blue_diamond": {
        "keywords": ["shape", "jewel", "gem"],
        "char": "🔷",
        "category": "symbols"
    },
    "small_red_triangle": {
        "keywords": ["shape", "direction", "up", "top"],
        "char": "🔺",
        "category": "symbols"
    },
    "black_small_square": {
        "keywords": ["shape", "icon"],
        "char": "▪️",
        "category": "symbols"
    },
    "white_small_square": {
        "keywords": ["shape", "icon"],
        "char": "▫️",
        "category": "symbols"
    },
    "black_large_square": {
        "keywords": ["shape", "icon", "button"],
        "char": "⬛",
        "category": "symbols"
    },
    "white_large_square": {
        "keywords": ["shape", "icon", "stone", "button"],
        "char": "⬜",
        "category": "symbols"
    },
    "small_red_triangle_down": {
        "keywords": ["shape", "direction", "bottom"],
        "char": "🔻",
        "category": "symbols"
    },
    "black_medium_square": {
        "keywords": ["shape", "button", "icon"],
        "char": "◼️",
        "category": "symbols"
    },
    "white_medium_square": {
        "keywords": ["shape", "stone", "icon"],
        "char": "◻️",
        "category": "symbols"
    },
    "black_medium_small_square": {
        "keywords": ["icon", "shape", "button"],
        "char": "◾",
        "category": "symbols"
    },
    "white_medium_small_square": {
        "keywords": ["shape", "stone", "icon", "button"],
        "char": "◽",
        "category": "symbols"
    },
    "black_square_button": {
        "keywords": ["shape", "input", "frame"],
        "char": "🔲",
        "category": "symbols"
    },
    "white_square_button": {
        "keywords": ["shape", "input"],
        "char": "🔳",
        "category": "symbols"
    },
    "speaker": {
        "keywords": ["sound", "volume", "silence", "broadcast"],
        "char": "🔈",
        "category": "symbols"
    },
    "sound": {
        "keywords": ["volume", "speaker", "broadcast"],
        "char": "🔉",
        "category": "symbols"
    },
    "loud_sound": {
        "keywords": ["volume", "noise", "noisy", "speaker", "broadcast"],
        "char": "🔊",
        "category": "symbols"
    },
    "mute": {
        "keywords": ["sound", "volume", "silence", "quiet"],
        "char": "🔇",
        "category": "symbols"
    },
    "mega": {
        "keywords": ["sound", "speaker", "volume"],
        "char": "📣",
        "category": "symbols"
    },
    "loudspeaker": {
        "keywords": ["volume", "sound"],
        "char": "📢",
        "category": "symbols"
    },
    "bell": {
        "keywords": ["sound", "notification", "christmas", "xmas", "chime"],
        "char": "🔔",
        "category": "symbols"
    },
    "no_bell": {
        "keywords": ["sound", "volume", "mute", "quiet", "silent"],
        "char": "🔕",
        "category": "symbols"
    },
    "black_joker": {
        "keywords": ["poker", "cards", "game", "play", "magic"],
        "char": "🃏",
        "category": "symbols"
    },
    "mahjong": {
        "keywords": ["game", "play", "chinese", "kanji"],
        "char": "🀄",
        "category": "symbols"
    },
    "spades": {
        "keywords": ["poker", "cards", "suits", "magic"],
        "char": "♠️",
        "category": "symbols"
    },
    "clubs": {
        "keywords": ["poker", "cards", "magic", "suits"],
        "char": "♣️",
        "category": "symbols"
    },
    "hearts": {
        "keywords": ["poker", "cards", "magic", "suits"],
        "char": "♥️",
        "category": "symbols"
    },
    "diamonds": {
        "keywords": ["poker", "cards", "magic", "suits"],
        "char": "♦️",
        "category": "symbols"
    },
    "flower_playing_cards": {
        "keywords": ["game", "sunset", "red"],
        "char": "🎴",
        "category": "symbols"
    },
    "thought_balloon": {
        "keywords": ["bubble", "cloud", "speech", "thinking"],
        "char": "💭",
        "category": "symbols"
    },
    "right_anger_bubble": {
        "keywords": ["caption", "speech", "thinking", "mad"],
        "char": "🗯",
        "category": "symbols"
    },
    "speech_balloon": {
        "keywords": ["bubble", "words", "message", "talk", "chatting"],
        "char": "💬",
        "category": "symbols"
    },
    "left_speech_bubble": {
        "keywords": ["words", "message", "talk", "chatting"],
        "char": "🗨",
        "category": "symbols"
    },
    "clock1": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕐",
        "category": "symbols"
    },
    "clock2": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕑",
        "category": "symbols"
    },
    "clock3": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕒",
        "category": "symbols"
    },
    "clock4": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕓",
        "category": "symbols"
    },
    "clock5": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕔",
        "category": "symbols"
    },
    "clock6": {
        "keywords": ["time", "late", "early", "schedule", "dawn", "dusk"],
        "char": "🕕",
        "category": "symbols"
    },
    "clock7": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕖",
        "category": "symbols"
    },
    "clock8": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕗",
        "category": "symbols"
    },
    "clock9": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕘",
        "category": "symbols"
    },
    "clock10": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕙",
        "category": "symbols"
    },
    "clock11": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕚",
        "category": "symbols"
    },
    "clock12": {
        "keywords": ["time", "noon", "midnight", "midday", "late", "early", "schedule"],
        "char": "🕛",
        "category": "symbols"
    },
    "clock130": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕜",
        "category": "symbols"
    },
    "clock230": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕝",
        "category": "symbols"
    },
    "clock330": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕞",
        "category": "symbols"
    },
    "clock430": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕟",
        "category": "symbols"
    },
    "clock530": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕠",
        "category": "symbols"
    },
    "clock630": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕡",
        "category": "symbols"
    },
    "clock730": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕢",
        "category": "symbols"
    },
    "clock830": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕣",
        "category": "symbols"
    },
    "clock930": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕤",
        "category": "symbols"
    },
    "clock1030": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕥",
        "category": "symbols"
    },
    "clock1130": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕦",
        "category": "symbols"
    },
    "clock1230": {
        "keywords": ["time", "late", "early", "schedule"],
        "char": "🕧",
        "category": "symbols"
    },
    "af": {
        "keywords": ["afghanistan", "flag", "nation", "country", "banner"],
        "char": "🇦🇫",
        "category": "flags"
    },
    "ax": {
        "keywords": ["Åland", "islands", "flag", "nation", "country", "banner"],
        "char": "🇦🇽",
        "category": "flags"
    },
    "al": {
        "keywords": ["albania", "flag", "nation", "country", "banner"],
        "char": "🇦🇱",
        "category": "flags"
    },
    "dz": {
        "keywords": ["algeria", "flag", "nation", "country", "banner"],
        "char": "🇩🇿",
        "category": "flags"
    },
    "as": {
        "keywords": ["american", "samoa", "flag", "nation", "country", "banner"],
        "char": "🇦🇸",
        "category": "flags"
    },
    "ad": {
        "keywords": ["andorra", "flag", "nation", "country", "banner"],
        "char": "🇦🇩",
        "category": "flags"
    },
    "ao": {
        "keywords": ["angola", "flag", "nation", "country", "banner"],
        "char": "🇦🇴",
        "category": "flags"
    },
    "ai": {
        "keywords": ["anguilla", "flag", "nation", "country", "banner"],
        "char": "🇦🇮",
        "category": "flags"
    },
    "aq": {
        "keywords": ["antarctica", "flag", "nation", "country", "banner"],
        "char": "🇦🇶",
        "category": "flags"
    },
    "ag": {
        "keywords": ["antigua", "barbuda", "flag", "nation", "country", "banner"],
        "char": "🇦🇬",
        "category": "flags"
    },
    "ar": {
        "keywords": ["argentina", "flag", "nation", "country", "banner"],
        "char": "🇦🇷",
        "category": "flags"
    },
    "am": {
        "keywords": ["armenia", "flag", "nation", "country", "banner"],
        "char": "🇦🇲",
        "category": "flags"
    },
    "aw": {
        "keywords": ["aruba", "flag", "nation", "country", "banner"],
        "char": "🇦🇼",
        "category": "flags"
    },
    "au": {
        "keywords": ["australia", "flag", "nation", "country", "banner"],
        "char": "🇦🇺",
        "category": "flags"
    },
    "at": {
        "keywords": ["austria", "flag", "nation", "country", "banner"],
        "char": "🇦🇹",
        "category": "flags"
    },
    "az": {
        "keywords": ["azerbaijan", "flag", "nation", "country", "banner"],
        "char": "🇦🇿",
        "category": "flags"
    },
    "bs": {
        "keywords": ["bahamas", "flag", "nation", "country", "banner"],
        "char": "🇧🇸",
        "category": "flags"
    },
    "bh": {
        "keywords": ["bahrain", "flag", "nation", "country", "banner"],
        "char": "🇧🇭",
        "category": "flags"
    },
    "bd": {
        "keywords": ["bangladesh", "flag", "nation", "country", "banner"],
        "char": "🇧🇩",
        "category": "flags"
    },
    "bb": {
        "keywords": ["barbados", "flag", "nation", "country", "banner"],
        "char": "🇧🇧",
        "category": "flags"
    },
    "by": {
        "keywords": ["belarus", "flag", "nation", "country", "banner"],
        "char": "🇧🇾",
        "category": "flags"
    },
    "be": {
        "keywords": ["belgium", "flag", "nation", "country", "banner"],
        "char": "🇧🇪",
        "category": "flags"
    },
    "bz": {
        "keywords": ["belize", "flag", "nation", "country", "banner"],
        "char": "🇧🇿",
        "category": "flags"
    },
    "bj": {
        "keywords": ["benin", "flag", "nation", "country", "banner"],
        "char": "🇧🇯",
        "category": "flags"
    },
    "bm": {
        "keywords": ["bermuda", "flag", "nation", "country", "banner"],
        "char": "🇧🇲",
        "category": "flags"
    },
    "bt": {
        "keywords": ["bhutan", "flag", "nation", "country", "banner"],
        "char": "🇧🇹",
        "category": "flags"
    },
    "bo": {
        "keywords": ["bolivia", "flag", "nation", "country", "banner"],
        "char": "🇧🇴",
        "category": "flags"
    },
    "bq": {
        "keywords": ["bonaire", "flag", "nation", "country", "banner"],
        "char": "🇧🇶",
        "category": "flags"
    },
    "ba": {
        "keywords": ["bosnia", "herzegovina", "flag", "nation", "country", "banner"],
        "char": "🇧🇦",
        "category": "flags"
    },
    "bw": {
        "keywords": ["botswana", "flag", "nation", "country", "banner"],
        "char": "🇧🇼",
        "category": "flags"
    },
    "br": {
        "keywords": ["brazil", "flag", "nation", "country", "banner"],
        "char": "🇧🇷",
        "category": "flags"
    },
    "io": {
        "keywords": ["british", "indian", "ocean", "territory", "flag", "nation", "country", "banner"],
        "char": "🇮🇴",
        "category": "flags"
    },
    "vg": {
        "keywords": ["british", "virgin", "islands", "bvi", "flag", "nation", "country", "banner"],
        "char": "🇻🇬",
        "category": "flags"
    },
    "bn": {
        "keywords": ["brunei", "darussalam", "flag", "nation", "country", "banner"],
        "char": "🇧🇳",
        "category": "flags"
    },
    "bg": {
        "keywords": ["bulgaria", "flag", "nation", "country", "banner"],
        "char": "🇧🇬",
        "category": "flags"
    },
    "bf": {
        "keywords": ["burkina", "faso", "flag", "nation", "country", "banner"],
        "char": "🇧🇫",
        "category": "flags"
    },
    "bi": {
        "keywords": ["burundi", "flag", "nation", "country", "banner"],
        "char": "🇧🇮",
        "category": "flags"
    },
    "cv": {
        "keywords": ["cabo", "verde", "flag", "nation", "country", "banner"],
        "char": "🇨🇻",
        "category": "flags"
    },
    "kh": {
        "keywords": ["cambodia", "flag", "nation", "country", "banner"],
        "char": "🇰🇭",
        "category": "flags"
    },
    "cm": {
        "keywords": ["cameroon", "flag", "nation", "country", "banner"],
        "char": "🇨🇲",
        "category": "flags"
    },
    "ca": {
        "keywords": ["canada", "flag", "nation", "country", "banner"],
        "char": "🇨🇦",
        "category": "flags"
    },
    "ic": {
        "keywords": ["canary", "islands", "flag", "nation", "country", "banner"],
        "char": "🇮🇨",
        "category": "flags"
    },
    "ky": {
        "keywords": ["cayman", "islands", "flag", "nation", "country", "banner"],
        "char": "🇰🇾",
        "category": "flags"
    },
    "cf": {
        "keywords": ["central", "african", "republic", "flag", "nation", "country", "banner"],
        "char": "🇨🇫",
        "category": "flags"
    },
    "td": {
        "keywords": ["chad", "flag", "nation", "country", "banner"],
        "char": "🇹🇩",
        "category": "flags"
    },
    "chile": {
        "keywords": ["flag", "nation", "country", "banner"],
        "char": "🇨🇱",
        "category": "flags"
    },
    "cn": {
        "keywords": ["china", "chinese", "prc", "flag", "country", "nation", "banner"],
        "char": "🇨🇳",
        "category": "flags"
    },
    "cx": {
        "keywords": ["christmas", "island", "flag", "nation", "country", "banner"],
        "char": "🇨🇽",
        "category": "flags"
    },
    "cc": {
        "keywords": ["cocos", "keeling", "islands", "flag", "nation", "country", "banner"],
        "char": "🇨🇨",
        "category": "flags"
    },
    "co": {
        "keywords": ["colombia", "flag", "nation", "country", "banner"],
        "char": "🇨🇴",
        "category": "flags"
    },
    "km": {
        "keywords": ["comoros", "flag", "nation", "country", "banner"],
        "char": "🇰🇲",
        "category": "flags"
    },
    "cg": {
        "keywords": ["congo", "flag", "nation", "country", "banner"],
        "char": "🇨🇬",
        "category": "flags"
    },
    "drc": {
        "keywords": ["congo", "democratic", "republic", "flag", "nation", "country", "banner"],
        "char": "🇨🇩",
        "category": "flags"
    },
    "ck": {
        "keywords": ["cook", "islands", "flag", "nation", "country", "banner"],
        "char": "🇨🇰",
        "category": "flags"
    },
    "cr": {
        "keywords": ["costa", "rica", "flag", "nation", "country", "banner"],
        "char": "🇨🇷",
        "category": "flags"
    },
    "hr": {
        "keywords": ["croatia", "flag", "nation", "country", "banner"],
        "char": "🇭🇷",
        "category": "flags"
    },
    "cu": {
        "keywords": ["cuba", "flag", "nation", "country", "banner"],
        "char": "🇨🇺",
        "category": "flags"
    },
    "cw": {
        "keywords": ["curaçao", "flag", "nation", "country", "banner"],
        "char": "🇨🇼",
        "category": "flags"
    },
    "cy": {
        "keywords": ["cyprus", "flag", "nation", "country", "banner"],
        "char": "🇨🇾",
        "category": "flags"
    },
    "cz": {
        "keywords": ["czech_republic", "flag", "nation", "country", "banner"],
        "char": "🇨🇿",
        "category": "flags"
    },
    "dk": {
        "keywords": ["denmark", "flag", "nation", "country", "banner"],
        "char": "🇩🇰",
        "category": "flags"
    },
    "dj": {
        "keywords": ["djibouti", "flag", "nation", "country", "banner"],
        "char": "🇩🇯",
        "category": "flags"
    },
    "dm": {
        "keywords": ["dominica", "flag", "nation", "country", "banner"],
        "char": "🇩🇲",
        "category": "flags"
    },
    "do": {
        "keywords": ["dominican", "republic", "flag", "nation", "country", "banner"],
        "char": "🇩🇴",
        "category": "flags"
    },
    "ec": {
        "keywords": ["ecuador", "flag", "nation", "country", "banner"],
        "char": "🇪🇨",
        "category": "flags"
    },
    "eg": {
        "keywords": ["egypt", "flag", "nation", "country", "banner"],
        "char": "🇪🇬",
        "category": "flags"
    },
    "sv": {
        "keywords": ["el", "salvador", "flag", "nation", "country", "banner"],
        "char": "🇸🇻",
        "category": "flags"
    },
    "gq": {
        "keywords": ["equatorial", "guinea", "flag", "nation", "country", "banner"],
        "char": "🇬🇶",
        "category": "flags"
    },
    "er": {
        "keywords": ["eritrea", "flag", "nation", "country", "banner"],
        "char": "🇪🇷",
        "category": "flags"
    },
    "ee": {
        "keywords": ["estonia", "flag", "nation", "country", "banner"],
        "char": "🇪🇪",
        "category": "flags"
    },
    "et": {
        "keywords": ["ethiopia", "flag", "nation", "country", "banner"],
        "char": "🇪🇹",
        "category": "flags"
    },
    "eu": {
        "keywords": ["european", "union", "flag", "banner"],
        "char": "🇪🇺",
        "category": "flags"
    },
    "fk": {
        "keywords": ["falkland", "islands", "malvinas", "flag", "nation", "country", "banner"],
        "char": "🇫🇰",
        "category": "flags"
    },
    "fo": {
        "keywords": ["faroe", "islands", "flag", "nation", "country", "banner"],
        "char": "🇫🇴",
        "category": "flags"
    },
    "fj": {
        "keywords": ["fiji", "flag", "nation", "country", "banner"],
        "char": "🇫🇯",
        "category": "flags"
    },
    "fi": {
        "keywords": ["finland", "flag", "nation", "country", "banner"],
        "char": "🇫🇮",
        "category": "flags"
    },
    "fr": {
        "keywords": ["banner", "flag", "nation", "france", "french", "country"],
        "char": "🇫🇷",
        "category": "flags"
    },
    "gf": {
        "keywords": ["french", "guiana", "flag", "nation", "country", "banner"],
        "char": "🇬🇫",
        "category": "flags"
    },
    "pf": {
        "keywords": ["french", "polynesia", "flag", "nation", "country", "banner"],
        "char": "🇵🇫",
        "category": "flags"
    },
    "tf": {
        "keywords": ["french", "southern", "territories", "flag", "nation", "country", "banner"],
        "char": "🇹🇫",
        "category": "flags"
    },
    "ga": {
        "keywords": ["gabon", "flag", "nation", "country", "banner"],
        "char": "🇬🇦",
        "category": "flags"
    },
    "gm": {
        "keywords": ["gambia", "flag", "nation", "country", "banner"],
        "char": "🇬🇲",
        "category": "flags"
    },
    "ge": {
        "keywords": ["georgia", "flag", "nation", "country", "banner"],
        "char": "🇬🇪",
        "category": "flags"
    },
    "de": {
        "keywords": ["german", "nation", "flag", "country", "banner"],
        "char": "🇩🇪",
        "category": "flags"
    },
    "gh": {
        "keywords": ["ghana", "flag", "nation", "country", "banner"],
        "char": "🇬🇭",
        "category": "flags"
    },
    "gi": {
        "keywords": ["gibraltar", "flag", "nation", "country", "banner"],
        "char": "🇬🇮",
        "category": "flags"
    },
    "gr": {
        "keywords": ["greece", "flag", "nation", "country", "banner"],
        "char": "🇬🇷",
        "category": "flags"
    },
    "gl": {
        "keywords": ["greenland", "flag", "nation", "country", "banner"],
        "char": "🇬🇱",
        "category": "flags"
    },
    "gd": {
        "keywords": ["grenada", "flag", "nation", "country", "banner"],
        "char": "🇬🇩",
        "category": "flags"
    },
    "gp": {
        "keywords": ["guadeloupe", "flag", "nation", "country", "banner"],
        "char": "🇬🇵",
        "category": "flags"
    },
    "gu": {
        "keywords": ["guam", "flag", "nation", "country", "banner"],
        "char": "🇬🇺",
        "category": "flags"
    },
    "gt": {
        "keywords": ["guatemala", "flag", "nation", "country", "banner"],
        "char": "🇬🇹",
        "category": "flags"
    },
    "gg": {
        "keywords": ["guernsey", "flag", "nation", "country", "banner"],
        "char": "🇬🇬",
        "category": "flags"
    },
    "gn": {
        "keywords": ["guinea", "flag", "nation", "country", "banner"],
        "char": "🇬🇳",
        "category": "flags"
    },
    "gw": {
        "keywords": ["guinea", "bissau", "flag", "nation", "country", "banner"],
        "char": "🇬🇼",
        "category": "flags"
    },
    "gy": {
        "keywords": ["guyana", "flag", "nation", "country", "banner"],
        "char": "🇬🇾",
        "category": "flags"
    },
    "ht": {
        "keywords": ["haiti", "flag", "nation", "country", "banner"],
        "char": "🇭🇹",
        "category": "flags"
    },
    "hn": {
        "keywords": ["honduras", "flag", "nation", "country", "banner"],
        "char": "🇭🇳",
        "category": "flags"
    },
    "hk": {
        "keywords": ["hong", "kong", "flag", "nation", "country", "banner"],
        "char": "🇭🇰",
        "category": "flags"
    },
    "hu": {
        "keywords": ["hungary", "flag", "nation", "country", "banner"],
        "char": "🇭🇺",
        "category": "flags"
    },
    "is": {
        "keywords": ["iceland", "flag", "nation", "country", "banner"],
        "char": "🇮🇸",
        "category": "flags"
    },
    "in": {
        "keywords": ["india", "flag", "nation", "country", "banner"],
        "char": "🇮🇳",
        "category": "flags"
    },
    "indonesia": {
        "keywords": ["flag", "nation", "country", "banner"],
        "char": "🇮🇩",
        "category": "flags"
    },
    "ir": {
        "keywords": ["iran,", "islamic", "republic", "flag", "nation", "country", "banner"],
        "char": "🇮🇷",
        "category": "flags"
    },
    "iq": {
        "keywords": ["iraq", "flag", "nation", "country", "banner"],
        "char": "🇮🇶",
        "category": "flags"
    },
    "ie": {
        "keywords": ["ireland", "flag", "nation", "country", "banner"],
        "char": "🇮🇪",
        "category": "flags"
    },
    "im": {
        "keywords": ["isle", "man", "flag", "nation", "country", "banner"],
        "char": "🇮🇲",
        "category": "flags"
    },
    "il": {
        "keywords": ["israel", "flag", "nation", "country", "banner"],
        "char": "🇮🇱",
        "category": "flags"
    },
    "it": {
        "keywords": ["italy", "flag", "nation", "country", "banner"],
        "char": "🇮🇹",
        "category": "flags"
    },
    "ci": {
        "keywords": ["ivory", "coast", "flag", "nation", "country", "banner"],
        "char": "🇨🇮",
        "category": "flags"
    },
    "jm": {
        "keywords": ["jamaica", "flag", "nation", "country", "banner"],
        "char": "🇯🇲",
        "category": "flags"
    },
    "jp": {
        "keywords": ["japanese", "nation", "flag", "country", "banner"],
        "char": "🇯🇵",
        "category": "flags"
    },
    "je": {
        "keywords": ["jersey", "flag", "nation", "country", "banner"],
        "char": "🇯🇪",
        "category": "flags"
    },
    "jo": {
        "keywords": ["jordan", "flag", "nation", "country", "banner"],
        "char": "🇯🇴",
        "category": "flags"
    },
    "kz": {
        "keywords": ["kazakhstan", "flag", "nation", "country", "banner"],
        "char": "🇰🇿",
        "category": "flags"
    },
    "ke": {
        "keywords": ["kenya", "flag", "nation", "country", "banner"],
        "char": "🇰🇪",
        "category": "flags"
    },
    "ki": {
        "keywords": ["kiribati", "flag", "nation", "country", "banner"],
        "char": "🇰🇮",
        "category": "flags"
    },
    "xk": {
        "keywords": ["kosovo", "flag", "nation", "country", "banner"],
        "char": "🇽🇰",
        "category": "flags"
    },
    "kw": {
        "keywords": ["kuwait", "flag", "nation", "country", "banner"],
        "char": "🇰🇼",
        "category": "flags"
    },
    "kg": {
        "keywords": ["kyrgyzstan", "flag", "nation", "country", "banner"],
        "char": "🇰🇬",
        "category": "flags"
    },
    "la": {
        "keywords": ["lao", "democratic", "republic", "flag", "nation", "country", "banner"],
        "char": "🇱🇦",
        "category": "flags"
    },
    "lv": {
        "keywords": ["latvia", "flag", "nation", "country", "banner"],
        "char": "🇱🇻",
        "category": "flags"
    },
    "lb": {
        "keywords": ["lebanon", "flag", "nation", "country", "banner"],
        "char": "🇱🇧",
        "category": "flags"
    },
    "ls": {
        "keywords": ["lesotho", "flag", "nation", "country", "banner"],
        "char": "🇱🇸",
        "category": "flags"
    },
    "lr": {
        "keywords": ["liberia", "flag", "nation", "country", "banner"],
        "char": "🇱🇷",
        "category": "flags"
    },
    "ly": {
        "keywords": ["libya", "flag", "nation", "country", "banner"],
        "char": "🇱🇾",
        "category": "flags"
    },
    "li": {
        "keywords": ["liechtenstein", "flag", "nation", "country", "banner"],
        "char": "🇱🇮",
        "category": "flags"
    },
    "lt": {
        "keywords": ["lithuania", "flag", "nation", "country", "banner"],
        "char": "🇱🇹",
        "category": "flags"
    },
    "lu": {
        "keywords": ["luxembourg", "flag", "nation", "country", "banner"],
        "char": "🇱🇺",
        "category": "flags"
    },
    "mo": {
        "keywords": ["macao", "flag", "nation", "country", "banner"],
        "char": "🇲🇴",
        "category": "flags"
    },
    "mk": {
        "keywords": ["macedonia,", "flag", "nation", "country", "banner"],
        "char": "🇲🇰",
        "category": "flags"
    },
    "mg": {
        "keywords": ["madagascar", "flag", "nation", "country", "banner"],
        "char": "🇲🇬",
        "category": "flags"
    },
    "mw": {
        "keywords": ["malawi", "flag", "nation", "country", "banner"],
        "char": "🇲🇼",
        "category": "flags"
    },
    "my": {
        "keywords": ["malaysia", "flag", "nation", "country", "banner"],
        "char": "🇲🇾",
        "category": "flags"
    },
    "mv": {
        "keywords": ["maldives", "flag", "nation", "country", "banner"],
        "char": "🇲🇻",
        "category": "flags"
    },
    "ml": {
        "keywords": ["mali", "flag", "nation", "country", "banner"],
        "char": "🇲🇱",
        "category": "flags"
    },
    "mt": {
        "keywords": ["malta", "flag", "nation", "country", "banner"],
        "char": "🇲🇹",
        "category": "flags"
    },
    "mh": {
        "keywords": ["marshall", "islands", "flag", "nation", "country", "banner"],
        "char": "🇲🇭",
        "category": "flags"
    },
    "mq": {
        "keywords": ["martinique", "flag", "nation", "country", "banner"],
        "char": "🇲🇶",
        "category": "flags"
    },
    "mr": {
        "keywords": ["mauritania", "flag", "nation", "country", "banner"],
        "char": "🇲🇷",
        "category": "flags"
    },
    "mu": {
        "keywords": ["mauritius", "flag", "nation", "country", "banner"],
        "char": "🇲🇺",
        "category": "flags"
    },
    "yt": {
        "keywords": ["mayotte", "flag", "nation", "country", "banner"],
        "char": "🇾🇹",
        "category": "flags"
    },
    "mx": {
        "keywords": ["mexico", "flag", "nation", "country", "banner"],
        "char": "🇲🇽",
        "category": "flags"
    },
    "fm": {
        "keywords": ["micronesia,", "federated", "states", "flag", "nation", "country", "banner"],
        "char": "🇫🇲",
        "category": "flags"
    },
    "md": {
        "keywords": ["moldova,", "republic", "flag", "nation", "country", "banner"],
        "char": "🇲🇩",
        "category": "flags"
    },
    "mc": {
        "keywords": ["monaco", "flag", "nation", "country", "banner"],
        "char": "🇲🇨",
        "category": "flags"
    },
    "mn": {
        "keywords": ["mongolia", "flag", "nation", "country", "banner"],
        "char": "🇲🇳",
        "category": "flags"
    },
    "me": {
        "keywords": ["montenegro", "flag", "nation", "country", "banner"],
        "char": "🇲🇪",
        "category": "flags"
    },
    "ms": {
        "keywords": ["montserrat", "flag", "nation", "country", "banner"],
        "char": "🇲🇸",
        "category": "flags"
    },
    "ma": {
        "keywords": ["morocco", "flag", "nation", "country", "banner"],
        "char": "🇲🇦",
        "category": "flags"
    },
    "mz": {
        "keywords": ["mozambique", "flag", "nation", "country", "banner"],
        "char": "🇲🇿",
        "category": "flags"
    },
    "mm": {
        "keywords": ["myanmar", "flag", "nation", "country", "banner"],
        "char": "🇲🇲",
        "category": "flags"
    },
    "na": {
        "keywords": ["namibia", "flag", "nation", "country", "banner"],
        "char": "🇳🇦",
        "category": "flags"
    },
    "nr": {
        "keywords": ["nauru", "flag", "nation", "country", "banner"],
        "char": "🇳🇷",
        "category": "flags"
    },
    "np": {
        "keywords": ["nepal", "flag", "nation", "country", "banner"],
        "char": "🇳🇵",
        "category": "flags"
    },
    "nl": {
        "keywords": ["netherlands", "flag", "nation", "country", "banner"],
        "char": "🇳🇱",
        "category": "flags"
    },
    "nc": {
        "keywords": ["new", "caledonia", "flag", "nation", "country", "banner"],
        "char": "🇳🇨",
        "category": "flags"
    },
    "nz": {
        "keywords": ["new", "zealand", "flag", "nation", "country", "banner"],
        "char": "🇳🇿",
        "category": "flags"
    },
    "ni": {
        "keywords": ["nicaragua", "flag", "nation", "country", "banner"],
        "char": "🇳🇮",
        "category": "flags"
    },
    "ne": {
        "keywords": ["niger", "flag", "nation", "country", "banner"],
        "char": "🇳🇪",
        "category": "flags"
    },
    "nigeria": {
        "keywords": ["flag", "nation", "country", "banner"],
        "char": "🇳🇬",
        "category": "flags"
    },
    "nu": {
        "keywords": ["niue", "flag", "nation", "country", "banner"],
        "char": "🇳🇺",
        "category": "flags"
    },
    "nf": {
        "keywords": ["norfolk", "island", "flag", "nation", "country", "banner"],
        "char": "🇳🇫",
        "category": "flags"
    },
    "mp": {
        "keywords": ["northern", "mariana", "islands", "flag", "nation", "country", "banner"],
        "char": "🇲🇵",
        "category": "flags"
    },
    "kp": {
        "keywords": ["north", "korea", "nation", "flag", "country", "banner"],
        "char": "🇰🇵",
        "category": "flags"
    },
    "no": {
        "keywords": ["norway", "flag", "nation", "country", "banner"],
        "char": "🇳🇴",
        "category": "flags"
    },
    "om": {
        "keywords": ["oman", "flag", "nation", "country", "banner"],
        "char": "🇴🇲",
        "category": "flags"
    },
    "pk": {
        "keywords": ["pakistan", "flag", "nation", "country", "banner"],
        "char": "🇵🇰",
        "category": "flags"
    },
    "pw": {
        "keywords": ["palau", "flag", "nation", "country", "banner"],
        "char": "🇵🇼",
        "category": "flags"
    },
    "ps": {
        "keywords": ["palestine", "palestinian", "territories", "flag", "nation", "country", "banner"],
        "char": "🇵🇸",
        "category": "flags"
    },
    "pa": {
        "keywords": ["panama", "flag", "nation", "country", "banner"],
        "char": "🇵🇦",
        "category": "flags"
    },
    "pg": {
        "keywords": ["papua", "new", "guinea", "flag", "nation", "country", "banner"],
        "char": "🇵🇬",
        "category": "flags"
    },
    "py": {
        "keywords": ["paraguay", "flag", "nation", "country", "banner"],
        "char": "🇵🇾",
        "category": "flags"
    },
    "pe": {
        "keywords": ["peru", "flag", "nation", "country", "banner"],
        "char": "🇵🇪",
        "category": "flags"
    },
    "ph": {
        "keywords": ["philippines", "flag", "nation", "country", "banner"],
        "char": "🇵🇭",
        "category": "flags"
    },
    "pn": {
        "keywords": ["pitcairn", "flag", "nation", "country", "banner"],
        "char": "🇵🇳",
        "category": "flags"
    },
    "pl": {
        "keywords": ["poland", "flag", "nation", "country", "banner"],
        "char": "🇵🇱",
        "category": "flags"
    },
    "pt": {
        "keywords": ["portugal", "flag", "nation", "country", "banner"],
        "char": "🇵🇹",
        "category": "flags"
    },
    "pr": {
        "keywords": ["puerto", "rico", "flag", "nation", "country", "banner"],
        "char": "🇵🇷",
        "category": "flags"
    },
    "qa": {
        "keywords": ["qatar", "flag", "nation", "country", "banner"],
        "char": "🇶🇦",
        "category": "flags"
    },
    "re": {
        "keywords": ["réunion", "flag", "nation", "country", "banner"],
        "char": "🇷🇪",
        "category": "flags"
    },
    "ro": {
        "keywords": ["romania", "flag", "nation", "country", "banner"],
        "char": "🇷🇴",
        "category": "flags"
    },
    "ru": {
        "keywords": ["russian", "federation", "flag", "nation", "country", "banner"],
        "char": "🇷🇺",
        "category": "flags"
    },
    "rw": {
        "keywords": ["rwanda", "flag", "nation", "country", "banner"],
        "char": "🇷🇼",
        "category": "flags"
    },
    "bl": {
        "keywords": ["saint", "barthélemy", "flag", "nation", "country", "banner"],
        "char": "🇧🇱",
        "category": "flags"
    },
    "sh": {
        "keywords": ["saint", "helena", "ascension", "tristan", "cunha", "flag", "nation", "country", "banner"],
        "char": "🇸🇭",
        "category": "flags"
    },
    "kn": {
        "keywords": ["saint", "kitts", "nevis", "flag", "nation", "country", "banner"],
        "char": "🇰🇳",
        "category": "flags"
    },
    "lc": {
        "keywords": ["saint", "lucia", "flag", "nation", "country", "banner"],
        "char": "🇱🇨",
        "category": "flags"
    },
    "pm": {
        "keywords": ["saint", "pierre", "miquelon", "flag", "nation", "country", "banner"],
        "char": "🇵🇲",
        "category": "flags"
    },
    "vc": {
        "keywords": ["saint", "vincent", "grenadines", "flag", "nation", "country", "banner"],
        "char": "🇻🇨",
        "category": "flags"
    },
    "ws": {
        "keywords": ["samoa", "flag", "nation", "country", "banner"],
        "char": "🇼🇸",
        "category": "flags"
    },
    "sm": {
        "keywords": ["san", "marino", "flag", "nation", "country", "banner"],
        "char": "🇸🇲",
        "category": "flags"
    },
    "st": {
        "keywords": ["sao", "tome", "principe", "flag", "nation", "country", "banner"],
        "char": "🇸🇹",
        "category": "flags"
    },
    "saudi_arabia": {
        "keywords": ["flag", "nation", "country", "banner"],
        "char": "🇸🇦",
        "category": "flags"
    },
    "sn": {
        "keywords": ["senegal", "flag", "nation", "country", "banner"],
        "char": "🇸🇳",
        "category": "flags"
    },
    "rs": {
        "keywords": ["serbia", "flag", "nation", "country", "banner"],
        "char": "🇷🇸",
        "category": "flags"
    },
    "sc": {
        "keywords": ["seychelles", "flag", "nation", "country", "banner"],
        "char": "🇸🇨",
        "category": "flags"
    },
    "sl": {
        "keywords": ["sierra", "leone", "flag", "nation", "country", "banner"],
        "char": "🇸🇱",
        "category": "flags"
    },
    "sg": {
        "keywords": ["singapore", "flag", "nation", "country", "banner"],
        "char": "🇸🇬",
        "category": "flags"
    },
    "sx": {
        "keywords": ["sint", "maarten", "dutch", "flag", "nation", "country", "banner"],
        "char": "🇸🇽",
        "category": "flags"
    },
    "sk": {
        "keywords": ["slovakia", "flag", "nation", "country", "banner"],
        "char": "🇸🇰",
        "category": "flags"
    },
    "si": {
        "keywords": ["slovenia", "flag", "nation", "country", "banner"],
        "char": "🇸🇮",
        "category": "flags"
    },
    "sb": {
        "keywords": ["solomon", "islands", "flag", "nation", "country", "banner"],
        "char": "🇸🇧",
        "category": "flags"
    },
    "so": {
        "keywords": ["somalia", "flag", "nation", "country", "banner"],
        "char": "🇸🇴",
        "category": "flags"
    },
    "za": {
        "keywords": ["south", "africa", "flag", "nation", "country", "banner"],
        "char": "🇿🇦",
        "category": "flags"
    },
    "gs": {
        "keywords": ["south", "georgia", "sandwich", "islands", "flag", "nation", "country", "banner"],
        "char": "🇬🇸",
        "category": "flags"
    },
    "kr": {
        "keywords": ["south", "korea", "nation", "flag", "country", "banner"],
        "char": "🇰🇷",
        "category": "flags"
    },
    "ss": {
        "keywords": ["south", "sudan", "flag", "nation", "country", "banner"],
        "char": "🇸🇸",
        "category": "flags"
    },
    "es": {
        "keywords": ["spain", "flag", "nation", "country", "banner"],
        "char": "🇪🇸",
        "category": "flags"
    },
    "lk": {
        "keywords": ["sri", "lanka", "flag", "nation", "country", "banner"],
        "char": "🇱🇰",
        "category": "flags"
    },
    "sd": {
        "keywords": ["sudan", "flag", "nation", "country", "banner"],
        "char": "🇸🇩",
        "category": "flags"
    },
    "sr": {
        "keywords": ["suriname", "flag", "nation", "country", "banner"],
        "char": "🇸🇷",
        "category": "flags"
    },
    "sz": {
        "keywords": ["swaziland", "flag", "nation", "country", "banner"],
        "char": "🇸🇿",
        "category": "flags"
    },
    "se": {
        "keywords": ["sweden", "flag", "nation", "country", "banner"],
        "char": "🇸🇪",
        "category": "flags"
    },
    "ch": {
        "keywords": ["switzerland", "flag", "nation", "country", "banner"],
        "char": "🇨🇭",
        "category": "flags"
    },
    "sy": {
        "keywords": ["syrian", "arab", "republic", "flag", "nation", "country", "banner"],
        "char": "🇸🇾",
        "category": "flags"
    },
    "tw": {
        "keywords": ["taiwan", "flag", "nation", "country", "banner"],
        "char": "🇹🇼",
        "category": "flags"
    },
    "tj": {
        "keywords": ["tajikistan", "flag", "nation", "country", "banner"],
        "char": "🇹🇯",
        "category": "flags"
    },
    "tz": {
        "keywords": ["tanzania,", "united", "republic", "flag", "nation", "country", "banner"],
        "char": "🇹🇿",
        "category": "flags"
    },
    "th": {
        "keywords": ["thailand", "flag", "nation", "country", "banner"],
        "char": "🇹🇭",
        "category": "flags"
    },
    "tl": {
        "keywords": ["timor", "leste", "flag", "nation", "country", "banner"],
        "char": "🇹🇱",
        "category": "flags"
    },
    "tg": {
        "keywords": ["togo", "flag", "nation", "country", "banner"],
        "char": "🇹🇬",
        "category": "flags"
    },
    "tk": {
        "keywords": ["tokelau", "flag", "nation", "country", "banner"],
        "char": "🇹🇰",
        "category": "flags"
    },
    "to": {
        "keywords": ["tonga", "flag", "nation", "country", "banner"],
        "char": "🇹🇴",
        "category": "flags"
    },
    "tt": {
        "keywords": ["trinidad", "tobago", "flag", "nation", "country", "banner"],
        "char": "🇹🇹",
        "category": "flags"
    },
    "tn": {
        "keywords": ["tunisia", "flag", "nation", "country", "banner"],
        "char": "🇹🇳",
        "category": "flags"
    },
    "tr": {
        "keywords": ["turkey", "flag", "nation", "country", "banner"],
        "char": "🇹🇷",
        "category": "flags"
    },
    "turkmenistan": {
        "keywords": ["flag", "nation", "country", "banner"],
        "char": "🇹🇲",
        "category": "flags"
    },
    "tc": {
        "keywords": ["turks", "caicos", "islands", "flag", "nation", "country", "banner"],
        "char": "🇹🇨",
        "category": "flags"
    },
    "tuvalu": {
        "keywords": ["flag", "nation", "country", "banner"],
        "char": "🇹🇻",
        "category": "flags"
    },
    "ug": {
        "keywords": ["uganda", "flag", "nation", "country", "banner"],
        "char": "🇺🇬",
        "category": "flags"
    },
    "ua": {
        "keywords": ["ukraine", "flag", "nation", "country", "banner"],
        "char": "🇺🇦",
        "category": "flags"
    },
    "ae": {
        "keywords": ["united", "arab", "emirates", "flag", "nation", "country", "banner"],
        "char": "🇦🇪",
        "category": "flags"
    },
    "gb": {
        "keywords": ["united", "kingdom", "great", "britain", "northern", "ireland", "flag", "nation", "country", "banner", "british", "UK", "english", "england", "union jack"],
        "char": "🇬🇧",
        "category": "flags"
    },
    "us": {
        "keywords": ["united", "states", "america", "flag", "nation", "country", "banner"],
        "char": "🇺🇸",
        "category": "flags"
    },
    "vi": {
        "keywords": ["virgin", "islands", "us", "flag", "nation", "country", "banner"],
        "char": "🇻🇮",
        "category": "flags"
    },
    "uy": {
        "keywords": ["uruguay", "flag", "nation", "country", "banner"],
        "char": "🇺🇾",
        "category": "flags"
    },
    "uz": {
        "keywords": ["uzbekistan", "flag", "nation", "country", "banner"],
        "char": "🇺🇿",
        "category": "flags"
    },
    "vu": {
        "keywords": ["vanuatu", "flag", "nation", "country", "banner"],
        "char": "🇻🇺",
        "category": "flags"
    },
    "va": {
        "keywords": ["vatican", "city", "flag", "nation", "country", "banner"],
        "char": "🇻🇦",
        "category": "flags"
    },
    "ve": {
        "keywords": ["venezuela", "bolivarian", "republic", "flag", "nation", "country", "banner"],
        "char": "🇻🇪",
        "category": "flags"
    },
    "vn": {
        "keywords": ["viet", "nam", "flag", "nation", "country", "banner"],
        "char": "🇻🇳",
        "category": "flags"
    },
    "wf": {
        "keywords": ["wallis", "futuna", "flag", "nation", "country", "banner"],
        "char": "🇼🇫",
        "category": "flags"
    },
    "eh": {
        "keywords": ["western", "sahara", "flag", "nation", "country", "banner"],
        "char": "🇪🇭",
        "category": "flags"
    },
    "ye": {
        "keywords": ["yemen", "flag", "nation", "country", "banner"],
        "char": "🇾🇪",
        "category": "flags"
    },
    "zm": {
        "keywords": ["zambia", "flag", "nation", "country", "banner"],
        "char": "🇿🇲",
        "category": "flags"
    },
    "zw": {
        "keywords": ["zimbabwe", "flag", "nation", "country", "banner"],
        "char": "🇿🇼",
        "category": "flags"
    },
    "octocat": {
        "keywords": ["animal", "octopus", "github", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "shipit": {
        "keywords": ["squirrel", "detective", "animal", "sherlock", "inspector", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "bowtie": {
        "keywords": ["face", "formal", "fashion", "suit", "classy", "magic", "circus"],
        "char": null,
        "category": "_custom"
    },
    "neckbeard": {
        "keywords": ["nerdy", "face", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "metal": {
        "keywords": ["fingers", "rocknroll", "concert", "band", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "fu": {
        "keywords": ["fuck", "finger", "dislike", "thumbsdown", "disapprove", "no", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "trollface": {
        "keywords": ["internet", "meme", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "godmode": {
        "keywords": ["doom", "oldschool"],
        "char": null,
        "category": "_custom"
    },
    "goberserk": {
        "keywords": ["doom", "rage", "bloody", "hurt"],
        "char": null,
        "category": "_custom"
    },
    "finnadie": {
        "keywords": ["doom", "oldschool"],
        "char": null,
        "category": "_custom"
    },
    "feelsgood": {
        "keywords": ["doom", "oldschool"],
        "char": null,
        "category": "_custom"
    },
    "rage1": {
        "keywords": ["angry", "mad", "hate", "despise"],
        "char": null,
        "category": "_custom"
    },
    "rage2": {
        "keywords": ["angry", "mad", "hate", "despise"],
        "char": null,
        "category": "_custom"
    },
    "rage3": {
        "keywords": ["angry", "mad", "hate", "despise"],
        "char": null,
        "category": "_custom"
    },
    "rage4": {
        "keywords": ["angry", "mad", "hate", "despise"],
        "char": null,
        "category": "_custom"
    },
    "suspect": {
        "keywords": ["mad", "custom_"],
        "char": null,
        "category": "_custom"
    },
    "hurtrealbad": {
        "keywords": ["mad", "injured", "doom", "oldschool", "custom_"],
        "char": null,
        "category": "_custom"
    }
};

class EmojiSelectorPanelComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.activeCategory = 'people';
        this.searchResults = [];
        this.searchVisible = false;
        this.selected = new Subject();
    }
    get searchQuery() {
        return this._searchQuery;
    }
    set searchQuery(value) {
        this._searchQuery = value;
        setTimeout(() => {
            this.searchResults = Object.keys(EMOJIS).filter(k => k.includes(value)).map(k => EMOJIS[k]);
            this.searchResults.splice(50, this.searchResults.length);
            console.log(`looking for '${value}' => ${this.searchResults.length} results`);
        });
    }
    humanize(str) {
        return str.replace(/(^| )[a-z]/g, k => k.toUpperCase()).replace(/_/g, ' ');
    }
    select(char) {
        this.selected.next(char);
    }
    pairs(object) {
        return Object.keys(object).map(key => [key, object[key]]);
    }
    hideSearch() {
        // because of the "outside click detection"
        setTimeout(() => {
            this.searchVisible = false;
        });
    }
    showSearch() {
        // because of the "outside click detection"
        setTimeout(() => {
            this.searchVisible = true;
        });
    }
    ngOnInit() {
        let cats = {};
        let categoryIcons = {
            symbols: 'warning',
            people: 'people',
            animals_and_nature: 'nature',
            travel_and_places: 'location_on',
            activity: 'local_activity',
            food_and_drink: 'restaurant',
            objects: 'computer',
            flags: 'flag'
        };
        for (let pair of this.pairs(EMOJIS)) {
            let name = pair[0];
            let emoji = pair[1];
            if (!cats[emoji.category]) {
                cats[emoji.category] = {
                    name: emoji.category,
                    icon: categoryIcons[emoji.category] || 'code',
                    emojis: []
                };
            }
            emoji.html = this.sanitizer.bypassSecurityTrustHtml(twemoji.parse(emoji.char || ''));
            cats[emoji.category].emojis.push(emoji);
        }
        this.categories = this.pairs(cats).map(pair => pair[1]);
    }
}
EmojiSelectorPanelComponent.ɵfac = function EmojiSelectorPanelComponent_Factory(t) { return new (t || EmojiSelectorPanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
EmojiSelectorPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EmojiSelectorPanelComponent, selectors: [["emoji-selector-panel"]], outputs: { selected: "selected" }, decls: 4, vars: 3, consts: [["class", "search-box", 4, "ngIf"], [1, "selector"], [4, "ngIf"], [1, "search-box"], ["mat-icon-button", "", "href", "javascript:;", 3, "click"], ["appearance", "outline", "floatLabel", "always"], ["name", "search", "type", "text", "matInput", "", "placeholder", "Start typing", 3, "ngModel", "ngModelChange"], [1, "emoji-list"], ["href", "javascript:;", 3, "innerHtml", "click", 4, "ngFor", "ngForOf"], ["href", "javascript:;", 3, "innerHtml", "click"], [1, "categories"], [4, "ngFor", "ngForOf"], ["mat-icon-button", "", 3, "title", "active", "click", 4, "ngFor", "ngForOf"], ["title", "Search", "mat-icon-button", "", 3, "active", "click"], ["mat-icon-button", "", 3, "title", "click"], ["class", "emoji-list", 4, "ngIf"]], template: function EmojiSelectorPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EmojiSelectorPanelComponent_div_0_Template, 8, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, EmojiSelectorPanelComponent_ng_container_2_Template, 3, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, EmojiSelectorPanelComponent_ng_container_3_Template, 4, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchVisible);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchVisible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.MatAnchor, ɵngcc4.MatIcon, ɵngcc5.MatFormField, ɵngcc5.MatLabel, ɵngcc6.MatInput, ɵngcc7.DefaultValueAccessor, ɵngcc7.NgControlStatus, ɵngcc7.NgModel, ɵngcc1.NgForOf], styles: ["[_nghost-%COMP%]{background:#111;border:1px solid #333;border-radius:5px;color:#fff;max-width:calc(100vw - 1.5em);padding:.5em;width:calc(288px + 9em)}.selector[_ngcontent-%COMP%]{display:flex;flex-direction:column}.categories[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{opacity:.25;transition:opacity .4s ease-in-out}.categories[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{opacity:.5}.categories[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%]{opacity:1}.emoji-list[_ngcontent-%COMP%]{flex-grow:1;height:20em;overflow-y:auto}.emoji-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{background-color:#111;display:inline-block;margin:4px;padding:2px}.emoji-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]     .emoji{height:32px;width:32px}.emoji-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{background-color:#333}.search-box[_ngcontent-%COMP%]{align-items:baseline;display:flex}.search-box[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{flex-grow:1}@media (max-width:500px){.selector[_ngcontent-%COMP%]{flex-direction:row;height:27em}.emoji-list[_ngcontent-%COMP%]{height:auto}}"] });
EmojiSelectorPanelComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
EmojiSelectorPanelComponent.propDecorators = {
    selected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmojiSelectorPanelComponent, [{
        type: Component,
        args: [{
                selector: 'emoji-selector-panel',
                template: "<div class=\"search-box\" *ngIf=\"searchVisible\">\r\n\t<a mat-icon-button href=\"javascript:;\" (click)=\"hideSearch()\">\r\n\t\t<mat-icon>arrow_back</mat-icon>\r\n\t</a>\r\n\t<mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n\t\t<mat-label>Search for emoji</mat-label>\r\n\t\t<input name=\"search\" type=\"text\" matInput placeholder=\"Start typing\" [(ngModel)]=\"searchQuery\" />\r\n\t</mat-form-field>\r\n</div>\r\n\r\n<div class=\"selector\">\r\n\t<ng-container *ngIf=\"searchVisible\">\r\n\t\t<div class=\"emoji-list\">\r\n\t\t\t<a href=\"javascript:;\" (click)=\"select(emoji.char)\" \r\n\t\t\t\t*ngFor=\"let emoji of searchResults\" [innerHtml]=\"emoji.html || ''\">\r\n\t\t\t</a>\r\n\t\t</div>\r\n\t</ng-container>\r\n\t<ng-container *ngIf=\"!searchVisible\">\r\n\t\t<div class=\"categories\">\r\n\t\t\t<ng-container *ngIf=\"!searchVisible\">\r\n\t\t\t\t<a [title]=\"humanize(category.name)\" [class.active]=\"activeCategory === category.name\" mat-icon-button *ngFor=\"let category of categories\" (click)=\"activeCategory = category.name\">\r\n\t\t\t\t\t<mat-icon>{{category.icon}}</mat-icon>\r\n\t\t\t\t</a>\r\n\r\n\t\t\t\t<a title=\"Search\" [class.active] mat-icon-button (click)=\"showSearch()\">\r\n\t\t\t\t\t<mat-icon>search</mat-icon>\r\n\t\t\t\t</a>\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t\t<ng-container *ngFor=\"let category of categories\">\r\n\t\t\t<div class=\"emoji-list\" *ngIf=\"activeCategory && activeCategory == category.name\">\r\n\t\t\t\t<a href=\"javascript:;\" (click)=\"select(emoji.char)\" \r\n\t\t\t\t\t*ngFor=\"let emoji of category.emojis\" [innerHtml]=\"emoji.html || ''\">\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t</ng-container>\r\n\t</ng-container>\r\n</div>",
                styles: [":host{background:#111;border:1px solid #333;border-radius:5px;color:#fff;max-width:calc(100vw - 1.5em);padding:.5em;width:calc(288px + 9em)}.selector{display:flex;flex-direction:column}.categories a{opacity:.25;transition:opacity .4s ease-in-out}.categories a:hover{opacity:.5}.categories a.active{opacity:1}.emoji-list{flex-grow:1;height:20em;overflow-y:auto}.emoji-list a{background-color:#111;display:inline-block;margin:4px;padding:2px}.emoji-list a ::ng-deep .emoji{height:32px;width:32px}.emoji-list a:hover{background-color:#333}.search-box{align-items:baseline;display:flex}.search-box mat-form-field{flex-grow:1}@media (max-width:500px){.selector{flex-direction:row;height:27em}.emoji-list{height:auto}}"]
            }]
    }], function () { return [{ type: ɵngcc2.DomSanitizer }]; }, { selected: [{
            type: Output
        }] }); })();

class EmojiSelectorButtonComponent {
    constructor() {
        this._selected = new Subject();
        this.showEmojiPanel = false;
    }
    get selected() {
        return this._selected;
    }
    ngOnDestroy() {
        this.removeListener();
        this.panelElement.nativeElement.remove();
    }
    ngAfterViewInit() {
        let root = document.body.querySelector('[ng-version]') || document.body;
        root.appendChild(this.panelElement.nativeElement);
    }
    removeListener() {
        document.removeEventListener('click', this.clickListener);
        window.removeEventListener('resize', this.resizeListener);
    }
    place() {
        let pos = this.buttonElement.nativeElement.getBoundingClientRect();
        let size = this.panelElement.nativeElement.getBoundingClientRect();
        let left = window.scrollX + pos.left + pos.width - size.width;
        if (left < 0)
            left = (window.scrollX + window.innerWidth) / 2 - size.width / 2;
        Object.assign(this.panelElement.nativeElement.style, {
            top: `${window.scrollY + pos.top + pos.height}px`,
            left: `${Math.max(0, left)}px`
        });
    }
    show() {
        if (this.showEmojiPanel) {
            this.showEmojiPanel = false;
            return;
        }
        this.showEmojiPanel = true;
        this.place();
        setTimeout(() => {
            this.resizeListener = () => {
                if (!this.showEmojiPanel)
                    return;
                this.place();
            };
            this.clickListener = (ev) => {
                let parent = ev.target;
                let isInDialog = false;
                while (parent) {
                    if (parent.matches('emoji-selector-panel'))
                        isInDialog = true;
                    parent = parent.parentElement;
                }
                if (isInDialog)
                    return;
                this.showEmojiPanel = false;
                this.removeListener();
            };
            document.addEventListener('click', this.clickListener);
            window.addEventListener('resize', this.resizeListener);
        });
    }
    insert(str) {
        this._selected.next(str);
    }
}
EmojiSelectorButtonComponent.ɵfac = function EmojiSelectorButtonComponent_Factory(t) { return new (t || EmojiSelectorButtonComponent)(); };
EmojiSelectorButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EmojiSelectorButtonComponent, selectors: [["emoji-selector-button"]], viewQuery: function EmojiSelectorButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c1, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonElement = _t.first);
    } }, outputs: { selected: "selected" }, decls: 6, vars: 2, consts: [["type", "button", "mat-icon-button", "", 3, "click"], ["button", ""], [3, "selected"], ["panel", ""]], template: function EmojiSelectorButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("click", function EmojiSelectorButtonComponent_Template_button_click_0_listener() { return ctx.show(); });
        ɵngcc0.ɵɵelementStart(2, "mat-icon");
        ɵngcc0.ɵɵtext(3, "emoji_emotions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "emoji-selector-panel", 2, 3);
        ɵngcc0.ɵɵlistener("selected", function EmojiSelectorButtonComponent_Template_emoji_selector_panel_selected_4_listener($event) { return ctx.insert($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("visible", ctx.showEmojiPanel);
    } }, directives: [ɵngcc3.MatButton, ɵngcc4.MatIcon, EmojiSelectorPanelComponent], styles: ["[_nghost-%COMP%] {\n            display: block;\n            position: relative;\n        }\n\n        emoji-selector-panel[_ngcontent-%COMP%] {\n            position: absolute;\n            \n            opacity: 0;\n            pointer-events: none;\n            z-index: 10;\n        }\n\n        emoji-selector-panel.visible[_ngcontent-%COMP%] {\n            pointer-events: initial;\n            opacity: 1;\n        }\n\n        button[_ngcontent-%COMP%] {\n            color: #666\n        }"] });
EmojiSelectorButtonComponent.propDecorators = {
    selected: [{ type: Output }],
    panelElement: [{ type: ViewChild, args: ['panel', { read: ElementRef },] }],
    buttonElement: [{ type: ViewChild, args: ['button', { read: ElementRef },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmojiSelectorButtonComponent, [{
        type: Component,
        args: [{
                selector: 'emoji-selector-button',
                template: `
        <button #button type="button" mat-icon-button (click)="show()">
            <mat-icon>emoji_emotions</mat-icon>
        </button>
        <emoji-selector-panel 
            #panel
            (selected)="insert($event)"
            [class.visible]="showEmojiPanel"
            ></emoji-selector-panel>
    `,
                styles: [`
        :host {
            display: block;
            position: relative;
        }

        emoji-selector-panel {
            position: absolute;
            /* bottom: 2.5em;
            right: 0; */
            opacity: 0;
            pointer-events: none;
            z-index: 10;
        }

        emoji-selector-panel.visible {
            pointer-events: initial;
            opacity: 1;
        }

        button {
            color: #666
        }

        /* :host.bottom-left emoji-selector-panel {
            right: auto;
            left: 0;
        }

        :host.top-right emoji-selector-panel {
            top: 2.4em;
            bottom: auto;
        }

        :host.top-left emoji-selector-panel {
            top: 2.4em;
            bottom: auto;
            left: 0;
            right: auto;
        } */
    `]
            }]
    }], function () { return []; }, { selected: [{
            type: Output
        }], panelElement: [{
            type: ViewChild,
            args: ['panel', { read: ElementRef }]
        }], buttonElement: [{
            type: ViewChild,
            args: ['button', { read: ElementRef }]
        }] }); })();

const COMPONENTS$1 = [
    EmojiSelectorPanelComponent,
    EmojiSelectorButtonComponent
];
class EmojiModule {
}
EmojiModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EmojiModule });
EmojiModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EmojiModule_Factory(t) { return new (t || EmojiModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatIconModule,
            MatButtonModule,
            MatFormFieldModule,
            MatInputModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EmojiModule, { declarations: function () { return [EmojiSelectorPanelComponent, EmojiSelectorButtonComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule]; }, exports: function () { return [EmojiSelectorPanelComponent, EmojiSelectorButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmojiModule, [{
        type: NgModule,
        args: [{
                declarations: COMPONENTS$1,
                imports: [
                    CommonModule,
                    FormsModule,
                    MatIconModule,
                    MatButtonModule,
                    MatFormFieldModule,
                    MatInputModule
                ],
                exports: COMPONENTS$1
            }]
    }], null, null); })();

class ChatMessageComponent {
    constructor() {
        this._selected = new Subject();
        this._reported = new Subject();
        this._upvoted = new Subject();
        this._userSelected = new Subject();
    }
    get userSelected() {
        return this._userSelected;
    }
    get selected() {
        return this._selected;
    }
    get reported() {
        return this._reported;
    }
    get upvoted() {
        return this._upvoted;
    }
    avatarForUser(user) {
        if (user && user.avatarUrl) {
            let url = user.avatarUrl;
            return `url(${url})`;
        }
        return null;
    }
    upvote() {
        this._upvoted.next();
    }
    report() {
        this._reported.next();
    }
    select() {
        this._selected.next();
    }
    selectUser() {
        this._userSelected.next();
    }
}
ChatMessageComponent.ɵfac = function ChatMessageComponent_Factory(t) { return new (t || ChatMessageComponent)(); };
ChatMessageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatMessageComponent, selectors: [["banta-chat-message"]], inputs: { message: "message" }, outputs: { userSelected: "userSelected", selected: "selected", reported: "reported", upvoted: "upvoted" }, decls: 17, vars: 7, consts: [[1, "message-content"], [1, "user", 3, "click"], [1, "avatar"], [1, "content"], [3, "click"], [1, "status"], ["class", "count-indicator", 4, "ngIf"], [1, "actions"], ["mat-icon-button", "", "matTooltip", "Upvote", "matTooltipPosition", "below", 3, "click"], [3, "inline"], ["mat-icon-button", "", "matTooltip", "Report", "matTooltipPosition", "below", 3, "click"], [1, "count-indicator"]], template: function ChatMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function ChatMessageComponent_Template_div_click_1_listener() { return ctx.selectUser(); });
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵlistener("click", function ChatMessageComponent_Template_div_click_6_listener() { return ctx.select(); });
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtemplate(9, ChatMessageComponent_div_9_Template, 4, 2, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵelementStart(11, "button", 8);
        ɵngcc0.ɵɵlistener("click", function ChatMessageComponent_Template_button_click_11_listener() { return ctx.upvote(); });
        ɵngcc0.ɵɵelementStart(12, "mat-icon", 9);
        ɵngcc0.ɵɵtext(13, "thumb_up");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 10);
        ɵngcc0.ɵɵlistener("click", function ChatMessageComponent_Template_button_click_14_listener() { return ctx.report(); });
        ɵngcc0.ɵɵelementStart(15, "mat-icon", 9);
        ɵngcc0.ɵɵtext(16, "report");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("background-image", ctx.avatarForUser(ctx.message.user));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message.user.username);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.message.message, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.upvotes > 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("inline", true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("inline", true);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.MatButton, ɵngcc4.MatIcon], styles: ["[_nghost-%COMP%]{align-items:center;background-color:#fff;color:#000;display:flex;flex-direction:row;padding:0 1em;transition:background-color .4s ease-out}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#111}[_nghost-%COMP%]:hover{background-color:#ddd}.highlight[_nghost-%COMP%]{background:#00121b}.highlight[_nghost-%COMP%]:hover{background:#01324d}[_nghost-%COMP%]:nth-child(2n){background-color:#eee}[_nghost-%COMP%]:nth-child(2n):hover{background:#ddd}[_nghost-%COMP%]:nth-child(2n)   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#222}[_nghost-%COMP%]:nth-child(2n).highlight{background:#001a2a}[_nghost-%COMP%]:nth-child(2n).highlight:hover{background:#002b44}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row;flex-grow:1}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:5px 0}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .status[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row;margin-left:1em}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .status[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{margin-left:.5em}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]{align-items:center;color:#999;display:flex;flex-shrink:0;font-weight:400;margin-right:.25em;text-align:right}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{background-color:#333;background-position:50%;background-size:cover;border-radius:100%;flex-grow:0;flex-shrink:0;height:2em;margin-right:1em;width:2em}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]:after{content:\":\";margin-right:1em}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{flex-grow:1}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]{flex-shrink:0;opacity:0;transition:opacity .4s ease-out;white-space:nowrap}[_nghost-%COMP%]:hover   .actions[_ngcontent-%COMP%]{opacity:1}.count-indicator[_ngcontent-%COMP%]{white-space:nowrap}.mat-dark-theme[_nghost-%COMP%], .mat-dark-theme   [_nghost-%COMP%]{background-color:#000;color:#fff}.mat-dark-theme[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#ddd}.mat-dark-theme[_nghost-%COMP%]:hover, .mat-dark-theme   [_nghost-%COMP%]:hover{background-color:#111}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n).highlight, .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n).highlight{background:#001a2a}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n).highlight:hover, .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n).highlight:hover{background:#002b44}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n):hover, .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n):hover{background-color:#111}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n), .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n){background-color:#080808}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n)   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n)   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#eee}label[_ngcontent-%COMP%]{margin:0}"] });
ChatMessageComponent.propDecorators = {
    message: [{ type: Input }],
    userSelected: [{ type: Output }],
    selected: [{ type: Output }],
    reported: [{ type: Output }],
    upvoted: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatMessageComponent, [{
        type: Component,
        args: [{
                selector: 'banta-chat-message',
                template: "<div class=\"message-content\">\r\n    <div class=\"user\" (click)=\"selectUser()\">\r\n        <div class=\"avatar\" [style.background-image]=\"avatarForUser(message.user)\"></div>\r\n        <label>{{message.user.username}}</label>\r\n    </div>\r\n    <div class=\"content\">\r\n        <div (click)=\"select()\">\r\n            {{message.message}}\r\n        </div>\r\n        <div class=\"status\">\r\n            <div class=\"count-indicator\" *ngIf=\"message.upvotes > 0\">\r\n                {{message.upvotes}} <mat-icon [inline]=\"true\">star</mat-icon>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"actions\">\r\n    <button mat-icon-button matTooltip=\"Upvote\" matTooltipPosition=\"below\" (click)=\"upvote()\">\r\n        <mat-icon [inline]=\"true\">thumb_up</mat-icon>\r\n    </button>\r\n    <button mat-icon-button matTooltip=\"Report\" matTooltipPosition=\"below\" (click)=\"report()\">\r\n        <mat-icon [inline]=\"true\">report</mat-icon>\r\n    </button>\r\n</div>",
                styles: [":host{align-items:center;background-color:#fff;color:#000;display:flex;flex-direction:row;padding:0 1em;transition:background-color .4s ease-out}:host .message-content .content{color:#111}:host:hover{background-color:#ddd}:host.highlight{background:#00121b}:host.highlight:hover{background:#01324d}:host:nth-child(2n){background-color:#eee}:host:nth-child(2n):hover{background:#ddd}:host:nth-child(2n) .message-content .content{color:#222}:host:nth-child(2n).highlight{background:#001a2a}:host:nth-child(2n).highlight:hover{background:#002b44}:host .message-content{align-items:center;display:flex;flex-direction:row;flex-grow:1}:host .message-content .content{display:flex;flex-direction:row;padding:5px 0}:host .message-content .content .status{align-items:center;display:flex;flex-direction:row;margin-left:1em}:host .message-content .content .status mat-icon{margin-left:.5em}:host .user{align-items:center;color:#999;display:flex;flex-shrink:0;font-weight:400;margin-right:.25em;text-align:right}:host .user .avatar{background-color:#333;background-position:50%;background-size:cover;border-radius:100%;flex-grow:0;flex-shrink:0;height:2em;margin-right:1em;width:2em}:host .user:after{content:\":\";margin-right:1em}:host .content{flex-grow:1}:host .actions{flex-shrink:0;opacity:0;transition:opacity .4s ease-out;white-space:nowrap}:host:hover .actions{opacity:1}.count-indicator{white-space:nowrap}:host-context(.mat-dark-theme){background-color:#000;color:#fff}:host-context(.mat-dark-theme) .message-content .content{color:#ddd}:host-context(.mat-dark-theme):hover{background-color:#111}:host-context(.mat-dark-theme):nth-child(2n).highlight{background:#001a2a}:host-context(.mat-dark-theme):nth-child(2n).highlight:hover{background:#002b44}:host-context(.mat-dark-theme):nth-child(2n):hover{background-color:#111}:host-context(.mat-dark-theme):nth-child(2n){background-color:#080808}:host-context(.mat-dark-theme):nth-child(2n) .message-content .content{color:#eee}label{margin:0}"]
            }]
    }], function () { return []; }, { userSelected: [{
            type: Output
        }], selected: [{
            type: Output
        }], reported: [{
            type: Output
        }], upvoted: [{
            type: Output
        }], message: [{
            type: Input
        }] }); })();

class LiveChatMessageComponent {
    constructor(backend) {
        this.backend = backend;
        this._upvoted = new Subject();
        this._reported = new Subject();
        this._selected = new Subject();
    }
    get upvoted() {
        return this._upvoted;
    }
    get reported() {
        return this._reported;
    }
    get selected() {
        return this._selected;
    }
    get message() {
        return this._message;
    }
    set message(value) {
        let originalId = null;
        if (this._message)
            originalId = this._message.id;
        this._message = value;
        if (value && originalId === value.id) {
            return;
        }
        if (this.unsubscribe)
            this.unsubscribe();
        if (value) {
            this.unsubscribe = this.backend.watchMessage(value, message => this.message = message);
        }
    }
    report() {
        this._reported.next();
    }
    upvote() {
        this._upvoted.next();
    }
    select() {
        this._selected.next();
    }
}
LiveChatMessageComponent.ɵfac = function LiveChatMessageComponent_Factory(t) { return new (t || LiveChatMessageComponent)(ɵngcc0.ɵɵdirectiveInject(ChatBackendService)); };
LiveChatMessageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LiveChatMessageComponent, selectors: [["banta-live-chat-message"]], inputs: { message: "message" }, outputs: { upvoted: "upvoted", reported: "reported", selected: "selected" }, decls: 1, vars: 1, consts: [[3, "message", "upvoted", "reported", "selected", 4, "ngIf"], [3, "message", "upvoted", "reported", "selected"]], template: function LiveChatMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LiveChatMessageComponent_banta_chat_message_0_Template, 1, 1, "banta-chat-message", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
    } }, directives: [ɵngcc1.NgIf, ChatMessageComponent], styles: [""] });
LiveChatMessageComponent.ctorParameters = () => [
    { type: ChatBackendService }
];
LiveChatMessageComponent.propDecorators = {
    upvoted: [{ type: Output }],
    reported: [{ type: Output }],
    selected: [{ type: Output }],
    message: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveChatMessageComponent, [{
        type: Component,
        args: [{
                selector: 'banta-live-chat-message',
                template: `
        <banta-chat-message 
            *ngIf="message"
            [message]="message"
            (upvoted)="upvote()"
            (reported)="report()"
            (selected)="select()"
            ></banta-chat-message>
    `,
                styles: [``]
            }]
    }], function () { return [{ type: ChatBackendService }]; }, { upvoted: [{
            type: Output
        }], reported: [{
            type: Output
        }], selected: [{
            type: Output
        }], message: [{
            type: Input
        }] }); })();

class ChatViewComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._sourceSubs = new SubSink();
        this._selected = new Subject();
        this._reported = new Subject();
        this._upvoted = new Subject();
        this._userSelected = new Subject();
        this.messages = [];
        this.maxMessages = 200;
    }
    get source() {
        return this._source;
    }
    get selected() {
        return this._selected;
    }
    get userSelected() {
        return this._userSelected;
    }
    get reported() {
        return this._reported;
    }
    get upvoted() {
        return this._upvoted;
    }
    set source(value) {
        if (this._sourceSubs) {
            this._sourceSubs.unsubscribe();
            this._sourceSubs = null;
        }
        this._source = value;
        this.messages = [];
        if (value) {
            this._sourceSubs = new SubSink();
            this.messages = value.messages.slice();
            console.log(`Source set:`);
            console.dir(value);
            console.log(`Messages loaded:`);
            console.dir(this.messages);
            this._sourceSubs.add(this._source.messageReceived
                .subscribe(msg => this.messageReceived(msg)), this._source.messageSent
                .subscribe(msg => this.messageSent(msg)));
            if (this._source.currentUserChanged) {
                this._sourceSubs.add(this._source.currentUserChanged
                    .subscribe(user => this.currentUser = user));
            }
        }
    }
    addMessage(message) {
        if (this.messages.length > this.maxMessages + 1) {
            while (this.messages.length > this.maxMessages)
                this.messages.shift();
        }
        this.messages.push(message);
    }
    messageReceived(message) {
        this.addMessage(message);
        if (this.isScrolledToLatest())
            setTimeout(() => this.scrollToLatest());
    }
    isScrolledToLatest() {
        if (!this.messageContainer)
            return false;
        let el = this.messageContainer.nativeElement;
        let currentScroll = el.scrollTop;
        let currentTotal = el.scrollHeight - el.offsetHeight;
        return currentScroll > currentTotal - 10;
    }
    messageSent(message) {
        this.addMessage(message);
        if (!this.messageContainer)
            return;
        setTimeout(() => this.scrollToLatest());
    }
    scrollToLatest() {
        if (!this.messageContainer)
            return;
        let el = this.messageContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
    }
    jumpTo(message) {
        let element = this.elementRef.nativeElement;
        let messageElement = element.querySelector(`banta-chat-message[data-id="${message.id}"]`);
        if (!messageElement) {
            alert(`could not find message ${message.id}`);
            return;
        }
        messageElement.scrollIntoView({ behavior: 'smooth' });
        this.flashMessage(message);
    }
    flashMessage(message) {
        if (!message)
            return;
        this.flashedMessageId = message.id;
        //setTimeout(() => this.flashedMessageId = null, 250);
    }
    mentionsMe(message) {
        if (!this.currentUser)
            return false;
        if (message.message.includes(`@${this.currentUser.username}`))
            return true;
        return false;
    }
    upvoteMessage(message) {
        this._upvoted.next(message);
    }
    reportMessage(message) {
        this._reported.next(message);
    }
    selectMessage(message) {
        this._selected.next(message);
    }
    selectMessageUser(message) {
        this._userSelected.next(message);
    }
    avatarForUser(user) {
        if (user && user.avatarUrl) {
            let url = user.avatarUrl;
            return `url(${url})`;
        }
        return null;
    }
}
ChatViewComponent.ɵfac = function ChatViewComponent_Factory(t) { return new (t || ChatViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ChatViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatViewComponent, selectors: [["banta-chat-view"]], viewQuery: function ChatViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageContainer = _t.first);
    } }, inputs: { maxMessages: "maxMessages", source: "source" }, outputs: { selected: "selected", userSelected: "userSelected", reported: "reported", upvoted: "upvoted" }, ngContentSelectors: _c4, decls: 5, vars: 1, consts: [[1, "message-container"], ["messageContainer", ""], [3, "message", "highlight", "flash", "selected", "upvoted", "reported", "userSelected", 4, "ngFor", "ngForOf"], [3, "message", "selected", "upvoted", "reported", "userSelected"]], template: function ChatViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵtemplate(3, ChatViewComponent_banta_chat_message_3_Template, 1, 6, "banta-chat-message", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messages);
    } }, directives: [ɵngcc1.NgForOf, ChatMessageComponent], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex-grow:1}.message-container[_ngcontent-%COMP%]{background:#fff;color:#000;flex-grow:1;height:10em;overflow-x:hidden;overflow-y:auto;padding:.5em 1em .5em .5em}.message-container.no-scroll[_ngcontent-%COMP%]{height:auto;overflow-y:visible}.mat-dark-theme[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]{background:#000;color:#fff}banta-chat-message.flash[_ngcontent-%COMP%]{-webkit-animation:flash;-webkit-animation-duration:2.5s;-webkit-animation-iteration-count:1;animation:flash;animation-duration:2.5s;animation-iteration-count:1}@-webkit-keyframes flash{0%{background:#425700;transform:scale(1)}25%{transform:scale(1.05)}50%{transform:scale(1)}75%{transform:scale(1.05)}to{transform:scale(1)}}@keyframes flash{0%{background:#425700;transform:scale(1)}25%{transform:scale(1.05)}50%{transform:scale(1)}75%{transform:scale(1.05)}to{transform:scale(1)}}"] });
ChatViewComponent.ctorParameters = () => [
    { type: ElementRef }
];
ChatViewComponent.propDecorators = {
    source: [{ type: Input }],
    selected: [{ type: Output }],
    userSelected: [{ type: Output }],
    reported: [{ type: Output }],
    upvoted: [{ type: Output }],
    messageContainer: [{ type: ViewChild, args: ['messageContainer',] }],
    maxMessages: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatViewComponent, [{
        type: Component,
        args: [{
                selector: 'banta-chat-view',
                template: "<div class=\"message-container\" #messageContainer>\r\n    <ng-content select=\"[data-before]\"></ng-content>\r\n    <banta-chat-message \r\n        *ngFor=\"let message of messages\"\r\n        [message]=\"message\"\r\n        [class.highlight]=\"mentionsMe(message)\" \r\n        [class.flash]=\"message.id === flashedMessageId\"\r\n        (selected)=\"selectMessage(message)\"\r\n        (upvoted)=\"upvoteMessage(message)\"\r\n        (reported)=\"reportMessage(message)\"\r\n        (userSelected)=\"selectMessageUser(message)\"\r\n        [attr.data-id]=\"message.id\"\r\n        >\r\n        </banta-chat-message>\r\n    <ng-content select=\":not([data-before])\"></ng-content>\r\n</div>",
                styles: [":host{display:flex;flex-direction:column;flex-grow:1}.message-container{background:#fff;color:#000;flex-grow:1;height:10em;overflow-x:hidden;overflow-y:auto;padding:.5em 1em .5em .5em}.message-container.no-scroll{height:auto;overflow-y:visible}:host-context(.mat-dark-theme) .message-container{background:#000;color:#fff}banta-chat-message.flash{-webkit-animation:flash;-webkit-animation-duration:2.5s;-webkit-animation-iteration-count:1;animation:flash;animation-duration:2.5s;animation-iteration-count:1}@-webkit-keyframes flash{0%{background:#425700;transform:scale(1)}25%{transform:scale(1.05)}50%{transform:scale(1)}75%{transform:scale(1.05)}to{transform:scale(1)}}@keyframes flash{0%{background:#425700;transform:scale(1)}25%{transform:scale(1.05)}50%{transform:scale(1)}75%{transform:scale(1.05)}to{transform:scale(1)}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { maxMessages: [{
            type: Input
        }], source: [{
            type: Input
        }], selected: [{
            type: Output
        }], userSelected: [{
            type: Output
        }], reported: [{
            type: Output
        }], upvoted: [{
            type: Output
        }], messageContainer: [{
            type: ViewChild,
            args: ['messageContainer']
        }] }); })();

/**
 * Chat component
 */
class BantaChatComponent {
    constructor(banta, backend, elementRef) {
        this.banta = banta;
        this.backend = backend;
        this.elementRef = elementRef;
        this._subs = new SubSink();
        this.user = null;
        this.signInLabel = 'Sign In';
        this.sendLabel = 'Send';
        this.permissionDeniedLabel = 'Send';
        this._selected = new Subject();
        this._reported = new Subject();
        this._upvoted = new Subject();
        this._userSelected = new Subject();
        this._signInSelected = new Subject();
        this._permissionDeniedError = new Subject();
        this.showEmojiPanel = false;
        this.newMessage = {};
    }
    ngOnInit() {
        this._subs.add(this.banta.userChanged.subscribe(user => this.user = user));
    }
    ngOnDestroy() {
        this._subs.unsubscribe();
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }
    get topicID() {
        return this._source.identifier;
    }
    set topicID(value) {
        this.setSourceFromTopicID(value);
    }
    setSourceFromTopicID(topicID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._source && this._source.close)
                this._source.close();
            this._source = null;
            this._source = yield this.backend.getSourceForTopic(topicID);
        });
    }
    get signInSelected() {
        return this._signInSelected;
    }
    get permissionDeniedError() {
        return this._permissionDeniedError;
    }
    showSignIn() {
        this._signInSelected.next();
    }
    sendPermissionError() {
        this._permissionDeniedError.next();
    }
    insertEmoji(emoji) {
        let message = this.newMessage.message || '';
        this.newMessage.message = message + emoji;
    }
    onKeyDown(event) {
        // TODO
    }
    jumpToMessage(message) {
        if (this.chatView)
            this.chatView.jumpTo(message);
    }
    select(message) {
        this._selected.next(message);
    }
    selectUser(message) {
        this._userSelected.next(message);
    }
    report(message) {
        this._reported.next(message);
    }
    upvote(message) {
        this._upvoted.next(message);
    }
    get selected() {
        return this._selected;
    }
    get reported() {
        return this._reported;
    }
    get upvoted() {
        return this._upvoted;
    }
    get userSelected() {
        return this._userSelected;
    }
    get canChat() {
        var _a;
        if (!this.user)
            return false;
        if (!this.user.permissions)
            return true;
        if (!this.user.permissions.canChat)
            return true;
        return (_a = this.user.permissions) === null || _a === void 0 ? void 0 : _a.canChat(this.source);
    }
    sendMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.source)
                return;
            let text = (this.newMessage.message || '').trim();
            this.newMessage.message = '';
            if (text === '')
                return;
            let message = {
                user: null,
                sentAt: Date.now(),
                upvotes: 0,
                url: location.href,
                message: text
            };
            try {
                yield this.source.send(message);
            }
            catch (e) {
                console.error(`Failed to send message: `, message);
                console.error(e);
            }
        });
    }
}
BantaChatComponent.ɵfac = function BantaChatComponent_Factory(t) { return new (t || BantaChatComponent)(ɵngcc0.ɵɵdirectiveInject(BantaService), ɵngcc0.ɵɵdirectiveInject(ChatBackendService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BantaChatComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BantaChatComponent, selectors: [["banta-chat"]], viewQuery: function BantaChatComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chatView = _t.first);
    } }, inputs: { signInLabel: "signInLabel", sendLabel: "sendLabel", permissionDeniedLabel: "permissionDeniedLabel", source: "source", topicID: "topicID" }, outputs: { signInSelected: "signInSelected", permissionDeniedError: "permissionDeniedError", selected: "selected", reported: "reported", upvoted: "upvoted", userSelected: "userSelected" }, decls: 9, vars: 4, consts: [[3, "source", "upvoted", "reported", "selected", "userSelected"], ["chatView", ""], [1, "new-message", 3, "submit"], [1, "entry-container"], ["type", "text", "name", "message", 3, "ngModel", "keydown", "ngModelChange"], [3, "selected"], [1, "actions"], [4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "click"], ["mat-raised-button", "", "color", "primary", 3, "disabled", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", 3, "disabled"]], template: function BantaChatComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "banta-chat-view", 0, 1);
        ɵngcc0.ɵɵlistener("upvoted", function BantaChatComponent_Template_banta_chat_view_upvoted_0_listener($event) { return ctx.upvote($event); })("reported", function BantaChatComponent_Template_banta_chat_view_reported_0_listener($event) { return ctx.report($event); })("selected", function BantaChatComponent_Template_banta_chat_view_selected_0_listener($event) { return ctx.select($event); })("userSelected", function BantaChatComponent_Template_banta_chat_view_userSelected_0_listener($event) { return ctx.selectUser($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "form", 2);
        ɵngcc0.ɵɵlistener("submit", function BantaChatComponent_Template_form_submit_2_listener() { return ctx.sendMessage(); });
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "input", 4);
        ɵngcc0.ɵɵlistener("keydown", function BantaChatComponent_Template_input_keydown_4_listener($event) { return ctx.onKeyDown($event); })("ngModelChange", function BantaChatComponent_Template_input_ngModelChange_4_listener($event) { return ctx.newMessage.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "emoji-selector-button", 5);
        ɵngcc0.ɵɵlistener("selected", function BantaChatComponent_Template_emoji_selector_button_selected_5_listener($event) { return ctx.insertEmoji($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtemplate(7, BantaChatComponent_ng_container_7_Template, 3, 1, "ng-container", 7);
        ɵngcc0.ɵɵtemplate(8, BantaChatComponent_ng_container_8_Template, 3, 2, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("source", ctx.source);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.newMessage.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.user);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.user);
    } }, directives: [ChatViewComponent, ɵngcc7.ɵangular_packages_forms_forms_y, ɵngcc7.NgControlStatusGroup, ɵngcc7.NgForm, ɵngcc7.DefaultValueAccessor, ɵngcc7.NgControlStatus, ɵngcc7.NgModel, EmojiSelectorButtonComponent, ɵngcc1.NgIf, ɵngcc3.MatButton], styles: ["[_nghost-%COMP%]{border-radius:5px;flex-direction:column;font-size:10pt;padding:10px}.entry-container[_ngcontent-%COMP%], [_nghost-%COMP%]{display:flex;flex-grow:1}.entry-container[_ngcontent-%COMP%]{flex-direction:row;position:relative}.entry-container[_ngcontent-%COMP%]   emoji-selector-button[_ngcontent-%COMP%]{position:absolute;right:0;top:.15em}.entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-size:12pt;height:2.6em;padding-left:1em}.entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill, .entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill:focus, .entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill:hover{-webkit-box-shadow:0 0 0 1000px #211e07 inset;-webkit-text-fill-color:#9da302;-webkit-transition:background-color 5000s ease-in-out 0s;caret-color:#9da302;outline:1px solid #9da302;transition:background-color 5000s ease-in-out 0s}.entry-container[_ngcontent-%COMP%]   emoji-selector-panel[_ngcontent-%COMP%]{bottom:3.5em;opacity:0;pointer-events:none;position:absolute;right:0}.entry-container[_ngcontent-%COMP%]   emoji-selector-panel.visible[_ngcontent-%COMP%]{opacity:1;pointer-events:auto}form[_ngcontent-%COMP%]{align-items:center;display:flex;padding:.5em 0}form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#000;border:1px solid #333;color:#fff;font-size:14pt;min-height:6em;width:100%}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#fff;border:1px solid #ccc;color:#000;height:2.5em;width:100%}form[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{margin-left:1em}form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;margin:0 0 0 auto}.mat-dark-theme[_nghost-%COMP%]   form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#000;border:1px solid #333;color:#fff}"] });
BantaChatComponent.ctorParameters = () => [
    { type: BantaService },
    { type: ChatBackendService },
    { type: ElementRef }
];
BantaChatComponent.propDecorators = {
    source: [{ type: Input }],
    topicID: [{ type: Input }],
    signInLabel: [{ type: Input }],
    sendLabel: [{ type: Input }],
    permissionDeniedLabel: [{ type: Input }],
    signInSelected: [{ type: Output }],
    permissionDeniedError: [{ type: Output }],
    chatView: [{ type: ViewChild, args: ['chatView', { static: true },] }],
    selected: [{ type: Output }],
    reported: [{ type: Output }],
    upvoted: [{ type: Output }],
    userSelected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaChatComponent, [{
        type: Component,
        args: [{
                selector: 'banta-chat',
                template: "<banta-chat-view \r\n    #chatView\r\n    [source]=\"source\"\r\n    (upvoted)=\"upvote($event)\"\r\n    (reported)=\"report($event)\"\r\n    (selected)=\"select($event)\"\r\n    (userSelected)=\"selectUser($event)\"\r\n    ></banta-chat-view>\r\n\r\n<form class=\"new-message\" (submit)=\"sendMessage()\">\r\n    \r\n    <div class=\"entry-container\">\r\n        <input\r\n            type=\"text\"\r\n            name=\"message\" \r\n            (keydown)=\"onKeyDown($event)\"\r\n            [(ngModel)]=\"newMessage.message\" />\r\n            \r\n        <emoji-selector-button\r\n            (selected)=\"insertEmoji($event)\"\r\n            ></emoji-selector-button>\r\n    </div>\r\n\r\n    <div class=\"actions\">\r\n\r\n        <ng-container *ngIf=\"!user\">\r\n            <button type=\"button\" (click)=\"showSignIn()\" mat-raised-button color=\"primary\">{{signInLabel}}</button>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"user\">\r\n            <button *ngIf=\"canChat\" [disabled]=\"!newMessage.message\" mat-raised-button color=\"primary\">{{sendLabel}}</button>\r\n            <button *ngIf=\"!canChat\" type=\"button\" (click)=\"sendPermissionError()\" mat-raised-button color=\"primary\">{{permissionDeniedLabel}}</button>\r\n        </ng-container>\r\n    </div>\r\n</form>",
                styles: [":host{border-radius:5px;flex-direction:column;font-size:10pt;padding:10px}.entry-container,:host{display:flex;flex-grow:1}.entry-container{flex-direction:row;position:relative}.entry-container emoji-selector-button{position:absolute;right:0;top:.15em}.entry-container input{font-size:12pt;height:2.6em;padding-left:1em}.entry-container input:-webkit-autofill,.entry-container input:-webkit-autofill:focus,.entry-container input:-webkit-autofill:hover{-webkit-box-shadow:0 0 0 1000px #211e07 inset;-webkit-text-fill-color:#9da302;-webkit-transition:background-color 5000s ease-in-out 0s;caret-color:#9da302;outline:1px solid #9da302;transition:background-color 5000s ease-in-out 0s}.entry-container emoji-selector-panel{bottom:3.5em;opacity:0;pointer-events:none;position:absolute;right:0}.entry-container emoji-selector-panel.visible{opacity:1;pointer-events:auto}form{align-items:center;display:flex;padding:.5em 0}form textarea{background:#000;border:1px solid #333;color:#fff;font-size:14pt;min-height:6em;width:100%}form input[type=text]{background:#fff;border:1px solid #ccc;color:#000;height:2.5em;width:100%}form .actions{margin-left:1em}form button{display:block;margin:0 0 0 auto}:host-context(.mat-dark-theme) form input[type=text]{background:#000;border:1px solid #333;color:#fff}"]
            }]
    }], function () { return [{ type: BantaService }, { type: ChatBackendService }, { type: ɵngcc0.ElementRef }]; }, { signInLabel: [{
            type: Input
        }], sendLabel: [{
            type: Input
        }], permissionDeniedLabel: [{
            type: Input
        }], source: [{
            type: Input
        }], topicID: [{
            type: Input
        }], signInSelected: [{
            type: Output
        }], permissionDeniedError: [{
            type: Output
        }], selected: [{
            type: Output
        }], reported: [{
            type: Output
        }], upvoted: [{
            type: Output
        }], userSelected: [{
            type: Output
        }], chatView: [{
            type: ViewChild,
            args: ['chatView', { static: true }]
        }] }); })();

const COMPONENTS$2 = [
    ChatMessageComponent,
    LiveChatMessageComponent,
    ChatViewComponent,
    BantaChatComponent
];
class ChatModule {
}
ChatModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ChatModule });
ChatModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ChatModule_Factory(t) { return new (t || ChatModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatIconModule,
            MatButtonModule,
            EmojiModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChatModule, { declarations: function () { return [ChatMessageComponent, LiveChatMessageComponent, ChatViewComponent, BantaChatComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        MatIconModule,
        MatButtonModule, EmojiModule]; }, exports: function () { return [ChatMessageComponent, LiveChatMessageComponent, ChatViewComponent, BantaChatComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatModule, [{
        type: NgModule,
        args: [{
                declarations: COMPONENTS$2,
                imports: [
                    CommonModule,
                    FormsModule,
                    MatIconModule,
                    MatButtonModule,
                    EmojiModule
                ],
                exports: COMPONENTS$2
            }]
    }], null, null); })();

/**
 * Unified chat and comments component
 */
class BantaComponent {
    constructor(banta, backend, matDialog) {
        this.banta = banta;
        this.backend = backend;
        this.matDialog = matDialog;
        this._subs = new SubSink();
        this.auxOpen = false;
        this.auxTitle = 'Notifications';
        this.auxMode = 'notifications';
        this.mobileFocus = null;
        this.newNotifications = false;
        this.chatLabel = 'Chat';
        this.commentsLabel = 'Comments';
        this._signInSelected = new Subject();
        this.pointOpen = null;
        this.pointSubChat = null;
        this.newPointSubMessage = {};
        this.genericAvatarUrl = 'https://gravatar.com/avatar/915c804e0be607a4ad766ddadea5c48a?s=512&d=https://codepen.io/assets/avatars/user-avatar-512x512-6e240cf350d2f1cc07c2bed234c3a3bb5f1b237023c204c782622e80d6b212ba.png';
    }
    ngOnInit() {
        this._subs.add(this.banta.userChanged.subscribe(user => this.currentUser = user), this.backend.notificationsChanged.subscribe(notifs => this.notifications = notifs), this.backend.newNotification.subscribe(notif => {
            this.newNotifications = true;
        }));
    }
    sendPointSubMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            let text = (this.newPointSubMessage.message || '').trim();
            this.newPointSubMessage.message = '';
            if (text === '')
                return;
            let message = {
                user: null,
                sentAt: Date.now(),
                upvotes: 0,
                message: text
            };
            try {
                yield this.pointSubChat.send(message);
            }
            catch (e) {
                console.error(`Failed to send point sub-message:`);
                console.error(e);
            }
        });
    }
    goToMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            let targetMessage = message;
            if (message.parentMessageId) {
                // jump to the parent message thread...
                let parentMessage = yield this.backend.getMessage(message.topicId, message.parentMessageId);
                if (!parentMessage) {
                    console.error(`Failed to look up parent message ${message.topicId}/${message.parentMessageId}`);
                    console.error(`Original message was:`);
                    console.dir(targetMessage);
                    return;
                }
                message = parentMessage;
            }
            let viewType = this.getViewType(message);
            if (viewType === 'comment') {
                if (this.pointSubChat) {
                    if (this.pointSubChat.close)
                        this.pointSubChat.close();
                    this.pointSubChat = null;
                }
                this.mobileFocus = 'points';
                this.pointOpen = message;
                this.pointSubChat = yield this.backend.getSourceForThread(message.topicId, message.id);
                this.pointOpen = yield this.backend.refreshMessage(message);
                this.newPointSubMessage = {};
            }
            else if (viewType === 'chat') {
                this.mobileFocus = 'firehose';
                this.firehose.jumpToMessage(message);
            }
        });
    }
    pointUnfocus() {
        this.pointOpen = null;
        if (this.pointSubChat) {
            if (this.pointSubChat.close)
                this.pointSubChat.close();
            this.pointSubChat = null;
        }
    }
    ngOnDestroy() {
        this._subs.unsubscribe();
    }
    showAux(title, mode) {
        this.auxOpen = true;
        this.auxTitle = title;
        this.auxMode = mode;
        this.mobileFocus = 'aux';
    }
    showNotifications() {
        this.showAux('Notifications', 'notifications');
    }
    get topicID() {
        return this._topicID;
    }
    set topicID(value) {
        this._topicID = value;
        this.close();
        this.connectToTopic(this._topicID);
    }
    connectToTopic(id) {
        return __awaiter(this, void 0, void 0, function* () {
            this.firehoseSource = yield this.backend.getSourceForTopic(`${id}_firehose`);
            this.pointSource = yield this.backend.getSourceForTopic(`${id}_thepoint`);
        });
    }
    get signInSelected() {
        return this._signInSelected;
    }
    showSignIn() {
        this._signInSelected.next();
    }
    close() {
        if (this.firehoseSource) {
            if (this.firehoseSource.close)
                this.firehoseSource.close();
            this.firehoseSource = null;
        }
        if (this.pointSource) {
            if (this.pointSource.close)
                this.pointSource.close();
            this.pointSource = null;
        }
    }
    get hasPoint() {
        return this.pointOpen != null;
    }
    closeAux() {
        this.auxOpen = false;
        this.mobileFocus = 'firehose';
    }
    getViewType(message) {
        if (message.topicId.endsWith('_firehose'))
            return 'chat';
        else if (message.topicId.endsWith('_thepoint'))
            return 'comment';
        return 'comment';
    }
    upvoteMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (message.parentMessageId)
                yield this.backend.upvoteMessage(message.topicId, message.parentMessageId, message.id);
            else
                yield this.backend.upvoteMessage(message.topicId, message.id);
            //message.upvotes += 1;
        });
    }
    showProfile(user) {
        this.profileUser = user;
        this.showAux(`@${user.username}'s Profile`, 'profile');
    }
    sendReport(message) {
        this.auxOpen = false;
        alert('would send report');
    }
    reportMessage(message) {
        this.reportedMessage = message;
        this.showAux(`Report message from @${message.user.username}`, 'report');
    }
}
BantaComponent.ɵfac = function BantaComponent_Factory(t) { return new (t || BantaComponent)(ɵngcc0.ɵɵdirectiveInject(BantaService), ɵngcc0.ɵɵdirectiveInject(ChatBackendService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.MatDialog)); };
BantaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BantaComponent, selectors: [["banta"]], viewQuery: function BantaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c6, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.firehose = _t.first);
    } }, hostVars: 2, hostBindings: function BantaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("point-focus", ctx.hasPoint);
    } }, inputs: { chatLabel: "chatLabel", commentsLabel: "commentsLabel", topicID: "topicID" }, outputs: { signInSelected: "signInSelected" }, decls: 56, vars: 27, consts: [["userMenu", "matMenu"], [4, "ngIf"], ["mat-menu-item", ""], [1, "tabs"], ["mat-button", "", 3, "click"], [1, "spacer"], ["mat-button", "", 3, "click", 4, "ngIf"], [1, "firehose"], [3, "click"], [3, "source", "signInSelected", "upvoted", "userSelected", "reported"], ["firehose", ""], [1, "aux"], ["mat-icon-button", "", 3, "click"], [1, "aux-contents"], [1, "points"], [1, "point-focus"], [1, "actions"], ["class", "subcomments", 3, "newestLast", "allowReplies", "source", "upvoted", "reported", "userSelected", 4, "ngIf"], [1, "points-section"], [3, "source", "signInSelected", "upvoted", "reported", "selected", "userSelected"], ["mat-menu-item", "", 3, "disabled"], ["mat-menu-item", "", 3, "click"], ["mat-button", "", 3, "matMenuTriggerFor"], [2, "font-size", "125%"], [3, "message"], [2, "text-align", "center"], ["mat-raised-button", "", "color", "primary", 3, "click"], ["mat-raised-button", "", "color", "secondary", 3, "click"], [1, "notifications"], ["class", "notification", 4, "ngFor", "ngForOf"], [1, "notification"], [3, "value"], [3, "message", "upvoted", "reported", "selected"], ["mat-button", "", "target", "_blank", 3, "href"], [1, "counted-action"], [1, "count-indicator"], ["mat-icon-button", ""], [1, "subcomments", 3, "newestLast", "allowReplies", "source", "upvoted", "reported", "userSelected"], ["class", "focused-comment", "data-before", "", 3, "showReplyAction", "message", "upvoted", "userSelected", "reported", 4, "ngIf"], [1, "message", "reply"], [1, "new-message", 3, "submit"], ["name", "message", 3, "ngModel", "keydown", "ngModelChange"], ["mat-raised-button", "", "color", "primary", 3, "disabled"], ["data-before", "", 1, "focused-comment", 3, "showReplyAction", "message", "upvoted", "userSelected", "reported"]], template: function BantaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-menu", null, 0);
        ɵngcc0.ɵɵtemplate(2, BantaComponent_ng_container_2_Template, 5, 3, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, BantaComponent_ng_container_3_Template, 3, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵtext(5, "Help");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵelementStart(8, "a", 4);
        ɵngcc0.ɵɵlistener("click", function BantaComponent_Template_a_click_8_listener() { return ctx.mobileFocus = "chat"; });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "a", 4);
        ɵngcc0.ɵɵlistener("click", function BantaComponent_Template_a_click_10_listener() { return ctx.mobileFocus = "comments"; });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "div", 5);
        ɵngcc0.ɵɵelementStart(13, "div");
        ɵngcc0.ɵɵtemplate(14, BantaComponent_ng_container_14_Template, 6, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(15, BantaComponent_button_15_Template, 2, 0, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 7);
        ɵngcc0.ɵɵelementStart(17, "header");
        ɵngcc0.ɵɵelementStart(18, "div");
        ɵngcc0.ɵɵelementStart(19, "label", 8);
        ɵngcc0.ɵɵlistener("click", function BantaComponent_Template_label_click_19_listener() { return ctx.mobileFocus = "chat"; });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(21, "div", 5);
        ɵngcc0.ɵɵtemplate(22, BantaComponent_ng_container_22_Template, 6, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(23, BantaComponent_button_23_Template, 2, 0, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "banta-chat", 9, 10);
        ɵngcc0.ɵɵlistener("signInSelected", function BantaComponent_Template_banta_chat_signInSelected_24_listener() { return ctx.showSignIn(); })("upvoted", function BantaComponent_Template_banta_chat_upvoted_24_listener($event) { return ctx.upvoteMessage($event); })("userSelected", function BantaComponent_Template_banta_chat_userSelected_24_listener($event) { return ctx.showProfile($event.user); })("reported", function BantaComponent_Template_banta_chat_reported_24_listener($event) { return ctx.reportMessage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 11);
        ɵngcc0.ɵɵelementStart(27, "header");
        ɵngcc0.ɵɵelementStart(28, "div");
        ɵngcc0.ɵɵelementStart(29, "label");
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(31, "div", 5);
        ɵngcc0.ɵɵelementStart(32, "button", 12);
        ɵngcc0.ɵɵlistener("click", function BantaComponent_Template_button_click_32_listener() { return ctx.auxOpen = false; });
        ɵngcc0.ɵɵelementStart(33, "mat-icon");
        ɵngcc0.ɵɵtext(34, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 13);
        ɵngcc0.ɵɵtemplate(36, BantaComponent_ng_container_36_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(37, BantaComponent_ng_container_37_Template, 10, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(38, BantaComponent_ng_container_38_Template, 4, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "div", 14);
        ɵngcc0.ɵɵelementStart(40, "header");
        ɵngcc0.ɵɵelementStart(41, "div");
        ɵngcc0.ɵɵelementStart(42, "label");
        ɵngcc0.ɵɵtext(43);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "div", 15);
        ɵngcc0.ɵɵelementStart(45, "div", 16);
        ɵngcc0.ɵɵelementStart(46, "button", 4);
        ɵngcc0.ɵɵlistener("click", function BantaComponent_Template_button_click_46_listener() { return ctx.pointUnfocus(); });
        ɵngcc0.ɵɵelementStart(47, "mat-icon");
        ɵngcc0.ɵɵtext(48, "arrow_back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(49, " Back ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(50, "div", 5);
        ɵngcc0.ɵɵtemplate(51, BantaComponent_ng_container_51_Template, 7, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(52, BantaComponent_div_52_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵtemplate(53, BantaComponent_banta_comment_view_53_Template, 9, 6, "banta-comment-view", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "div", 18);
        ɵngcc0.ɵɵelementStart(55, "banta-comments", 19);
        ɵngcc0.ɵɵlistener("signInSelected", function BantaComponent_Template_banta_comments_signInSelected_55_listener() { return ctx.showSignIn(); })("upvoted", function BantaComponent_Template_banta_comments_upvoted_55_listener($event) { return ctx.upvoteMessage($event); })("reported", function BantaComponent_Template_banta_comments_reported_55_listener($event) { return ctx.reportMessage($event); })("selected", function BantaComponent_Template_banta_comments_selected_55_listener($event) { return ctx.goToMessage($event); })("userSelected", function BantaComponent_Template_banta_comments_userSelected_55_listener($event) { return ctx.showProfile($event.user); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.currentUser);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.chatLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.commentsLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.currentUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("focus", ctx.mobileFocus === "chat");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.chatLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.currentUser);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("source", ctx.firehoseSource);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("focus", ctx.mobileFocus === "aux")("open", ctx.auxOpen);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.auxTitle);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.auxMode === "profile");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.auxMode === "report");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.auxMode === "notifications");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("focus", ctx.mobileFocus === "points");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.commentsLabel);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pointOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.pointSubChat);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pointSubChat);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("source", ctx.pointSource);
    } }, directives: function () { return [ɵngcc9._MatMenu, ɵngcc1.NgIf, ɵngcc9.MatMenuItem, ɵngcc3.MatAnchor, BantaChatComponent, ɵngcc3.MatButton, ɵngcc4.MatIcon, BantaCommentsComponent, ɵngcc9.MatMenuTrigger, LiveMessageComponent, ɵngcc1.NgForOf, TimestampComponent, CommentViewComponent, ɵngcc7.ɵangular_packages_forms_forms_y, ɵngcc7.NgControlStatusGroup, ɵngcc7.NgForm, ɵngcc7.DefaultValueAccessor, ɵngcc7.NgControlStatus, ɵngcc7.NgModel, CommentComponent]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;height:40em;padding:.5em;position:relative}.counted-action[_ngcontent-%COMP%]{align-items:center;display:flex}.count-indicator[_ngcontent-%COMP%]{border:1px solid #333;border-radius:3px;font-size:9pt;padding:0 3px}header[_ngcontent-%COMP%]{margin-bottom:1em;position:relative}header[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{align-items:center;display:flex;height:30px}header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#666}header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#333;font-size:12pt;font-weight:100;letter-spacing:2px;margin:0 auto 0 0;overflow-x:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:1}header[_ngcontent-%COMP%]:after, header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:block;position:relative}header[_ngcontent-%COMP%]:after{border:1px solid #ccc;content:\"\";height:0;width:100%;z-index:0}.points[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-width:50em}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]{max-width:50em;width:66%}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]   .points-section[_ngcontent-%COMP%]{opacity:0;pointer-events:none}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%]{opacity:1;pointer-events:auto}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex}banta-comments[_ngcontent-%COMP%]{flex-grow:1}.points[_ngcontent-%COMP%]{flex-shrink:0;font-size:12pt;margin-left:.5em;max-width:30em;position:relative;transition:width .2s ease-in,max-width .2s ease-in;width:33%}.points[_ngcontent-%COMP%]   .points-section[_ngcontent-%COMP%]{opacity:1;z-index:2}.points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%], .points[_ngcontent-%COMP%]   .points-section[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-grow:1;transition:opacity .2s ease-in}.points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%]{bottom:0;left:0;opacity:0;padding:.5em;position:absolute;right:0;top:1.75em;width:100%}.firehose[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-grow:1;font-size:10pt}form[_ngcontent-%COMP%]{align-items:center;display:flex;padding:.5em 0}form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-size:14pt;min-height:6em}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#000;border:1px solid #333;color:#fff;width:100%}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{height:1em}form[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{margin-left:1em}form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;margin:0 0 0 auto}.subcomments[_ngcontent-%COMP%]     banta-comment{font-size:10pt}.subcomments[_ngcontent-%COMP%]     banta-comment.focused-comment{background:#001321;color:#fff;font-size:12pt}.aux[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-width:0;overflow-x:hidden;transition:width .4s ease-out,min-width .4s ease-out;width:0}.aux.open[_ngcontent-%COMP%]{min-width:18em;width:30em}.aux[_ngcontent-%COMP%]   .aux-contents[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:center;max-width:100%;min-width:10em;width:30em}.notifications[_ngcontent-%COMP%]   .notification[_ngcontent-%COMP%]{border-bottom:1px solid #333;padding:1em}.notifications[_ngcontent-%COMP%]   .notification[_ngcontent-%COMP%]   banta-timestamp[_ngcontent-%COMP%]{color:#999;display:block;font-size:9pt;text-align:right}.message.reply[_ngcontent-%COMP%]{padding:1em}.tabs[_ngcontent-%COMP%]{display:none}@media (max-width:1015px){[_nghost-%COMP%]{flex-direction:column}.tabs[_ngcontent-%COMP%]{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:rgba(0,0,0,.5);display:flex;left:0;position:absolute;right:0;top:0;width:100%;z-index:10}.points[_ngcontent-%COMP%]{margin-left:0;max-width:100%;width:100%}header[_ngcontent-%COMP%]{display:none}.aux[_ngcontent-%COMP%], .point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]{max-width:100%;width:100%}.aux[_ngcontent-%COMP%]{min-width:0}.aux[_ngcontent-%COMP%], .firehose[_ngcontent-%COMP%], .points[_ngcontent-%COMP%]{background:#000;bottom:0;left:0;position:absolute;right:0;top:2em;z-index:0}.aux.focus[_ngcontent-%COMP%], .firehose.focus[_ngcontent-%COMP%], .points.focus[_ngcontent-%COMP%]{z-index:2}}.mat-dark-theme[_nghost-%COMP%]   [_nghost-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   [_nghost-%COMP%]{background:#090909;color:#fff}.mat-dark-theme[_nghost-%COMP%]   form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ccc;color:#333}.mat-dark-theme[_nghost-%COMP%]   header[_ngcontent-%COMP%]:after, .mat-dark-theme   [_nghost-%COMP%]   header[_ngcontent-%COMP%]:after{border-color:#222}.mat-dark-theme[_nghost-%COMP%]   header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#aaa}"] });
BantaComponent.ctorParameters = () => [
    { type: BantaService },
    { type: ChatBackendService },
    { type: MatDialog }
];
BantaComponent.propDecorators = {
    firehose: [{ type: ViewChild, args: ['firehose', { static: true },] }],
    topicID: [{ type: Input }],
    chatLabel: [{ type: Input }],
    commentsLabel: [{ type: Input }],
    signInSelected: [{ type: Output }],
    hasPoint: [{ type: HostBinding, args: ['class.point-focus',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaComponent, [{
        type: Component,
        args: [{
                selector: `banta`,
                template: "\r\n<mat-menu #userMenu=\"matMenu\">\r\n    <ng-container *ngIf=\"currentUser\">\r\n        <button [disabled]=\"true\" mat-menu-item>{{currentUser.displayName}} (@{{currentUser.username}})</button>\r\n        <button mat-menu-item (click)=\"signOut()\">Sign Out</button>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!currentUser\">\r\n        <button mat-menu-item>Sign In</button>\r\n    </ng-container>\r\n    <button mat-menu-item>Help</button>\r\n</mat-menu>\r\n\r\n<div class=\"tabs\">\r\n    <div>\r\n        <a mat-button (click)=\"mobileFocus = 'chat'\">{{chatLabel}}</a>\r\n        <a mat-button (click)=\"mobileFocus = 'comments'\">{{commentsLabel}}</a>\r\n    </div>\r\n    <div class=\"spacer\"></div>\r\n    <div>\r\n        <ng-container *ngIf=\"currentUser\">\r\n            <button mat-button [matMenuTriggerFor]=\"userMenu\">\r\n                @{{currentUser.username}}\r\n            </button>\r\n            <button mat-icon-button (click)=\"showNotifications()\">\r\n                <mat-icon>notification_important</mat-icon>\r\n            </button>\r\n        </ng-container>\r\n        \r\n        <button mat-button *ngIf=\"!currentUser\" (click)=\"showSignIn()\">\r\n            Sign In\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"firehose\" [class.focus]=\"mobileFocus === 'chat'\">\r\n    <header>\r\n        <div>\r\n            <label (click)=\"mobileFocus = 'chat'\">{{chatLabel}}</label>\r\n            <div class=\"spacer\"></div>\r\n\r\n            <ng-container *ngIf=\"currentUser\">\r\n                <button mat-button [matMenuTriggerFor]=\"userMenu\">\r\n                    @{{currentUser.username}}\r\n                </button>\r\n                <button mat-icon-button (click)=\"showNotifications()\">\r\n                    <mat-icon>notification_important</mat-icon>\r\n                </button>\r\n            </ng-container>\r\n            \r\n            <button mat-button *ngIf=\"!currentUser\" (click)=\"showSignIn()\">\r\n                Sign In\r\n            </button>\r\n        </div>\r\n    </header>\r\n    <banta-chat \r\n        #firehose\r\n        [source]=\"firehoseSource\"\r\n        (signInSelected)=\"showSignIn()\"\r\n        (upvoted)=\"upvoteMessage($event)\"\r\n        (userSelected)=\"showProfile($event.user)\"\r\n        (reported)=\"reportMessage($event)\"\r\n        ></banta-chat>\r\n</div>\r\n\r\n<div class=\"aux\" [class.focus]=\"mobileFocus === 'aux'\" [class.open]=\"auxOpen\">\r\n    <header>\r\n        <div>\r\n            <label>{{auxTitle}}</label>\r\n            <div class=\"spacer\"></div>\r\n            <button mat-icon-button (click)=\"auxOpen = false\">\r\n                <mat-icon>close</mat-icon>\r\n            </button>\r\n        </div>\r\n    </header>\r\n    <div class=\"aux-contents\">\r\n        <ng-container *ngIf=\"auxMode === 'profile'\">\r\n            <ng-container *ngIf=\"profileUser\">\r\n\r\n                <div>\r\n                    <strong style=\"font-size: 125%;\">\r\n                        {{profileUser.displayName}}\r\n                    </strong>\r\n                    @{{profileUser.username}}\r\n                </div>\r\n\r\n                <br/>\r\n                <strong>Top Messages</strong>\r\n\r\n                <div>\r\n                    <em>Not yet available</em>\r\n                </div>\r\n\r\n                <br/>\r\n                <strong>Recent Messages</strong>\r\n\r\n                <div>\r\n                    <em>Not yet available</em>\r\n                </div>\r\n            </ng-container>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"auxMode === 'report'\">\r\n            <p>Are you sure you want to report this message?</p>\r\n\r\n            <banta-live-message [message]=\"reportedMessage\"></banta-live-message>\r\n\r\n            <div style=\"text-align: center;\">\r\n                <button mat-raised-button color=\"primary\" (click)=\"sendReport(reportedMessage)\">Yes, Report</button>\r\n                &nbsp;\r\n                <button mat-raised-button color=\"secondary\" (click)=\"auxOpen = false\">No, Cancel</button>\r\n            </div>\r\n\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"auxMode === 'notifications'\">\r\n\r\n            <div *ngIf=\"!notifications || notifications.length === 0\">\r\n                <em>You do not have any notifications yet</em>\r\n            </div>\r\n            \r\n            <div class=\"notifications\">\r\n                <div class=\"notification\" *ngFor=\"let notif of notifications\">\r\n                    <div>\r\n                        <ng-container *ngIf=\"notif.type === 'upvote'\">\r\n                            @{{notif.message?.user?.username}} upvoted your post\r\n                            \r\n                            <banta-live-message\r\n                                [message]=\"notif.message\"\r\n                                (upvoted)=\"upvoteMessage(notif.message)\"\r\n                                (reported)=\"reportMessage(notif.message)\"\r\n                                (selected)=\"goToMessage(notif.message)\">\r\n                            </banta-live-message>\r\n\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"notif.type === 'notice'\">\r\n                            <div>\r\n                                {{notif.message}}\r\n                            </div>\r\n                            <a mat-button target=\"_blank\" href=\"{{notif.actionUrl}}\">\r\n                                {{notif.actionLabel}}\r\n                            </a>\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"notif.type === 'mention'\">\r\n                            You were mentioned by @{{notif.message?.user?.username}}\r\n\r\n                            <banta-live-message\r\n                                [message]=\"notif.message\"\r\n                                (upvoted)=\"upvoteMessage(notif.message)\"\r\n                                (reported)=\"reportMessage(notif.message)\"\r\n                                (selected)=\"goToMessage(notif.message)\">\r\n                            </banta-live-message>\r\n\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"notif.type === 'reply'\">\r\n                            @{{notif.replyMessage?.user?.username}} replied to your post\r\n                            \r\n                            <banta-live-message\r\n                                [message]=\"notif.replyMessage\"\r\n                                (upvoted)=\"upvoteMessage(notif.replyMessage)\"\r\n                                (reported)=\"reportMessage(notif.replyMessage)\"\r\n                                (selected)=\"goToMessage(notif.replyMessage)\">\r\n                            </banta-live-message>\r\n                        </ng-container>\r\n                    </div>\r\n\r\n                    <banta-timestamp [value]=\"notif.sentAt\"></banta-timestamp>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n</div>\r\n<div class=\"points\" [class.focus]=\"mobileFocus === 'points'\">\r\n    <header>\r\n        <div>\r\n            <label>{{commentsLabel}}</label>\r\n        </div>\r\n    </header>\r\n    <div class=\"point-focus\">\r\n        <div class=\"actions\">\r\n            <button mat-button (click)=\"pointUnfocus()\">\r\n                <mat-icon>arrow_back</mat-icon>\r\n                Back\r\n            </button>\r\n\r\n            <div class=\"spacer\"></div>\r\n            \r\n            <ng-container *ngIf=\"pointOpen\">\r\n                <div class=\"counted-action\">\r\n                    <div class=\"count-indicator\">  \r\n                        {{pointOpen.upvotes}}\r\n                    </div>\r\n                    <button mat-icon-button>\r\n                        <mat-icon>thumb_up</mat-icon>\r\n                    </button>\r\n                </div>\r\n\r\n            </ng-container>\r\n        </div>\r\n\r\n        <div *ngIf=\"!pointSubChat\">\r\n            Error: No subchat\r\n        </div>\r\n        \r\n        <banta-comment-view\r\n            class=\"subcomments\"\r\n            *ngIf=\"pointSubChat\"\r\n            [newestLast]=\"true\"\r\n            [allowReplies]=\"false\"\r\n            [source]=\"pointSubChat\"\r\n            (upvoted)=\"upvoteMessage($event)\"\r\n            (reported)=\"reportMessage($event)\"\r\n            (userSelected)=\"showProfile($event.user)\"\r\n            >\r\n            \r\n            <banta-comment\r\n                class=\"focused-comment\"\r\n                data-before\r\n                *ngIf=\"pointOpen\"\r\n                (upvoted)=\"upvoteMessage(pointOpen)\"\r\n                (userSelected)=\"showProfile(pointOpen.user)\"\r\n                (reported)=\"reportMessage(pointOpen)\"\r\n                [showReplyAction]=\"false\"\r\n                [message]=\"pointOpen\"\r\n                ></banta-comment>\r\n        \r\n            <div class=\"message reply\">\r\n                Reply:\r\n                <form class=\"new-message\" (submit)=\"sendPointSubMessage()\">\r\n                    <textarea \r\n                        name=\"message\" \r\n                        (keydown)=\"newPointSubMessageKeyDown($event)\"\r\n                        [(ngModel)]=\"newPointSubMessage.message\"></textarea>\r\n                \r\n                    <div class=\"actions\">\r\n                        <button [disabled]=\"!newPointSubMessage.message\" \r\n                            mat-raised-button color=\"primary\">Send</button>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </banta-comment-view>\r\n    </div>\r\n    <div class=\"points-section\">\r\n        <banta-comments\r\n            [source]=\"pointSource\"\r\n            (signInSelected)=\"showSignIn()\"\r\n            (upvoted)=\"upvoteMessage($event)\"\r\n            (reported)=\"reportMessage($event)\"\r\n            (selected)=\"goToMessage($event)\"\r\n            (userSelected)=\"showProfile($event.user)\"\r\n            ></banta-comments>\r\n    </div>\r\n</div>",
                styles: [":host{display:flex;flex-direction:row;height:40em;padding:.5em;position:relative}.counted-action{align-items:center;display:flex}.count-indicator{border:1px solid #333;border-radius:3px;font-size:9pt;padding:0 3px}header{margin-bottom:1em;position:relative}header div{align-items:center;display:flex;height:30px}header button{color:#666}header label{color:#333;font-size:12pt;font-weight:100;letter-spacing:2px;margin:0 auto 0 0;overflow-x:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:1}header:after,header label{display:block;position:relative}header:after{border:1px solid #ccc;content:\"\";height:0;width:100%;z-index:0}.points{display:flex;flex-direction:column;max-width:50em}:host.point-focus .points{max-width:50em;width:66%}:host.point-focus .points .points-section{opacity:0;pointer-events:none}:host.point-focus .points .point-focus{opacity:1;pointer-events:auto}:host.point-focus .points .point-focus .actions{display:flex}banta-comments{flex-grow:1}.points{flex-shrink:0;font-size:12pt;margin-left:.5em;max-width:30em;position:relative;transition:width .2s ease-in,max-width .2s ease-in;width:33%}.points .points-section{opacity:1;z-index:2}.points .point-focus,.points .points-section{display:flex;flex-direction:column;flex-grow:1;transition:opacity .2s ease-in}.points .point-focus{bottom:0;left:0;opacity:0;padding:.5em;position:absolute;right:0;top:1.75em;width:100%}.firehose{display:flex;flex-direction:column;flex-grow:1;font-size:10pt}form{align-items:center;display:flex;padding:.5em 0}form textarea{font-size:14pt;min-height:6em}form input[type=text],form textarea{background:#000;border:1px solid #333;color:#fff;width:100%}form input[type=text]{height:1em}form .actions{margin-left:1em}form button{display:block;margin:0 0 0 auto}.subcomments ::ng-deep banta-comment{font-size:10pt}.subcomments ::ng-deep banta-comment.focused-comment{background:#001321;color:#fff;font-size:12pt}.aux{display:flex;flex-direction:column;min-width:0;overflow-x:hidden;transition:width .4s ease-out,min-width .4s ease-out;width:0}.aux.open{min-width:18em;width:30em}.aux .aux-contents{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:center;max-width:100%;min-width:10em;width:30em}.notifications .notification{border-bottom:1px solid #333;padding:1em}.notifications .notification banta-timestamp{color:#999;display:block;font-size:9pt;text-align:right}.message.reply{padding:1em}.tabs{display:none}@media (max-width:1015px){:host{flex-direction:column}.tabs{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:rgba(0,0,0,.5);display:flex;left:0;position:absolute;right:0;top:0;width:100%;z-index:10}.points{margin-left:0;max-width:100%;width:100%}header{display:none}.aux,:host.point-focus .points{max-width:100%;width:100%}.aux{min-width:0}.aux,.firehose,.points{background:#000;bottom:0;left:0;position:absolute;right:0;top:2em;z-index:0}.aux.focus,.firehose.focus,.points.focus{z-index:2}}:host-context(.mat-dark-theme) :host{background:#090909;color:#fff}:host-context(.mat-dark-theme) form textarea{background:#ccc;color:#333}:host-context(.mat-dark-theme) header:after{border-color:#222}:host-context(.mat-dark-theme) header label{color:#aaa}"]
            }]
    }], function () { return [{ type: BantaService }, { type: ChatBackendService }, { type: ɵngcc8.MatDialog }]; }, { chatLabel: [{
            type: Input
        }], commentsLabel: [{
            type: Input
        }], topicID: [{
            type: Input
        }], signInSelected: [{
            type: Output
        }], hasPoint: [{
            type: HostBinding,
            args: ['class.point-focus']
        }], firehose: [{
            type: ViewChild,
            args: ['firehose', { static: true }]
        }] }); })();

class BantaLogoComponent {
}
BantaLogoComponent.ɵfac = function BantaLogoComponent_Factory(t) { return new (t || BantaLogoComponent)(); };
BantaLogoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BantaLogoComponent, selectors: [["banta-logo"]], decls: 1, vars: 0, template: function BantaLogoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "banta");
    } }, styles: ["[_nghost-%COMP%] {\n            font-family: 'Odibee Sans', sans-serif;\n            font-size: 40pt;\n        }\n\n        .small[_nghost-%COMP%] {\n            font-size: 30pt;\n        }"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaLogoComponent, [{
        type: Component,
        args: [{
                selector: 'banta-logo',
                template: `banta`,
                styles: [`
        :host {
            font-family: 'Odibee Sans', sans-serif;
            font-size: 40pt;
        }

        :host.small {
            font-size: 30pt;
        }
        `]
            }]
    }], null, null); })();

class LiveMessageComponent {
    constructor() {
        this._upvoted = new Subject();
        this._reported = new Subject();
        this._selected = new Subject();
    }
    get upvoted() {
        return this._upvoted;
    }
    get reported() {
        return this._reported;
    }
    get selected() {
        return this._selected;
    }
    get message() {
        return this._message;
    }
    set message(value) {
        this._message = value;
        this.viewType = this.getViewType(value);
    }
    getViewType(message) {
        if (message.topicId.endsWith('_firehose'))
            return 'chat';
        else if (message.topicId.endsWith('_thepoint'))
            return 'comment';
        return 'comment';
    }
    upvote() {
        this._upvoted.next();
    }
    report() {
        this._reported.next();
    }
    select() {
        this._selected.next();
    }
}
LiveMessageComponent.ɵfac = function LiveMessageComponent_Factory(t) { return new (t || LiveMessageComponent)(); };
LiveMessageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LiveMessageComponent, selectors: [["banta-live-message"]], inputs: { message: "message" }, outputs: { upvoted: "upvoted", reported: "reported", selected: "selected" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "message", "upvoted", "reported", "selected", 4, "ngIf"], [3, "message", "upvoted", "reported", "selected"]], template: function LiveMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LiveMessageComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
    } }, directives: function () { return [ɵngcc1.NgIf, LiveChatMessageComponent, LiveCommentComponent]; }, styles: [""] });
LiveMessageComponent.ctorParameters = () => [];
LiveMessageComponent.propDecorators = {
    upvoted: [{ type: Output }],
    reported: [{ type: Output }],
    selected: [{ type: Output }],
    message: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveMessageComponent, [{
        type: Component,
        args: [{
                selector: 'banta-live-message',
                template: `
        <ng-container *ngIf="message">
            <banta-live-chat-message
                *ngIf="viewType === 'chat'"
                [message]="message"
                (upvoted)="upvote(message)"
                (reported)="report(message)"
                (selected)="select(message)">
            </banta-live-chat-message>

            <banta-live-comment 
                *ngIf="viewType === 'comment'"
                [message]="message"
                (upvoted)="upvote(message)"
                (reported)="report(message)"
                (selected)="select(message)">
            </banta-live-comment>
        </ng-container>
    `,
                styles: [``]
            }]
    }], function () { return []; }, { upvoted: [{
            type: Output
        }], reported: [{
            type: Output
        }], selected: [{
            type: Output
        }], message: [{
            type: Input
        }] }); })();

class CommentComponent {
    constructor() {
        this._reported = new Subject();
        this._selected = new Subject();
        this._upvoted = new Subject();
        this._userSelected = new Subject();
        this.isNew = false;
        this.visible = false;
        this.showReplyAction = true;
    }
    ngOnInit() {
        let maxTime = 500;
        let minTime = 0;
        let randomTime = minTime + Math.random() * (maxTime - minTime);
        setTimeout(() => {
            this.isNew = true;
            this.visible = true;
            setTimeout(() => this.isNew = false, 1000);
        }, randomTime);
    }
    get userSelected() {
        return this._userSelected;
    }
    get reported() {
        return this._reported;
    }
    get upvoted() {
        return this._upvoted;
    }
    get selected() {
        return this._selected;
    }
    get commentId() {
        var _a;
        return (_a = this.message) === null || _a === void 0 ? void 0 : _a.id;
    }
    report() {
        this._reported.next();
    }
    upvote() {
        this._upvoted.next();
    }
    select() {
        this._selected.next();
    }
    selectUser() {
        return this._userSelected.next();
    }
    avatarForUser(user) {
        if (user && user.avatarUrl) {
            let url = user.avatarUrl;
            return `url(${url})`;
        }
        return null;
    }
}
CommentComponent.ɵfac = function CommentComponent_Factory(t) { return new (t || CommentComponent)(); };
CommentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommentComponent, selectors: [["banta-comment"]], hostVars: 5, hostBindings: function CommentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-comment-id", ctx.commentId);
        ɵngcc0.ɵɵclassProp("new", ctx.isNew)("visible", ctx.visible);
    } }, inputs: { showReplyAction: "showReplyAction", message: "message" }, outputs: { userSelected: "userSelected", reported: "reported", upvoted: "upvoted", selected: "selected" }, decls: 28, vars: 11, consts: [["pointItemMenu", "matMenu"], ["mat-menu-item", "", 3, "click"], ["mat-menu-item", ""], [1, "message-content"], [1, "user"], ["href", "javascript:;", 1, "avatar", 3, "click"], ["href", "javascript:;", 1, "display-name", 3, "click"], ["href", "javascript:;", 1, "username", 3, "click"], [1, "content"], [1, "actions"], [3, "value"], [1, "spacer"], ["class", "counted-action", 4, "ngIf"], [1, "counted-action"], [1, "count-indicator"], ["mat-icon-button", "", "matTooltip", "Upvote", "matTooltipPosition", "below", 3, "click"], [3, "inline"], ["mat-icon-button", "", 3, "matMenuTriggerFor"], ["mat-icon-button", "", "matTooltip", "Comment", "matTooltipPosition", "below", 3, "click"]], template: function CommentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-menu", null, 0);
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵlistener("click", function CommentComponent_Template_button_click_2_listener() { return ctx.report(); });
        ɵngcc0.ɵɵtext(3, "Report");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵtext(5, "Help");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "a", 5);
        ɵngcc0.ɵɵlistener("click", function CommentComponent_Template_a_click_8_listener() { return ctx.selectUser(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "a", 6);
        ɵngcc0.ɵɵlistener("click", function CommentComponent_Template_a_click_9_listener() { return ctx.selectUser(); });
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "a", 7);
        ɵngcc0.ɵɵlistener("click", function CommentComponent_Template_a_click_11_listener() { return ctx.selectUser(); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 9);
        ɵngcc0.ɵɵelement(16, "banta-timestamp", 10);
        ɵngcc0.ɵɵelement(17, "div", 11);
        ɵngcc0.ɵɵtemplate(18, CommentComponent_div_18_Template, 6, 2, "div", 12);
        ɵngcc0.ɵɵelementStart(19, "div", 13);
        ɵngcc0.ɵɵelementStart(20, "div", 14);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "button", 15);
        ɵngcc0.ɵɵlistener("click", function CommentComponent_Template_button_click_22_listener() { return ctx.upvote(); });
        ɵngcc0.ɵɵelementStart(23, "mat-icon", 16);
        ɵngcc0.ɵɵtext(24, "thumb_up");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "button", 17);
        ɵngcc0.ɵɵelementStart(26, "mat-icon", 16);
        ɵngcc0.ɵɵtext(27, "more_vert");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵstyleProp("background-image", ctx.avatarForUser(ctx.message.user));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message.user.displayName);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("@", ctx.message.user.username, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.message.message, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("value", ctx.message.sentAt);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showReplyAction);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.message.upvotes, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("inline", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("inline", true);
    } }, directives: [ɵngcc9._MatMenu, ɵngcc9.MatMenuItem, TimestampComponent, ɵngcc1.NgIf, ɵngcc3.MatButton, ɵngcc4.MatIcon, ɵngcc9.MatMenuTrigger], styles: ["@-webkit-keyframes comment-appear{0%{transform:translate(100vw)}to{transform:translate(0)}}@keyframes comment-appear{0%{transform:translate(100vw)}to{transform:translate(0)}}[_nghost-%COMP%]{display:flex;flex-direction:column;padding:.5em;position:relative;visibility:hidden}.new[_nghost-%COMP%]{-webkit-animation-duration:.4s;-webkit-animation-fill-mode:both;-webkit-animation-name:comment-appear;animation-duration:.4s;animation-fill-mode:both;animation-name:comment-appear}.new[_nghost-%COMP%], .visible[_nghost-%COMP%]{visibility:visible}[_nghost-%COMP%]:hover{background:#eee}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{margin-left:60px;margin-right:.5em}.abbreviated[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{max-height:8.5em;overflow-y:hidden;text-overflow:ellipsis}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]{align-items:center;display:flex;margin-left:60px;padding-right:10px}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#666}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]   banta-timestamp[_ngcontent-%COMP%]{color:#666;font-size:10pt}.user[_ngcontent-%COMP%]{align-items:center;display:flex;margin:1em 0 0;position:relative}.user[_ngcontent-%COMP%]   .display-name[_ngcontent-%COMP%], .user[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{color:#000;display:block;flex-grow:0;flex-shrink:1;font-size:10pt;margin:0 auto 0 0;max-width:100%;overflow:hidden;padding:0 0 0 1em;position:relative;text-overflow:ellipsis;white-space:nowrap;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:1}.user[_ngcontent-%COMP%]   .display-name.username[_ngcontent-%COMP%], .user[_ngcontent-%COMP%]   .username.username[_ngcontent-%COMP%]{color:#666;flex-grow:1;flex-shrink:0}.avatar[_ngcontent-%COMP%]{background-color:#333;background-position:50%;background-size:cover;border-radius:100%;flex-grow:0;flex-shrink:0;height:48px;width:48px}.counted-action[_ngcontent-%COMP%]{align-items:center;display:flex}.count-indicator[_ngcontent-%COMP%]{color:#666;font-size:9pt;padding:0 0 0 3px}.mat-dark-theme[_nghost-%COMP%]   .count-indicator[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .count-indicator[_ngcontent-%COMP%]{border-color:#333}.mat-dark-theme[_nghost-%COMP%]:hover, .mat-dark-theme   [_nghost-%COMP%]:hover{background:#060606}.mat-dark-theme[_nghost-%COMP%]   .user[_ngcontent-%COMP%]   .display-name[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .user[_ngcontent-%COMP%]   .display-name[_ngcontent-%COMP%], .mat-dark-theme[_nghost-%COMP%]   .user[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .user[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{color:#fff}@media (max-width:400px){.avatar[_ngcontent-%COMP%]{height:32px;width:32px}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]{margin-left:44px}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{margin-left:44px;margin-right:.5em}}"] });
CommentComponent.propDecorators = {
    isNew: [{ type: HostBinding, args: ['class.new',] }],
    visible: [{ type: HostBinding, args: ['class.visible',] }],
    message: [{ type: Input }],
    showReplyAction: [{ type: Input }],
    userSelected: [{ type: Output }],
    reported: [{ type: Output }],
    upvoted: [{ type: Output }],
    selected: [{ type: Output }],
    commentId: [{ type: HostBinding, args: ['attr.data-comment-id',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommentComponent, [{
        type: Component,
        args: [{
                selector: 'banta-comment',
                template: "\r\n<mat-menu #pointItemMenu=\"matMenu\">\r\n    <button mat-menu-item (click)=\"report()\">Report</button>\r\n    <button mat-menu-item>Help</button>\r\n</mat-menu>\r\n\r\n<div class=\"message-content\">\r\n    <div class=\"user\">\r\n        <a \r\n            href=\"javascript:;\"\r\n            class=\"avatar\"\r\n            (click)=\"selectUser()\"\r\n            [style.background-image]=\"avatarForUser(message.user)\"></a>\r\n        <a href=\"javascript:;\" class=\"display-name\" (click)=\"selectUser()\">{{message.user.displayName}}</a>\r\n        <a href=\"javascript:;\" class=\"username\" (click)=\"selectUser()\">@{{message.user.username}}</a>\r\n    </div>\r\n    <div class=\"content\">\r\n        {{message.message}}\r\n    </div>\r\n    \r\n    <div class=\"actions\">\r\n        <banta-timestamp [value]=\"message.sentAt\"></banta-timestamp>\r\n        <div class=\"spacer\"></div>\r\n        <div class=\"counted-action\" *ngIf=\"showReplyAction\">\r\n            <div class=\"count-indicator\">\r\n                {{message.submessages?.length || 0}}\r\n            </div>\r\n            <button mat-icon-button matTooltip=\"Comment\" matTooltipPosition=\"below\" (click)=\"select()\">\r\n                <mat-icon [inline]=\"true\">comment</mat-icon>\r\n            </button>\r\n        </div>\r\n        <div class=\"counted-action\">\r\n            <div class=\"count-indicator\">  \r\n                {{message.upvotes}}\r\n            </div>\r\n            <button mat-icon-button matTooltip=\"Upvote\" matTooltipPosition=\"below\" (click)=\"upvote()\">\r\n                <mat-icon [inline]=\"true\">thumb_up</mat-icon>\r\n            </button>\r\n        </div>\r\n        \r\n        <button mat-icon-button [matMenuTriggerFor]=\"pointItemMenu\">\r\n            <mat-icon [inline]=\"true\">more_vert</mat-icon>\r\n        </button>\r\n    </div>\r\n</div>\r\n",
                styles: ["@-webkit-keyframes comment-appear{0%{transform:translate(100vw)}to{transform:translate(0)}}@keyframes comment-appear{0%{transform:translate(100vw)}to{transform:translate(0)}}:host{display:flex;flex-direction:column;padding:.5em;position:relative;visibility:hidden}:host.new{-webkit-animation-duration:.4s;-webkit-animation-fill-mode:both;-webkit-animation-name:comment-appear;animation-duration:.4s;animation-fill-mode:both;animation-name:comment-appear}:host.new,:host.visible{visibility:visible}:host:hover{background:#eee}:host .message-content .content{margin-left:60px;margin-right:.5em}:host.abbreviated .message-content .content{max-height:8.5em;overflow-y:hidden;text-overflow:ellipsis}:host .actions{align-items:center;display:flex;margin-left:60px;padding-right:10px}:host .actions button{color:#666}:host .actions banta-timestamp{color:#666;font-size:10pt}.user{align-items:center;display:flex;margin:1em 0 0;position:relative}.user .display-name,.user .username{color:#000;display:block;flex-grow:0;flex-shrink:1;font-size:10pt;margin:0 auto 0 0;max-width:100%;overflow:hidden;padding:0 0 0 1em;position:relative;text-overflow:ellipsis;white-space:nowrap;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:1}.user .display-name.username,.user .username.username{color:#666;flex-grow:1;flex-shrink:0}.avatar{background-color:#333;background-position:50%;background-size:cover;border-radius:100%;flex-grow:0;flex-shrink:0;height:48px;width:48px}.counted-action{align-items:center;display:flex}.count-indicator{color:#666;font-size:9pt;padding:0 0 0 3px}:host-context(.mat-dark-theme) .count-indicator{border-color:#333}:host-context(.mat-dark-theme):hover{background:#060606}:host-context(.mat-dark-theme) .user .display-name,:host-context(.mat-dark-theme) .user .username{color:#fff}@media (max-width:400px){.avatar{height:32px;width:32px}:host .actions{margin-left:44px}:host .message-content .content{margin-left:44px;margin-right:.5em}}"]
            }]
    }], function () { return []; }, { isNew: [{
            type: HostBinding,
            args: ['class.new']
        }], visible: [{
            type: HostBinding,
            args: ['class.visible']
        }], showReplyAction: [{
            type: Input
        }], userSelected: [{
            type: Output
        }], reported: [{
            type: Output
        }], upvoted: [{
            type: Output
        }], selected: [{
            type: Output
        }], commentId: [{
            type: HostBinding,
            args: ['attr.data-comment-id']
        }], message: [{
            type: Input
        }] }); })();

class CommentViewComponent {
    constructor(backend) {
        this.backend = backend;
        this._sourceSubs = new SubSink();
        this._selected = new Subject();
        this._upvoted = new Subject();
        this._reported = new Subject();
        this._userSelected = new Subject();
        this.showEmptyState = true;
        this.allowReplies = true;
        this.menuMessage = null;
        this.messages = [];
        this.maxMessages = 2000;
        this.maxVisibleMessages = 200;
        this.newestLast = false;
        this.isViewingMore = false;
        this.isLoadingMore = false;
        this.hasMore = false;
        this.newMessages = [];
        this.olderMessages = [];
    }
    get selected() {
        return this._selected;
    }
    get userSelected() {
        return this._userSelected;
    }
    get reported() {
        return this._reported;
    }
    get upvoted() {
        return this._upvoted;
    }
    get source() {
        return this._source;
    }
    upvoteMessage(message) {
        this._upvoted.next(message);
    }
    reportMessage(message) {
        this._reported.next(message);
    }
    selectMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            this._selected.next(message);
        });
    }
    selectMessageUser(message) {
        this._userSelected.next(message);
    }
    set source(value) {
        if (this._sourceSubs) {
            this._sourceSubs.unsubscribe();
            this._sourceSubs = null;
        }
        this._source = value;
        if (value) {
            let messages = (value.messages || []).slice();
            this.messages = messages;
            this.olderMessages = messages.splice(this.maxVisibleMessages, messages.length);
            this.hasMore = this.olderMessages.length > 0;
            this._sourceSubs = new SubSink();
            this._sourceSubs.add(this._source.messageReceived
                .subscribe(msg => this.messageReceived(msg)), this._source.messageSent
                .subscribe(msg => this.messageSent(msg)));
            if (this._source.currentUserChanged) {
                this._sourceSubs.add(this._source.currentUserChanged.subscribe(user => this.currentUser = user));
            }
        }
    }
    messageIdentity(index, chatMessage) {
        return chatMessage.id;
    }
    showNew() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isViewingMore = false;
            this.messages = this.newMessages.splice(0, this.newMessages.length).concat(this.messages);
            let overflow = this.messages.splice(this.maxVisibleMessages, this.messages.length);
            this.olderMessages = overflow.concat(this.olderMessages);
            this.olderMessages.splice(this.maxMessages - this.maxVisibleMessages, this.olderMessages.length);
        });
    }
    showMore() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isViewingMore = true;
            if (this.olderMessages.length > 0) {
                this.isLoadingMore = false;
                this.messages = this.messages.concat(this.olderMessages.splice(0, 50));
            }
            else {
                if (this.source.loadAfter) {
                    this.isLoadingMore = true;
                    let lastMessage = this.messages[this.messages.length - 1];
                    let messages = yield this.source.loadAfter(lastMessage, 100);
                    this.messages = this.messages.concat(messages);
                    this.isLoadingMore = false;
                    if (messages.length === 0)
                        this.hasMore = false;
                }
                else {
                    this.hasMore = false;
                }
            }
        });
    }
    addMessage(message) {
        let destination = this.messages;
        let bucket = this.olderMessages;
        if (this.isViewingMore) {
            destination = this.newMessages;
            bucket = null;
        }
        if (this.newestLast) {
            destination.push(message);
            let overflow = destination.splice(this.maxVisibleMessages, destination.length);
            bucket === null || bucket === void 0 ? void 0 : bucket.push(...overflow);
        }
        else {
            destination.unshift(message);
            let overflow = destination.splice(this.maxVisibleMessages, destination.length);
            bucket === null || bucket === void 0 ? void 0 : bucket.unshift(...overflow);
        }
        if ((bucket === null || bucket === void 0 ? void 0 : bucket.length) > 0)
            this.hasMore = true;
    }
    messageReceived(message) {
        this.addMessage(message);
        if (this.isScrolledToLatest())
            setTimeout(() => this.scrollToLatest());
    }
    isScrolledToLatest() {
        if (!this.messageContainer)
            return false;
        let el = this.messageContainer.nativeElement;
        let currentScroll = el.scrollTop;
        let currentTotal = el.scrollHeight - el.offsetHeight;
        return currentScroll > currentTotal - 10;
    }
    messageSent(message) {
        this.addMessage(message);
        if (!this.messageContainer)
            return;
        this.scrollToLatest();
    }
    scrollToLatest() {
        if (!this.messageContainer)
            return;
        let el = this.messageContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
    }
    mentionsMe(message) {
        if (!this.currentUser)
            return false;
        if (message.message.includes(`@${this.currentUser.username}`))
            return true;
        return false;
    }
    avatarForUser(user) {
        let url = this.genericAvatarUrl;
        if (user && user.avatarUrl)
            url = user.avatarUrl;
        return `url(${url})`;
    }
}
CommentViewComponent.ɵfac = function CommentViewComponent_Factory(t) { return new (t || CommentViewComponent)(ɵngcc0.ɵɵdirectiveInject(ChatBackendService)); };
CommentViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommentViewComponent, selectors: [["banta-comment-view"]], viewQuery: function CommentViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageContainer = _t.first);
    } }, hostVars: 2, hostBindings: function CommentViewComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("fixed-height", ctx.fixedHeight);
    } }, inputs: { showEmptyState: "showEmptyState", allowReplies: "allowReplies", maxMessages: "maxMessages", maxVisibleMessages: "maxVisibleMessages", newestLast: "newestLast", source: "source", fixedHeight: "fixedHeight", genericAvatarUrl: "genericAvatarUrl" }, outputs: { selected: "selected", userSelected: "userSelected", reported: "reported", upvoted: "upvoted" }, ngContentSelectors: _c4, decls: 13, vars: 9, consts: [[1, "message-container"], ["mat-button", "", "href", "javascript:;", 1, "nav", 3, "click"], [4, "ngIf"], ["class", "abbreviated", 3, "message", "showReplyAction", "click", "userSelected", "upvoted", "reported", "selected", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "loading-more", 4, "ngIf"], ["class", "empty-state", 4, "ngIf"], [1, "empty-state"], [1, "abbreviated", 3, "message", "showReplyAction", "click", "userSelected", "upvoted", "reported", "selected"], [1, "loading-more"]], template: function CommentViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "a", 1);
        ɵngcc0.ɵɵlistener("click", function CommentViewComponent_Template_a_click_2_listener() { return ctx.showNew(); });
        ɵngcc0.ɵɵelementStart(3, "mat-icon");
        ɵngcc0.ɵɵtext(4, "file_upload");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, " New ");
        ɵngcc0.ɵɵtemplate(6, CommentViewComponent_ng_container_6_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, CommentViewComponent_ng_container_7_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(8, CommentViewComponent_banta_comment_8_Template, 1, 2, "banta-comment", 3);
        ɵngcc0.ɵɵelementStart(9, "a", 1);
        ɵngcc0.ɵɵlistener("click", function CommentViewComponent_Template_a_click_9_listener() { return ctx.showMore(); });
        ɵngcc0.ɵɵtext(10, "Show more");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, CommentViewComponent_div_11_Template, 2, 0, "div", 4);
        ɵngcc0.ɵɵprojection(12, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("visible", ctx.isViewingMore);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.newMessages.length >= 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.messages.length === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messages)("ngForTrackBy", ctx.messageIdentity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("visible", ctx.hasMore && !ctx.isLoadingMore);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoadingMore);
    } }, directives: [ɵngcc3.MatAnchor, ɵngcc4.MatIcon, ɵngcc1.NgIf, ɵngcc1.NgForOf, CommentComponent, ɵngcc10.MatSpinner], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex-grow:1;opacity:1;transition:opacity .2s ease-in}.message-container[_ngcontent-%COMP%]{background:#fff;color:#111;flex-grow:1;opacity:1;overflow-x:hidden;padding:.5em 1em 3em .5em;position:relative;transition:opacity .5s ease-in-out}.message-container.no-scroll[_ngcontent-%COMP%]{height:auto;overflow-y:visible}.message-container.faded[_ngcontent-%COMP%]{opacity:.25}.message-container[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%]{bottom:0;left:0;position:absolute;right:0;top:0;z-index:10}.fixed-height[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]{overflow-y:auto}.mat-dark-theme[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]{background:#111;color:#fff}.empty-state[_ngcontent-%COMP%]{color:#666;margin:3em;text-align:center}.mat-dark-theme[_nghost-%COMP%]   .empty-state[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .empty-state[_ngcontent-%COMP%]{color:#666}a.nav[_ngcontent-%COMP%]{background:#222;border-radius:2em;opacity:0;pointer-events:none;position:absolute;right:.5em;text-align:center;transition:opacity .4s ease-in-out;z-index:10}a.nav.visible[_ngcontent-%COMP%]{opacity:1;pointer-events:auto}.loading-more[_ngcontent-%COMP%]{margin:0 auto;padding:2em;text-align:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}@media (max-width:400px){.message-container[_ngcontent-%COMP%]{padding:0 0 3em}}"] });
CommentViewComponent.ctorParameters = () => [
    { type: ChatBackendService }
];
CommentViewComponent.propDecorators = {
    showEmptyState: [{ type: Input }],
    allowReplies: [{ type: Input }],
    fixedHeight: [{ type: Input }, { type: HostBinding, args: ['class.fixed-height',] }],
    selected: [{ type: Output }],
    userSelected: [{ type: Output }],
    reported: [{ type: Output }],
    upvoted: [{ type: Output }],
    source: [{ type: Input }],
    genericAvatarUrl: [{ type: Input }],
    messageContainer: [{ type: ViewChild, args: ['messageContainer',] }],
    maxMessages: [{ type: Input }],
    maxVisibleMessages: [{ type: Input }],
    newestLast: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommentViewComponent, [{
        type: Component,
        args: [{
                selector: 'banta-comment-view',
                template: "<div class=\"message-container\">\r\n    <ng-content select=\"[data-before]\"></ng-content>\r\n    \r\n    <a mat-button class=\"nav\" [class.visible]=\"isViewingMore\" href=\"javascript:;\" (click)=\"showNew()\">\r\n        <mat-icon>file_upload</mat-icon>\r\n        New\r\n        <ng-container *ngIf=\"newMessages.length >= 1\">\r\n            ({{newMessages.length}})\r\n        </ng-container>\r\n    </a>\r\n\r\n    <ng-container *ngIf=\"messages.length === 0\">\r\n        <div class=\"empty-state\" *ngIf=\"showEmptyState\">\r\n            Be the first to comment!\r\n        </div>\r\n    </ng-container>\r\n    <banta-comment \r\n        *ngFor=\"let message of messages; trackBy: messageIdentity\"\r\n        class=\"abbreviated\"\r\n        [message]=\"message\"\r\n        (click)=\"isViewingMore = true\"\r\n        [showReplyAction]=\"allowReplies\"\r\n        (userSelected)=\"selectMessageUser(message)\"\r\n        (upvoted)=\"upvoteMessage(message)\"\r\n        (reported)=\"reportMessage(message)\"\r\n        (selected)=\"selectMessage(message)\"\r\n        ></banta-comment>\r\n\r\n    <a mat-button class=\"nav\" [class.visible]=\"hasMore && !isLoadingMore\" href=\"javascript:;\" (click)=\"showMore()\">Show more</a>\r\n\r\n    <div class=\"loading-more\" *ngIf=\"isLoadingMore\">\r\n        <mat-spinner></mat-spinner>\r\n    </div>\r\n\r\n    <!-- <div style=\"color: #666\">\r\n        n={{newMessages.length}}, m={{messages.length}}, o={{olderMessages.length}},\r\n        v={{maxVisibleMessages}}, M={{maxMessages}}\r\n    </div> -->\r\n\r\n    <ng-content select=\":not([data-before])\"></ng-content>\r\n</div>",
                styles: [":host{display:flex;flex-direction:column;flex-grow:1;opacity:1;transition:opacity .2s ease-in}.message-container{background:#fff;color:#111;flex-grow:1;opacity:1;overflow-x:hidden;padding:.5em 1em 3em .5em;position:relative;transition:opacity .5s ease-in-out}.message-container.no-scroll{height:auto;overflow-y:visible}.message-container.faded{opacity:.25}.message-container .overlay{bottom:0;left:0;position:absolute;right:0;top:0;z-index:10}:host.fixed-height .message-container{overflow-y:auto}:host-context(.mat-dark-theme) .message-container{background:#111;color:#fff}.empty-state{color:#666;margin:3em;text-align:center}:host-context(.mat-dark-theme) .empty-state{color:#666}a.nav{background:#222;border-radius:2em;opacity:0;pointer-events:none;position:absolute;right:.5em;text-align:center;transition:opacity .4s ease-in-out;z-index:10}a.nav.visible{opacity:1;pointer-events:auto}.loading-more{margin:0 auto;padding:2em;text-align:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}@media (max-width:400px){.message-container{padding:0 0 3em}}"]
            }]
    }], function () { return [{ type: ChatBackendService }]; }, { showEmptyState: [{
            type: Input
        }], allowReplies: [{
            type: Input
        }], maxMessages: [{
            type: Input
        }], maxVisibleMessages: [{
            type: Input
        }], newestLast: [{
            type: Input
        }], selected: [{
            type: Output
        }], userSelected: [{
            type: Output
        }], reported: [{
            type: Output
        }], upvoted: [{
            type: Output
        }], source: [{
            type: Input
        }], fixedHeight: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.fixed-height']
        }], genericAvatarUrl: [{
            type: Input
        }], messageContainer: [{
            type: ViewChild,
            args: ['messageContainer']
        }] }); })();

/**
 * Comments component
 */
class BantaCommentsComponent {
    constructor(banta, backend, elementRef) {
        this.banta = banta;
        this.backend = backend;
        this.elementRef = elementRef;
        this._upvoted = new Subject();
        this._reported = new Subject();
        this._selected = new Subject();
        this._userSelected = new Subject();
        this._subs = new SubSink();
        this.hashtags = [
            { hashtag: 'error', description: 'Cause an error' },
            { hashtag: 'timeout', description: 'Cause a slow timeout error' },
            { hashtag: 'slow', description: 'Be slow when this message is posted' },
        ];
        this.participants = [];
        this.signInLabel = 'Sign In';
        this.sendLabel = 'Send';
        this.replyLabel = 'Reply';
        this.sendingLabel = 'Sending';
        this.permissionDeniedLabel = 'Send';
        this.postCommentLabel = 'Post a comment';
        this.postReplyLabel = 'Post a reply';
        this._signInSelected = new Subject();
        this._permissionDeniedError = new Subject();
        this._editAvatarSelected = new Subject();
        this.sending = false;
        this.expandError = false;
        this.selectedMessageVisible = false;
    }
    ngOnInit() {
        this._subs.add(this.banta.userChanged.subscribe(user => this.user = user));
    }
    ngOnDestroy() {
        this._subs.unsubscribe();
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }
    get topicID() {
        return this._source.identifier;
    }
    set topicID(value) {
        this.setSourceFromTopicID(value);
    }
    setSourceFromTopicID(topicID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._source && this._source.close)
                this._source.close();
            this._source = null;
            this._source = yield this.backend.getSourceForTopic(topicID);
            this._source.messageReceived.subscribe(m => this.addParticipant(m));
            this._source.messageSent.subscribe(m => this.addParticipant(m));
            this._source.messages.forEach(m => this.addParticipant(m));
        });
    }
    addParticipant(message) {
        if (!message || !message.user || !message.user.id)
            return;
        let existing = this.participants.find(x => x.id === message.user.id);
        if (existing)
            return;
        this.participants.push(message.user);
    }
    showSignIn() {
        this._signInSelected.next();
    }
    showEditAvatar() {
        this._editAvatarSelected.next();
    }
    get newMessageText() {
        return this._newMessageText;
    }
    set newMessageText(value) {
        this._newMessageText = value;
        if (this._newMessageText === '' && this.sendError)
            setTimeout(() => this.sendError = null);
    }
    get signInSelected() {
        return this._signInSelected;
    }
    get editAvatarSelected() {
        return this._editAvatarSelected;
    }
    get permissionDeniedError() {
        return this._permissionDeniedError;
    }
    showPermissionDenied() {
        this._permissionDeniedError.next();
    }
    get canComment() {
        var _a;
        if (!this.user)
            return false;
        if (!this.user.permissions)
            return true;
        if (!this.user.permissions.canComment)
            return true;
        return (_a = this.user.permissions) === null || _a === void 0 ? void 0 : _a.canComment(this.source);
    }
    get upvoted() {
        return this._upvoted;
    }
    get reported() {
        return this._reported;
    }
    get selected() {
        return this._selected;
    }
    get userSelected() {
        return this._userSelected;
    }
    onKeyDown(event) {
    }
    insertEmoji(text) {
        this.newMessageText += text;
    }
    onReplyKeyDown(event) {
    }
    insertReplyEmoji(text) {
        this.replyMessage += text;
    }
    indicateError(message) {
        this.sendError = new Error(message);
        setTimeout(() => {
            this.expandError = true;
            setTimeout(() => {
                this.expandError = false;
            }, 5 * 1000);
        });
    }
    upvoteMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            this._upvoted.next(message);
            yield this.backend.upvoteMessage(message.topicId, message.parentMessageId ? message.parentMessageId : message.id, message.parentMessageId ? message.id : undefined);
        });
    }
    reportMessage(message) {
        this._reported.next(message);
    }
    unselectMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            let message = this.selectedMessage;
            this._selected.next(null);
            this.selectedMessage = null;
            if (this.selectedMessageThread) {
                if (this.selectedMessageThread.close)
                    this.selectedMessageThread.close();
                this.selectedMessageThread = null;
            }
            if (message)
                setTimeout(() => this.scrollToMessage(message));
        });
    }
    selectMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            this._selected.next(message);
            this.selectedMessage = message;
            setTimeout(() => this.selectedMessageVisible = true);
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                this.selectedMessageThread = yield this.backend.getSourceForThread(this.topicID, message.id);
            }), 250);
        });
    }
    selectMessageUser(message) {
        this._userSelected.next(message);
    }
    sendReply() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.selectedMessageThread.send({
                message: this.replyMessage,
                parentMessageId: this.selectedMessage.id,
                upvotes: 0,
                user: this.user,
                submessages: [],
                topicId: this.topicID,
                sentAt: Date.now(),
                updatedAt: Date.now()
            });
            this.replyMessage = '';
        });
    }
    scrollToMessage(message) {
        let el = this.elementRef.nativeElement.querySelector(`[data-comment-id="${message.id}"]`);
        if (!el)
            return;
        el.scrollIntoView({ block: 'center', inline: 'start' });
    }
}
BantaCommentsComponent.ɵfac = function BantaCommentsComponent_Factory(t) { return new (t || BantaCommentsComponent)(ɵngcc0.ɵɵdirectiveInject(BantaService), ɵngcc0.ɵɵdirectiveInject(ChatBackendService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BantaCommentsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BantaCommentsComponent, selectors: [["banta-comments"]], inputs: { hashtags: "hashtags", participants: "participants", signInLabel: "signInLabel", sendLabel: "sendLabel", replyLabel: "replyLabel", sendingLabel: "sendingLabel", permissionDeniedLabel: "permissionDeniedLabel", postCommentLabel: "postCommentLabel", postReplyLabel: "postReplyLabel", source: "source", topicID: "topicID", fixedHeight: "fixedHeight", maxMessages: "maxMessages", maxVisibleMessages: "maxVisibleMessages", genericAvatarUrl: "genericAvatarUrl" }, outputs: { signInSelected: "signInSelected", editAvatarSelected: "editAvatarSelected", permissionDeniedError: "permissionDeniedError", upvoted: "upvoted", reported: "reported", selected: "selected", userSelected: "userSelected" }, decls: 4, vars: 20, consts: [["class", "focused", 3, "visible", 4, "ngIf"], [1, "main"], [3, "source", "user", "sendLabel", "sendingLabel", "signInLabel", "canComment", "hashtags", "participants", "label", "permissionDeniedLabel", "editAvatarSelected", "signInSelected", "permissionDeniedError"], [3, "source", "fixedHeight", "maxMessages", "maxVisibleMessages", "genericAvatarUrl", "userSelected", "selected", "upvoted", "reported"], [1, "focused"], ["mat-button", "", "href", "javascript:;", 3, "click"], [3, "message"], [1, "replies"], [4, "ngIf"], [1, "loading"], [3, "source", "allowReplies", "fixedHeight", "showEmptyState", "newestLast"], [3, "sendLabel", "sendingLabel", "hashtags", "participants", "source", "canComment", "signInLabel", "permissionDeniedLabel", "user", "label", "signInSelected", "editAvatarSelected", "permissionDeniedError"]], template: function BantaCommentsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BantaCommentsComponent_div_0_Template, 10, 5, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "banta-comment-field", 2);
        ɵngcc0.ɵɵlistener("editAvatarSelected", function BantaCommentsComponent_Template_banta_comment_field_editAvatarSelected_2_listener() { return ctx.showEditAvatar(); })("signInSelected", function BantaCommentsComponent_Template_banta_comment_field_signInSelected_2_listener() { return ctx.showSignIn(); })("permissionDeniedError", function BantaCommentsComponent_Template_banta_comment_field_permissionDeniedError_2_listener() { return ctx.showPermissionDenied(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "banta-comment-view", 3);
        ɵngcc0.ɵɵlistener("userSelected", function BantaCommentsComponent_Template_banta_comment_view_userSelected_3_listener($event) { return ctx.selectMessageUser($event); })("selected", function BantaCommentsComponent_Template_banta_comment_view_selected_3_listener($event) { return ctx.selectMessage($event); })("upvoted", function BantaCommentsComponent_Template_banta_comment_view_upvoted_3_listener($event) { return ctx.upvoteMessage($event); })("reported", function BantaCommentsComponent_Template_banta_comment_view_reported_3_listener($event) { return ctx.reportMessage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hidden", ctx.selectedMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("source", ctx.source)("user", ctx.user)("sendLabel", ctx.sendLabel)("sendingLabel", ctx.sendingLabel)("signInLabel", ctx.signInLabel)("canComment", ctx.canComment)("hashtags", ctx.hashtags)("participants", ctx.participants)("label", ctx.postCommentLabel)("permissionDeniedLabel", ctx.permissionDeniedLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("faded", ctx.selectedMessage);
        ɵngcc0.ɵɵproperty("source", ctx.source)("fixedHeight", ctx.fixedHeight)("maxMessages", ctx.maxMessages)("maxVisibleMessages", ctx.maxVisibleMessages)("genericAvatarUrl", ctx.genericAvatarUrl);
    } }, directives: function () { return [ɵngcc1.NgIf, CommentFieldComponent, CommentViewComponent, ɵngcc3.MatAnchor, ɵngcc4.MatIcon, CommentComponent, ɵngcc10.MatSpinner]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column}@-webkit-keyframes select-comment{0%{transform:scale(1.15)}to{transform:scale(1)}}@keyframes select-comment{0%{transform:scale(1.15)}to{transform:scale(1)}}.focused[_ngcontent-%COMP%]{-webkit-animation-duration:.4s;-webkit-animation-fill-mode:both;-webkit-animation-name:select-comment;animation-duration:.4s;animation-fill-mode:both;animation-name:select-comment}.focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{margin-left:4em;margin-top:1em}banta-comment-view[_ngcontent-%COMP%]{opacity:1;transition:opacity .4s ease-in-out}banta-comment-view.faded[_ngcontent-%COMP%]{opacity:.25}.loading[_ngcontent-%COMP%]{display:block;margin:0 auto;min-height:16em;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.main.hidden[_ngcontent-%COMP%]{display:none}@media (max-width:500px){.focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{margin-left:0}}"] });
BantaCommentsComponent.ctorParameters = () => [
    { type: BantaService },
    { type: ChatBackendService },
    { type: ElementRef }
];
BantaCommentsComponent.propDecorators = {
    hashtags: [{ type: Input }],
    participants: [{ type: Input }],
    source: [{ type: Input }],
    fixedHeight: [{ type: Input }],
    maxMessages: [{ type: Input }],
    maxVisibleMessages: [{ type: Input }],
    genericAvatarUrl: [{ type: Input }],
    topicID: [{ type: Input }],
    signInLabel: [{ type: Input }],
    sendLabel: [{ type: Input }],
    replyLabel: [{ type: Input }],
    sendingLabel: [{ type: Input }],
    permissionDeniedLabel: [{ type: Input }],
    postCommentLabel: [{ type: Input }],
    postReplyLabel: [{ type: Input }],
    signInSelected: [{ type: Output }],
    editAvatarSelected: [{ type: Output }],
    permissionDeniedError: [{ type: Output }],
    upvoted: [{ type: Output }],
    reported: [{ type: Output }],
    selected: [{ type: Output }],
    userSelected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaCommentsComponent, [{
        type: Component,
        args: [{
                selector: 'banta-comments',
                template: "\r\n<div class=\"focused\" [class.visible]=\"selectedMessageVisible\" *ngIf=\"selectedMessage\">\r\n\r\n    <div>\r\n        <a mat-button href=\"javascript:;\" (click)=\"unselectMessage()\">\r\n            <mat-icon>arrow_back</mat-icon>\r\n            Latest Comments\r\n        </a>\r\n    </div>\r\n\r\n    <banta-comment \r\n        [message]=\"selectedMessage\"\r\n        ></banta-comment>\r\n\r\n    <div class=\"replies\">\r\n\r\n        <ng-container *ngIf=\"!selectedMessageThread\">\r\n            <div class=\"loading\">\r\n                <mat-spinner></mat-spinner>\r\n            </div>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"selectedMessageThread\">\r\n            <banta-comment-view \r\n                [source]=\"selectedMessageThread\"\r\n                [allowReplies]=\"false\"\r\n                [fixedHeight]=\"false\"\r\n                [showEmptyState]=\"false\"\r\n                [newestLast]=\"true\"\r\n                ></banta-comment-view>\r\n\r\n            <banta-comment-field\r\n                [sendLabel]=\"replyLabel\"\r\n                [sendingLabel]=\"sendingLabel\"\r\n                [hashtags]=\"hashtags\"\r\n                [participants]=\"participants\"\r\n                (signInSelected)=\"showSignIn()\"\r\n                (editAvatarSelected)=\"showEditAvatar()\"\r\n                [source]=\"selectedMessageThread\"\r\n                [canComment]=\"canComment\"\r\n                [signInLabel]=\"signInLabel\"\r\n                [permissionDeniedLabel]=\"permissionDeniedLabel\"\r\n                (permissionDeniedError)=\"showPermissionDenied()\"\r\n                [user]=\"user\"\r\n                [label]=\"postReplyLabel\"\r\n                ></banta-comment-field>\r\n        </ng-container>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"main\" [class.hidden]=\"selectedMessage\">\r\n    <banta-comment-field\r\n        [source]=\"source\"\r\n        [user]=\"user\"\r\n        [sendLabel]=\"sendLabel\"\r\n        [sendingLabel]=\"sendingLabel\"\r\n        [signInLabel]=\"signInLabel\"\r\n        [canComment]=\"canComment\"\r\n        [hashtags]=\"hashtags\"\r\n        [participants]=\"participants\"\r\n        [label]=\"postCommentLabel\"\r\n        (editAvatarSelected)=\"showEditAvatar()\"\r\n        (signInSelected)=\"showSignIn()\"\r\n        [permissionDeniedLabel]=\"permissionDeniedLabel\"\r\n        (permissionDeniedError)=\"showPermissionDenied()\"\r\n        ></banta-comment-field>\r\n\r\n    <banta-comment-view \r\n        [class.faded]=\"selectedMessage\"\r\n        [source]=\"source\"\r\n        [fixedHeight]=\"fixedHeight\"\r\n        [maxMessages]=\"maxMessages\"\r\n        [maxVisibleMessages]=\"maxVisibleMessages\"\r\n        [genericAvatarUrl]=\"genericAvatarUrl\"\r\n        (userSelected)=\"selectMessageUser($event)\"\r\n        (selected)=\"selectMessage($event)\"\r\n        (upvoted)=\"upvoteMessage($event)\"\r\n        (reported)=\"reportMessage($event)\"\r\n        ></banta-comment-view>\r\n</div>",
                styles: [":host{display:flex;flex-direction:column}@-webkit-keyframes select-comment{0%{transform:scale(1.15)}to{transform:scale(1)}}@keyframes select-comment{0%{transform:scale(1.15)}to{transform:scale(1)}}.focused{-webkit-animation-duration:.4s;-webkit-animation-fill-mode:both;-webkit-animation-name:select-comment;animation-duration:.4s;animation-fill-mode:both;animation-name:select-comment}.focused .replies{margin-left:4em;margin-top:1em}banta-comment-view{opacity:1;transition:opacity .4s ease-in-out}banta-comment-view.faded{opacity:.25}.loading{display:block;margin:0 auto;min-height:16em;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.main.hidden{display:none}@media (max-width:500px){.focused .replies{margin-left:0}}"]
            }]
    }], function () { return [{ type: BantaService }, { type: ChatBackendService }, { type: ɵngcc0.ElementRef }]; }, { hashtags: [{
            type: Input
        }], participants: [{
            type: Input
        }], signInLabel: [{
            type: Input
        }], sendLabel: [{
            type: Input
        }], replyLabel: [{
            type: Input
        }], sendingLabel: [{
            type: Input
        }], permissionDeniedLabel: [{
            type: Input
        }], postCommentLabel: [{
            type: Input
        }], postReplyLabel: [{
            type: Input
        }], source: [{
            type: Input
        }], topicID: [{
            type: Input
        }], signInSelected: [{
            type: Output
        }], editAvatarSelected: [{
            type: Output
        }], permissionDeniedError: [{
            type: Output
        }], upvoted: [{
            type: Output
        }], reported: [{
            type: Output
        }], selected: [{
            type: Output
        }], userSelected: [{
            type: Output
        }], fixedHeight: [{
            type: Input
        }], maxMessages: [{
            type: Input
        }], maxVisibleMessages: [{
            type: Input
        }], genericAvatarUrl: [{
            type: Input
        }] }); })();

class LiveCommentComponent {
    constructor(backend) {
        this.backend = backend;
        this._upvoted = new Subject();
        this._reported = new Subject();
        this._selected = new Subject();
    }
    get upvoted() {
        return this._upvoted;
    }
    get reported() {
        return this._reported;
    }
    get selected() {
        return this._selected;
    }
    get message() {
        return this._message;
    }
    set message(value) {
        let originalId = null;
        if (this._message)
            originalId = this._message.id;
        this._message = value;
        if (value && originalId === value.id) {
            return;
        }
        if (this.unsubscribe)
            this.unsubscribe();
        if (value) {
            this.unsubscribe = this.backend.watchMessage(value, message => this.message = message);
        }
    }
    report() {
        this._reported.next();
    }
    upvote() {
        this._upvoted.next();
    }
    select() {
        this._selected.next();
    }
}
LiveCommentComponent.ɵfac = function LiveCommentComponent_Factory(t) { return new (t || LiveCommentComponent)(ɵngcc0.ɵɵdirectiveInject(ChatBackendService)); };
LiveCommentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LiveCommentComponent, selectors: [["banta-live-comment"]], inputs: { message: "message" }, outputs: { upvoted: "upvoted", reported: "reported", selected: "selected" }, decls: 1, vars: 1, consts: [[3, "message", "upvoted", "reported", "selected", 4, "ngIf"], [3, "message", "upvoted", "reported", "selected"]], template: function LiveCommentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LiveCommentComponent_banta_comment_0_Template, 1, 1, "banta-comment", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
    } }, directives: [ɵngcc1.NgIf, CommentComponent], styles: [""] });
LiveCommentComponent.ctorParameters = () => [
    { type: ChatBackendService }
];
LiveCommentComponent.propDecorators = {
    upvoted: [{ type: Output }],
    reported: [{ type: Output }],
    selected: [{ type: Output }],
    message: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveCommentComponent, [{
        type: Component,
        args: [{
                selector: 'banta-live-comment',
                template: `
        <banta-comment 
            *ngIf="message"
            [message]="message"
            (upvoted)="upvote()"
            (reported)="report()"
            (selected)="select()"
            ></banta-comment>
    `,
                styles: [``]
            }]
    }], function () { return [{ type: ChatBackendService }]; }, { upvoted: [{
            type: Output
        }], reported: [{
            type: Output
        }], selected: [{
            type: Output
        }], message: [{
            type: Input
        }] }); })();

class CommentFieldComponent {
    constructor() {
        this.canComment = true;
        this.signInSelected = new Subject();
        this.editAvatarSelected = new Subject();
        this.sending = false;
        this.expandError = false;
        this.text = '';
        this.sendLabel = 'Send';
        this.sendingLabel = 'Sending';
        this.label = 'Post a comment';
        this.permissionDeniedLabel = 'Unavailable';
        this.signInLabel = 'Sign In';
        this.placeholder = '';
        this.participants = [];
        this._permissionDeniedError = new Subject();
        this.autocompleteVisible = false;
        this.autocompleteOptions = [];
        this.autoCompleteSelected = 0;
    }
    get permissionDeniedError() {
        return this._permissionDeniedError;
    }
    ngAfterViewInit() {
        let root = document.body.querySelector('[ng-version]') || document.body;
        root.appendChild(this.autocompleteEl.nativeElement);
    }
    showPermissionDenied() {
        this._permissionDeniedError.next();
    }
    showAutoComplete(options) {
        this.autoCompleteSelected = 0;
        this.autocompleteOptions = options;
        let pos = this.autocompleteContainerEl.nativeElement.getBoundingClientRect();
        let size = this.autocompleteEl.nativeElement.getBoundingClientRect();
        this.autocompleteEl.nativeElement.style.left = `${window.scrollX + pos.left}px`;
        this.autocompleteEl.nativeElement.style.top = `${window.scrollY + pos.top}px`;
        this.autocompleteEl.nativeElement.style.width = `${pos.width}px`;
        this.autocompleteVisible = true;
    }
    activateAutoComplete(option) {
        option.action();
        this.dismissAutoComplete();
    }
    dismissAutoComplete() {
        this.autocompleteVisible = false;
        this.completionFunc = null;
        this.completionPrefix = '';
    }
    indicateError(message) {
        this.sendError = new Error(message);
        setTimeout(() => {
            this.expandError = true;
            setTimeout(() => {
                this.expandError = false;
            }, 5 * 1000);
        });
    }
    autocomplete(replacement) {
        return __awaiter(this, void 0, void 0, function* () {
            let el = this.textareaEl.nativeElement;
            this.text = this.text.slice(0, el.selectionStart - this.completionPrefix.length) + replacement + this.text.slice(el.selectionStart);
        });
    }
    insert(str) {
        return __awaiter(this, void 0, void 0, function* () {
            let el = this.textareaEl.nativeElement;
            this.text = this.text.slice(0, el.selectionStart) + str + this.text.slice(el.selectionStart);
        });
    }
    onKeyDown(event) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(event.key);
            if (this.autocompleteVisible) {
                if (event.key === 'Escape') {
                    this.dismissAutoComplete();
                    return;
                }
                if (event.key === 'Shift') {
                    return;
                }
                if (event.key === 'Enter') {
                    this.activateAutoComplete(this.autocompleteOptions[this.autoCompleteSelected]);
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
                if (event.key === 'ArrowUp') {
                    if (this.autoCompleteSelected === 0)
                        this.autoCompleteSelected = this.autocompleteOptions.length - 1;
                    else
                        this.autoCompleteSelected = this.autoCompleteSelected - 1;
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
                else if (event.key === 'ArrowDown') {
                    this.autoCompleteSelected = (this.autoCompleteSelected + 1) % this.autocompleteOptions.length;
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
            }
            if (event.key === 'Enter' && event.ctrlKey) {
                yield this.sendMessage();
                return;
            }
            if (this.completionFunc) {
                if (event.key === 'Backspace') {
                    this.completionPrefix = this.completionPrefix.slice(0, this.completionPrefix.length - 1);
                    if (this.completionPrefix === '') {
                        this.dismissAutoComplete();
                        return;
                    }
                }
                else if (event.key === ' ' || event.key.length > 1) {
                    this.dismissAutoComplete();
                    return;
                }
                else {
                    this.completionPrefix += event.key;
                }
                this.showAutoComplete(this.completionFunc(this.completionPrefix));
            }
            else {
                if (event.key === ':') {
                    this.startAutoComplete(event, prefix => {
                        prefix = prefix.slice(1);
                        // makes :-), :-( etc work (as they are ":)" etc in the db)
                        if (prefix.startsWith('-'))
                            prefix = prefix.slice(1);
                        return Object.keys(EMOJIS)
                            .filter(k => k.includes(prefix) || EMOJIS[k].keywords.some(kw => kw.includes(prefix)))
                            .map(k => ({
                            label: `${EMOJIS[k].char} ${k}`,
                            action: () => this.autocomplete(EMOJIS[k].char)
                        }))
                            .slice(0, 5);
                    });
                }
                else if (event.key === '@') {
                    this.startAutoComplete(event, prefix => {
                        prefix = prefix.slice(1);
                        return this.participants.filter(x => x.username.includes(prefix))
                            .map(p => ({
                            label: `@${p.username} -- ${p.displayName}`,
                            action: () => this.autocomplete(`@${p.username}`)
                        }));
                    });
                }
                else if (event.key === '#') {
                    this.startAutoComplete(event, prefix => {
                        prefix = prefix.slice(1);
                        return this.hashtags
                            .filter(ht => ht.hashtag.includes(prefix))
                            .map(ht => ({
                            label: `#${ht.hashtag}${ht.description ? ` -- ${ht.description}` : ``}`,
                            action: () => this.autocomplete(`#${ht.hashtag}`)
                        }))
                            .slice(0, 5);
                    });
                }
            }
        });
    }
    startAutoComplete(event, completionFunc) {
        this.completionPrefix = event.key;
        this.completionFunc = completionFunc;
        this.showAutoComplete(this.completionFunc(this.completionPrefix));
    }
    onBlur() {
        setTimeout(() => this.dismissAutoComplete(), 250);
    }
    insertEmoji(text) {
        this.text += text;
    }
    showSignIn() {
        this.signInSelected.next();
    }
    showEditAvatar() {
        this.editAvatarSelected.next();
    }
    sendMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.source)
                return;
            this.sending = true;
            this.sendError = null;
            try {
                let text = (this.text || '').trim();
                if (text === '')
                    return;
                let message = {
                    user: this.user,
                    sentAt: Date.now(),
                    url: location.href,
                    upvotes: 0,
                    message: text
                };
                try {
                    yield this.source.send(message);
                    this.text = '';
                }
                catch (e) {
                    this.indicateError(`Could not send: ${e.message}`);
                    console.error(`Failed to send message: `, message);
                    console.error(e);
                }
            }
            finally {
                this.sending = false;
            }
        });
    }
}
CommentFieldComponent.ɵfac = function CommentFieldComponent_Factory(t) { return new (t || CommentFieldComponent)(); };
CommentFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommentFieldComponent, selectors: [["banta-comment-field"]], viewQuery: function CommentFieldComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, true);
        ɵngcc0.ɵɵviewQuery(_c8, true);
        ɵngcc0.ɵɵviewQuery(_c9, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autocompleteEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autocompleteContainerEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textareaEl = _t.first);
    } }, inputs: { canComment: "canComment", sendLabel: "sendLabel", sendingLabel: "sendingLabel", label: "label", permissionDeniedLabel: "permissionDeniedLabel", signInLabel: "signInLabel", placeholder: "placeholder", participants: "participants", source: "source", user: "user", hashtags: "hashtags" }, outputs: { signInSelected: "signInSelected", editAvatarSelected: "editAvatarSelected", permissionDeniedError: "permissionDeniedError" }, decls: 25, vars: 14, consts: [[1, "new-message", 3, "submit"], [1, "avatar-container"], ["href", "javascript:;", 1, "avatar", 3, "click"], [1, "text-container"], [1, "field-container"], ["appearance", "outline", "floatLabel", "always"], ["name", "message", "matInput", "", "cdkTextareaAutosize", "", 3, "placeholder", "disabled", "ngModel", "keydown", "blur", "ngModelChange"], ["textarea", ""], [1, "autocomplete-container"], ["autocompleteContainer", ""], [1, "autocomplete"], ["autocomplete", ""], ["mat-button", "", 3, "active", "click", 4, "ngFor", "ngForOf"], ["class", "icon loading", "diameter", "18", "strokeWidth", "2", 4, "ngIf"], ["class", "error-message", 3, "expanded", 4, "ngIf"], [1, "top-right", 3, "selected"], [1, "actions"], [4, "ngIf"], ["mat-button", "", 3, "click"], ["diameter", "18", "strokeWidth", "2", 1, "icon", "loading"], [1, "error-message"], ["mat-raised-button", "", "color", "primary", "type", "button", 3, "click"], ["mat-raised-button", "", "class", "send", "color", "primary", 3, "disabled", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", 1, "send", 3, "disabled"], ["class", "icon", "diameter", "18", "strokeWidth", "2", 4, "ngIf"], [1, "label"], ["diameter", "18", "strokeWidth", "2", 1, "icon"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "click"]], template: function CommentFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵlistener("submit", function CommentFieldComponent_Template_form_submit_0_listener() { return ctx.sendMessage(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵlistener("click", function CommentFieldComponent_Template_a_click_2_listener() { return ctx.showEditAvatar(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "mat-form-field", 5);
        ɵngcc0.ɵɵelementStart(6, "mat-label");
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "textarea", 6, 7);
        ɵngcc0.ɵɵlistener("keydown", function CommentFieldComponent_Template_textarea_keydown_8_listener($event) { return ctx.onKeyDown($event); })("blur", function CommentFieldComponent_Template_textarea_blur_8_listener() { return ctx.onBlur(); })("ngModelChange", function CommentFieldComponent_Template_textarea_ngModelChange_8_listener($event) { return ctx.text = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 8, 9);
        ɵngcc0.ɵɵelementStart(12, "div", 10, 11);
        ɵngcc0.ɵɵelementStart(14, "div");
        ɵngcc0.ɵɵelementStart(15, "strong");
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "... ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, CommentFieldComponent_a_18_Template, 2, 3, "a", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, CommentFieldComponent_mat_spinner_19_Template, 1, 0, "mat-spinner", 13);
        ɵngcc0.ɵɵtemplate(20, CommentFieldComponent_div_20_Template, 3, 4, "div", 14);
        ɵngcc0.ɵɵelementStart(21, "emoji-selector-button", 15);
        ɵngcc0.ɵɵlistener("selected", function CommentFieldComponent_Template_emoji_selector_button_selected_21_listener($event) { return ctx.insertEmoji($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 16);
        ɵngcc0.ɵɵtemplate(23, CommentFieldComponent_ng_container_23_Template, 3, 1, "ng-container", 17);
        ɵngcc0.ɵɵtemplate(24, CommentFieldComponent_ng_container_24_Template, 3, 2, "ng-container", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("background-image", "url(" + (ctx.user == null ? null : ctx.user.avatarUrl) + ")");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("disabled", ctx.sending)("ngModel", ctx.text);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("visible", ctx.autocompleteVisible);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.completionPrefix);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.autocompleteOptions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sending);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sendError);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.user);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.user);
    } }, directives: [ɵngcc7.ɵangular_packages_forms_forms_y, ɵngcc7.NgControlStatusGroup, ɵngcc7.NgForm, ɵngcc5.MatFormField, ɵngcc5.MatLabel, ɵngcc6.MatInput, ɵngcc11.CdkTextareaAutosize, ɵngcc7.DefaultValueAccessor, ɵngcc7.NgControlStatus, ɵngcc7.NgModel, ɵngcc1.NgForOf, ɵngcc1.NgIf, EmojiSelectorButtonComponent, ɵngcc3.MatAnchor, ɵngcc10.MatSpinner, ɵngcc4.MatIcon, ɵngcc3.MatButton], styles: ["@-webkit-keyframes comment-field-appear{0%{opacity:0;transform:translateY(128px)}to{opacity:1;transform:translate(0)}}@keyframes comment-field-appear{0%{opacity:0;transform:translateY(128px)}to{opacity:1;transform:translate(0)}}[_nghost-%COMP%]{-webkit-animation-delay:.4s;-webkit-animation-duration:.8s;-webkit-animation-fill-mode:both;-webkit-animation-name:comment-field-appear;animation-delay:.4s;animation-duration:.8s;animation-fill-mode:both;animation-name:comment-field-appear;display:block;margin:0 2em 0 0}.avatar-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;width:calc(48px + 1.75em)}.avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{background:pink;background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;height:48px;margin-right:.75em;margin-top:.75em;width:48px}form[_ngcontent-%COMP%]{align-items:center;display:flex;padding:.5em}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]{display:flex;flex-grow:1;position:relative}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-size:14pt;width:100%}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   textarea[disabled][_ngcontent-%COMP%]{opacity:.5}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{margin-bottom:1em}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   emoji-selector-button[_ngcontent-%COMP%]{bottom:0;position:absolute;right:0}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   .error-message[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   mat-spinner.loading[_ngcontent-%COMP%]{bottom:.5em;left:.5em;position:absolute}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   .error-message[_ngcontent-%COMP%]{color:#683333;max-width:1.5em;overflow-x:hidden;transition:max-width 2s ease-in-out;white-space:nowrap}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   .error-message.expanded[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   .error-message[_ngcontent-%COMP%]:hover{max-width:100%}form[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   .error-message[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{vertical-align:middle}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#000;border:1px solid #333;color:#fff;height:1em;width:100%}form[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{margin-left:1em}form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;margin:0 0 0 auto}form.new-message[_ngcontent-%COMP%]{align-items:flex-start;display:flex}form.new-message[_ngcontent-%COMP%]   .field-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-grow:1}form.new-message[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{width:100%}form.new-message[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:1.25em 0 0}button.send[_ngcontent-%COMP%]{min-width:9em}textarea[_ngcontent-%COMP%]{max-height:7em}.autocomplete-container[_ngcontent-%COMP%]{pointer-events:none;position:relative;top:-2em;width:calc(100% - 2em)}.autocomplete[_ngcontent-%COMP%]{background:#333;display:flex;flex-direction:column;padding:.5em;pointer-events:none;position:absolute;visibility:hidden;z-index:100}.autocomplete.visible[_ngcontent-%COMP%]{pointer-events:auto;visibility:visible}.autocomplete[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-align:left;width:100%}.autocomplete[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%]{background:#555}@media (max-width:500px){[_nghost-%COMP%]{margin:0}.avatar-container[_ngcontent-%COMP%]{width:auto}.avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{height:32px;margin-top:1.5em;width:32px}button.send[_ngcontent-%COMP%]{margin-top:1.5em;min-width:auto}button.send[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{display:none}}"] });
CommentFieldComponent.propDecorators = {
    source: [{ type: Input }],
    user: [{ type: Input }],
    canComment: [{ type: Input }],
    signInSelected: [{ type: Output }],
    editAvatarSelected: [{ type: Output }],
    sendLabel: [{ type: Input }],
    sendingLabel: [{ type: Input }],
    label: [{ type: Input }],
    permissionDeniedLabel: [{ type: Input }],
    signInLabel: [{ type: Input }],
    placeholder: [{ type: Input }],
    autocompleteEl: [{ type: ViewChild, args: ['autocomplete',] }],
    autocompleteContainerEl: [{ type: ViewChild, args: ['autocompleteContainer',] }],
    textareaEl: [{ type: ViewChild, args: ['textarea',] }],
    hashtags: [{ type: Input }],
    participants: [{ type: Input }],
    permissionDeniedError: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommentFieldComponent, [{
        type: Component,
        args: [{
                selector: 'banta-comment-field',
                template: "<form class=\"new-message\" (submit)=\"sendMessage()\">\r\n    <div class=\"avatar-container\">\r\n        <a  href=\"javascript:;\" \r\n            class=\"avatar\" \r\n            (click)=\"showEditAvatar()\" \r\n            [style.background-image]=\"'url(' + user?.avatarUrl + ')'\"\r\n            ></a>\r\n    </div>\r\n    <div class=\"text-container\">\r\n        <div class=\"field-container\">\r\n            <mat-form-field appearance=\"outline\" floatLabel=\"always\">\r\n                <mat-label>{{label}}</mat-label>\r\n                <textarea \r\n                    #textarea\r\n                    name=\"message\" \r\n                    [placeholder]=\"placeholder\"\r\n                    matInput\r\n                    cdkTextareaAutosize \r\n                    (keydown)=\"onKeyDown($event)\"\r\n                    (blur)=\"onBlur()\"\r\n                    [disabled]=\"sending\"\r\n                    [(ngModel)]=\"text\"></textarea>\r\n            </mat-form-field>\r\n            <div #autocompleteContainer class=\"autocomplete-container\">\r\n                <div #autocomplete class=\"autocomplete\" [class.visible]=\"autocompleteVisible\">\r\n\r\n                    <div>\r\n                        <strong>{{completionPrefix}}</strong>...\r\n                    </div>\r\n\r\n                    <a \r\n                        mat-button \r\n                        *ngFor=\"let option of autocompleteOptions; index as index\" \r\n                        (click)=\"activateAutoComplete(option)\"\r\n                        [class.active]=\"autoCompleteSelected === index\" \r\n                        >\r\n                        {{option.label}}\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <mat-spinner *ngIf=\"sending\" class=\"icon loading\" diameter=\"18\" strokeWidth=\"2\"></mat-spinner>\r\n        <div *ngIf=\"sendError\" class=\"error-message\" [class.expanded]=\"expandError\">\r\n            <mat-icon *ngIf=\"sendError\">error</mat-icon>\r\n            {{sendError.message}}\r\n        </div>\r\n        <emoji-selector-button \r\n            class=\"top-right\"\r\n            (selected)=\"insertEmoji($event)\"\r\n            ></emoji-selector-button>\r\n    </div>\r\n    <div class=\"actions\">\r\n        <ng-container *ngIf=\"!user\">\r\n            <button \r\n                mat-raised-button \r\n                color=\"primary\"\r\n                type=\"button\"\r\n                (click)=\"showSignIn()\"\r\n                >{{signInLabel}}</button>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"user\">\r\n            <button \r\n                *ngIf=\"canComment\"\r\n                mat-raised-button \r\n                class=\"send\"\r\n                color=\"primary\"\r\n                [disabled]=\"!text || sending\" \r\n                >\r\n                <mat-icon *ngIf=\"!sending\">chevron_right</mat-icon>\r\n                <mat-spinner *ngIf=\"sending\" class=\"icon\" diameter=\"18\" strokeWidth=\"2\"></mat-spinner>\r\n                <span class=\"label\">\r\n                    <ng-container *ngIf=\"!sending\">\r\n                        {{sendLabel}}\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"sending\">\r\n                        {{sendingLabel}}\r\n                    </ng-container>\r\n                </span>\r\n\r\n                </button>\r\n            <button \r\n                *ngIf=\"!canComment\"\r\n                type=\"button\"\r\n                (click)=\"showPermissionDenied()\"\r\n                mat-raised-button \r\n                color=\"primary\"\r\n                >{{permissionDeniedLabel}}</button>\r\n        </ng-container>\r\n    </div>\r\n</form>\r\n",
                styles: ["@-webkit-keyframes comment-field-appear{0%{opacity:0;transform:translateY(128px)}to{opacity:1;transform:translate(0)}}@keyframes comment-field-appear{0%{opacity:0;transform:translateY(128px)}to{opacity:1;transform:translate(0)}}:host{-webkit-animation-delay:.4s;-webkit-animation-duration:.8s;-webkit-animation-fill-mode:both;-webkit-animation-name:comment-field-appear;animation-delay:.4s;animation-duration:.8s;animation-fill-mode:both;animation-name:comment-field-appear;display:block;margin:0 2em 0 0}.avatar-container{display:flex;justify-content:flex-end;width:calc(48px + 1.75em)}.avatar-container .avatar{background:pink;background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;height:48px;margin-right:.75em;margin-top:.75em;width:48px}form{align-items:center;display:flex;padding:.5em}form .text-container{display:flex;flex-grow:1;position:relative}form .text-container textarea{font-size:14pt;width:100%}form .text-container textarea[disabled]{opacity:.5}form .text-container mat-form-field{margin-bottom:1em}form .text-container emoji-selector-button{bottom:0;position:absolute;right:0}form .text-container .error-message,form .text-container mat-spinner.loading{bottom:.5em;left:.5em;position:absolute}form .text-container .error-message{color:#683333;max-width:1.5em;overflow-x:hidden;transition:max-width 2s ease-in-out;white-space:nowrap}form .text-container .error-message.expanded,form .text-container .error-message:hover{max-width:100%}form .text-container .error-message mat-icon{vertical-align:middle}form input[type=text]{background:#000;border:1px solid #333;color:#fff;height:1em;width:100%}form .actions{margin-left:1em}form button{display:block;margin:0 0 0 auto}form.new-message{align-items:flex-start;display:flex}form.new-message .field-container{display:flex;flex-direction:column;flex-grow:1}form.new-message mat-form-field{width:100%}form.new-message button{margin:1.25em 0 0}button.send{min-width:9em}textarea{max-height:7em}.autocomplete-container{pointer-events:none;position:relative;top:-2em;width:calc(100% - 2em)}.autocomplete{background:#333;display:flex;flex-direction:column;padding:.5em;pointer-events:none;position:absolute;visibility:hidden;z-index:100}.autocomplete.visible{pointer-events:auto;visibility:visible}.autocomplete a{text-align:left;width:100%}.autocomplete a.active{background:#555}@media (max-width:500px){:host{margin:0}.avatar-container{width:auto}.avatar-container .avatar{height:32px;margin-top:1.5em;width:32px}button.send{margin-top:1.5em;min-width:auto}button.send .label{display:none}}"]
            }]
    }], function () { return []; }, { canComment: [{
            type: Input
        }], signInSelected: [{
            type: Output
        }], editAvatarSelected: [{
            type: Output
        }], sendLabel: [{
            type: Input
        }], sendingLabel: [{
            type: Input
        }], label: [{
            type: Input
        }], permissionDeniedLabel: [{
            type: Input
        }], signInLabel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], participants: [{
            type: Input
        }], permissionDeniedError: [{
            type: Output
        }], source: [{
            type: Input
        }], user: [{
            type: Input
        }], autocompleteEl: [{
            type: ViewChild,
            args: ['autocomplete']
        }], autocompleteContainerEl: [{
            type: ViewChild,
            args: ['autocompleteContainer']
        }], textareaEl: [{
            type: ViewChild,
            args: ['textarea']
        }], hashtags: [{
            type: Input
        }] }); })();

const COMPONENTS$3 = [
    CommentComponent,
    CommentViewComponent,
    BantaCommentsComponent,
    LiveCommentComponent,
    CommentFieldComponent
];
class CommentsModule {
}
CommentsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CommentsModule });
CommentsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CommentsModule_Factory(t) { return new (t || CommentsModule)(); }, imports: [[
            CommonModule,
            TextFieldModule,
            FormsModule,
            MatIconModule,
            MatFormFieldModule,
            MatInputModule,
            MatButtonModule,
            MatMenuModule,
            MatProgressSpinnerModule,
            BantaCommonModule,
            EmojiModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CommentsModule, { declarations: function () { return [CommentComponent, CommentViewComponent, BantaCommentsComponent, LiveCommentComponent, CommentFieldComponent]; }, imports: function () { return [CommonModule,
        TextFieldModule,
        FormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatMenuModule,
        MatProgressSpinnerModule, BantaCommonModule, EmojiModule]; }, exports: function () { return [CommentComponent, CommentViewComponent, BantaCommentsComponent, LiveCommentComponent, CommentFieldComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommentsModule, [{
        type: NgModule,
        args: [{
                declarations: COMPONENTS$3,
                imports: [
                    CommonModule,
                    TextFieldModule,
                    FormsModule,
                    MatIconModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatProgressSpinnerModule,
                    BantaCommonModule,
                    EmojiModule
                ],
                exports: COMPONENTS$3
            }]
    }], null, null); })();

class BantaSdkModule {
    static forRoot() {
        return {
            ngModule: BantaSdkModule,
            providers: [
                BantaService
            ]
        };
    }
}
BantaSdkModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BantaSdkModule });
BantaSdkModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BantaSdkModule_Factory(t) { return new (t || BantaSdkModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            BantaCommonModule,
            CommentsModule,
            ChatModule,
            EmojiModule,
            MatIconModule,
            MatButtonModule,
            MatTooltipModule,
            MatMenuModule,
            MatDialogModule,
            MatFormFieldModule,
            MatInputModule,
            MatProgressSpinnerModule
        ], ChatModule, CommentsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BantaSdkModule, { declarations: function () { return [BantaComponent, BantaLogoComponent, LiveMessageComponent]; }, imports: function () { return [CommonModule,
        FormsModule, BantaCommonModule, CommentsModule, ChatModule, EmojiModule, MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatMenuModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule]; }, exports: function () { return [BantaComponent, BantaLogoComponent, LiveMessageComponent, ChatModule, CommentsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BantaSdkModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    BantaCommonModule,
                    CommentsModule,
                    ChatModule,
                    EmojiModule,
                    MatIconModule,
                    MatButtonModule,
                    MatTooltipModule,
                    MatMenuModule,
                    MatDialogModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatProgressSpinnerModule
                ],
                declarations: [
                    BantaComponent,
                    BantaLogoComponent,
                    LiveMessageComponent
                ],
                exports: [
                    BantaComponent,
                    BantaLogoComponent,
                    LiveMessageComponent,
                    ChatModule,
                    CommentsModule
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of sdk
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BantaChatComponent, BantaCommentsComponent, BantaCommonModule, BantaComponent, BantaLogoComponent, BantaSdkModule, BantaService, ChatBackendService, ChatMessageComponent, ChatModule, ChatViewComponent, CommentComponent, CommentFieldComponent, CommentViewComponent, CommentsModule, EMOJIS, EmojiModule, EmojiSelectorButtonComponent, EmojiSelectorPanelComponent, LiveChatMessageComponent, LiveCommentComponent, LiveMessageComponent, TimestampComponent, lazyConnection };

//# sourceMappingURL=banta-sdk.js.map